import {Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {NgbActiveModal, NgbModal, NgbModalConfig} from '@ng-bootstrap/ng-bootstrap';
import {ScrollTopService} from '../../../services/scroll-top.service';
import {HttpParams} from '@angular/common/http';
import {CommonService} from '../../../services/common/common.service';
import {Constant, ContentTypeValues, countryCodes, frameRange, ManageTitle, SolrContentTypeValues} from 'src/app/common/constant/constant';
import {ConfirmationComponent} from "../../../components/common/confirmation/confirmation.component";
import {KnowledgeArticleService} from "../../../services/knowledge-article/knowledge-article.service";
import {DashboardService} from "../../../services/dashboard/dashboard.service";
import {Router} from '@angular/router';
import {AuthenticationService} from "../../../services/authentication/authentication.service";
import { RepairOrderService } from 'src/app/services/repair-order/repair-order.service';
import {LandingpageService} from '../../../services/landingpage/landingpage.service';
import {BaseService} from 'src/app/modules/base/base.service';
import {GtsService} from "src/app/services/gts/gts.service";
import {ApiService} from "src/app/services/api/api.service";
import {environment} from 'src/environments/environment';
import {countries} from 'country-data';
import { FileAttachmentComponent } from '../file-attachment/file-attachment.component';
import * as moment from 'moment';
import { ProductMatrixService } from 'src/app/services/product-matrix/product-matrix.service';
import { ManageJobsComponent } from '../manage-jobs/manage-jobs.component';
import { SuccessComponent } from '../success/success.component';

interface ActiveListdrop {
  name: string,
  code: string
}
@Component({
  selector: 'app-manage-list',
  templateUrl: './manage-list.component.html',
  styleUrls: ['./manage-list.component.scss']
})
export class ManageListComponent implements OnInit {
  @ViewChild('focusInput') focusInput: ElementRef;
  @ViewChild('fileAttachment') fileAttachment!: FileAttachmentComponent;
  productActiveListdrop: ActiveListdrop[];

  //selectedCity1: ActiveListdrop;
  //@Input() manageList: any;
  @Input() access: any;
  @Input() accessAction: boolean;
  @Input() apiData: any;
  @Input() apiDataCalproAttachments: any;
  @Input() inputData: any = [];
  @Input() filterPageAccess: any = '';
  @Input() saveButtonColor: any = '';
  @Input() checkboxColor: any = '';
  @Input() checkboxFlag: boolean = true;
  @Input() emissionType: string = "";
  @Input() gtsAccess: boolean = false;
  @Input() height: number;
  @Input() filteredTags: any;
  @Input() filteredLists: any;
  @Input() filteredErrorCodes: any;
  @Input() commonApiValue: any = '';
  @Input() filteredModelsCount: any = '';
  @Input() filteredROPartDesc: any = '';
  @Input() pageType: any = '';
  @Input() filterCall: boolean = false;
  @Input() bodyClass2: string = 'identiscan';
  @Output() selectedItems: EventEmitter<any> = new EventEmitter();
  @Output() thirdPartyReport: EventEmitter<any> = new EventEmitter();
  public pageAccess: string = "";
  public initSelectedObj: any;
  public countryCode: any;
  public countryCodeLists: any;
  public bodyElem;
  public selectedCity1;
  public bodyClass: string = "manage-list";
  public bodyClass1: string = "thread-detail";
  public title: string = "";
  public placeholder: string = "";
  public addTxt: string = "New";
  public itemCode: string = "";
  public itemVal: string = "";
  public manageList = [];
  public listItems = [];
  public selectionList = [];
  public actionItems = [];
  public customerList: any = [];
  public jobItemList: any = [];
  public selectedJobList: any = [];
  public selectedJobListItems: any = [];
  public newTagOptFlag: boolean = false;

  public clearFlag: boolean = false;
  public actionFlag: boolean = false;
  public activeListshow: boolean = true;
  public submitActionFlag: boolean = false;
  public listFlag: any = null;
  public itemAction: string = "";
  public successMsg: string = "";
  public success: boolean = false;
  public loading: boolean = true;
  public lazyLoading: boolean = false;
  public empty: boolean = false;
  public searchNew: boolean = false;
  public listTotal: number;
  public ws = [];
  public vehicle: string = "";

  public techInfoFlag: boolean = false;
  public tagFlag: boolean = false;
  public vinFlag: boolean = false;
  public dynamicOptions: boolean = false;
  public errorCodeFlag: boolean = false;
  public lookUpdataFlag: boolean = false;
  public escloopUpFlag: boolean = false;

  public partFlag: boolean = false;
  public searchVal: string = '';
  public searchValOld: string = '';
  public searchForm: UntypedFormGroup;
  public searchInputFlag: boolean = false;
  public searchTick: boolean = false;
  public searchClose: boolean = false;
  public submitted: boolean = false;
  public listAction: boolean = false;
  public assetPath: string = 'assets/images';
  public separatorPath: string = `${this.assetPath}/matrix/chevron-gray.png`;
  public separatorImg: any;
  public headercheckDisplay: string = "checkbox-hide";
  public headerCheck: string = "unchecked";
  public emptyIndex: any = '-1';
  public countryAllFlag : boolean = false;
  public industryType: any = [];
  public inputMaxLen: any = '';
  public offset: number = 0;
  public DisableText: string = 'Disable';
  public limit: number = 20;
  public scrollInit: number = 1;
  public lastScrollTop: number = 0;
  public scrollTop: number;
  public scrollCallback: boolean = true;
  public itemLength: number = 0;
  public itemTotal: number = 0;
  public closeFlag: boolean = false;
  public selection: string = "multiple";
  public TVSDomain: boolean = false;
  public TVSIBDomain: boolean = false;
  public modalConfig: any = {backdrop: 'static', keyboard: true, centered: true};
  inputForNewValue: boolean;
  domainId: string;
  public isTechSupportInternalStatus: boolean = false;
  public roPartsFlag: boolean = false;
  public roToolsFlag: boolean = false;
  public selectUserAtDealerShip: boolean = false;

  public custActionFlag:boolean = false;
  public actionTitle = '';
  public actionForm = '';
  serviceShopForm: UntypedFormGroup;
  submitClicked = false;
  public serviceShopSubmit:boolean = false;
  public shopExist = true;
  public existError = '';
  public bodyClass3: string = "action-sidebar";
  formProcessing: boolean = false;
  public phoneNumberData:any;
  public icountryName = '';
  public icountryCode = '';
  public idialCode = '';
  public iphoneNumber = '';
  public phonenoInputFlag:boolean = true;
  public phoneNumberValid:boolean = false;
  public invalidNumber:boolean = true;
  public emailDisable: boolean = false;
  public emailValidationError:boolean = false;
  public emailValidationErrorMsg = "";
  public adasReportType: number = 1;
  public fileName: string = '';
  public fileEvent: any;
  uploadedItems: any = [];
  attachmentsData: any;
  adasAttachmentLoader: boolean = false;
  attachmentinit: boolean = false;
  UseExistingFile: boolean = false;
  UseExistingFileData: any;
  isSaving: boolean = false;

    public partsSelectedCols = [];
  public partsSelectedList = [];
  public toolsSelectedCols = [];
  public toolsSelectedList = [];

  workstreamListsOptions = []
  public accessLevel : any = {view: true, create: false, edit: false, delete:false};

  companiesList = [];
  selectedCompanyValue: any;
  compListhoveredIndex: any = null;
  public callProFlag: boolean = false;
  public hoveredInternalStatusIndex: number | null = null;

  // convenience getter for easy access to form fields
  get f() { return this.searchForm.controls; }

  // Scroll Down
  @HostListener('scroll', ['$event'])
  onScroll(event: any) { console.log(1);
    let inHeight = event.target.offsetHeight + event.target.scrollTop;
    let totalHeight = event.target.scrollHeight - (this.offset * 8);
    this.scrollTop = event.target.scrollTop - 80;
    if (this.scrollTop > this.lastScrollTop && this.scrollInit > 0) { console.log(2);
      console.log(inHeight);
      console.log(totalHeight);
      console.log(this.scrollCallback);
      console.log(this.itemTotal);
      console.log(this.itemLength);
      if (inHeight >= totalHeight && this.scrollCallback && this.itemTotal > this.itemLength) {
        console.log('in lazy loading')
        this.lazyLoading = true;
        this.scrollCallback = false;
        let i = -2;
        switch (this.access) {
          case 'GTSList':
            this.getGTSList(i);
            break;
          case 'additionalSystems':
          case 'customerList':
          case 'customerListRO':
            this.getShopList(i);
            break;
          case 'MSOLocationList':
            this.getLocationList(i);
            break;
          case 'roPartNumber':
            this.getROPartList(i);
            break;
          case 'roQtyAvailable':
            this.getROQtyList(i);
            break;
          case 'Tags':
          case 'New Thread Tags':
            this.getTagInfo(i);
            break;
          case 'Error Codes':
          case 'New Thread Error Codes':
            this.errorCodeFlag = true;
            if(!this.filterCall) {
              this.getErrorCodes(i);
            }
            break;
          case 'New Parts':
            this.partFlag = true;
            this.getData(i);
            break;
          case 'techinfo':
            this.techInfoFlag = true;
            this.getData(i);
            break;
          case 'mediaUpload':
          case 'adasCalproReport':  
            this.tagFlag = true;
            this.getData(i);
            break;
          case 'newthread':
          case 'newAdasSystem':
            if (this.title != 'Frame Range') {
              if(this.inputData.field == 'category'){
                this.getCatgInfo(i);
              }
              else if(this.inputData.field == 'zone'){
                this.getZoneInfo(i);
              }
              else if(this.inputData.field == 'keyword'){
                this.getKeywordInfo(i);
              }
              else if(this.inputData.field == 'cba-manufacturer' || this.inputData.field == 'softwareUpdate' || this.inputData.field == 'programNewModule'){
                this.getDiagnosticInfo(i);
              }
              else if(this.inputData.field == 'folders'){
                this.getFolderInfo(i);
              }
              else{
                this.getData(i);
              }
            }
            break;
            case 'InternalStatusAccess':
              this.getData(i);
              break;
          case 'gtsDynamicOptions':
            //
            break;
          case 'jobListRO':
            this.getJobsData(i);
            break;  
        }
      }
    }
    this.lastScrollTop = this.scrollTop;
  }
  constructor(
    public activeModal: NgbActiveModal,
    private scrollTopService: ScrollTopService,
    private commonApi: CommonService,
    private formBuilder: UntypedFormBuilder,
    private modalService: NgbModal,
    private authenticationService: AuthenticationService,
    private LandingpagewidgetsAPI: LandingpageService,
    private productMetrixAPI: ProductMatrixService,
    private repairOrderApi: RepairOrderService,
    private dashboardService: DashboardService,
    private knowledgeArticleService: KnowledgeArticleService,
    private router: Router,
    private config: NgbModalConfig,
    private baseSerivce: BaseService,
    public gtsListingApi: GtsService,
    public apiUrl: ApiService,
  ) {
    config.backdrop = "static";
    config.keyboard = false;
    config.size = "dialog-centered";
  }

  get shf() { return this.serviceShopForm.controls; }

  ngOnInit() {
    let platformId = localStorage.getItem("platformId");
    let domainId = localStorage.getItem("domainId");
    this.domainId = domainId;
    this.TVSDomain = (platformId == '2' && domainId == '52') ? true : false;
    this.TVSIBDomain = (platformId == '2' && domainId == '97') ? true : false;
    this.industryType = this.commonApi.getIndustryType();
    this.bodyElem = document.getElementsByTagName('body')[0];

    let callProFlag:any = localStorage.getItem('callProFlag');
    callProFlag = (callProFlag && callProFlag != undefined) ? callProFlag : 0;
    this.callProFlag = (callProFlag == 1) ? true : false;

    if(this.domainId == '336'){
      this.separatorPath = `${this.assetPath}/matrix/chevron-white.png`;
    }
    else{
      this.separatorPath = `${this.assetPath}/matrix/chevron-gray.png`;
    }
    this.separatorImg = `<img src="${this.separatorPath}" />`;
    this.selectedCity1 = 'Active';
    this.countryCodeLists = countryCodes;
    this.countryCode = this.countryCodeLists[5];
    //console.log(this.countryCodeLists)
    // this.productActiveListdrop = [{label: 'Active', value: 'Active'},{label: 'In Active', value: 'In Active'}]
    this.productActiveListdrop = [
      { name: 'Active', code: 'NY' },
      { name: 'In Active', code: 'RM' }
    ];
    this.bodyElem.classList.add(this.bodyClass);
    let url = this.router.url.split('/');
    if(url[1] == 'documents') {
      if(document.body.classList.contains(this.bodyClass1)) {
        //document.body.classList.remove(this.bodyClass1);
      }
    }
    this.searchForm = this.formBuilder.group({
      searchKey: [this.searchVal, [Validators.required]],
    });
    this.listTotal = this.manageList.length;
    localStorage.removeItem('newItem');
    localStorage.removeItem('searchVal');

    this.searchValOld = "";
    this.selectionList = [];

    this.listAction = this.accessAction;
    this.height = this.height - 120;
    let index = 0;
    setTimeout(() => {
      this.searchInputFlag = true;
    }, 100);
    console.log(this.access, this.inputData, Object.keys(this.inputData).length, this.filteredTags, this.filteredLists)
    this.selection = (Object.keys(this.inputData).length > 0) ? this.inputData.selectionType : this.selection;
    this.pageAccess = (this.inputData.pageAccess) ? this.inputData.pageAccess : '';
    console.log("this.access", this.access);



       this.partsSelectedList = [
       {
        id: 1,
         partBannerImg: "assets/images/repair-order/parts-image-1.png",
         isDefault: 0,
         part: "MCC",
         partdesc: "Marathon Cryopump Controller",
         parttype: "Controller",
         partsystem: "-",
         partinventory: "5",
         partavailable: "3",
       },
       {
         id: 2,
         partBannerImg: "assets/images/repair-order/parts-imag-2.png",
         isDefault: 0,
         part: "FSGL",
         partdesc: "Flexible & Superflex Gas Lines",
         parttype: "Gas Line",
         partsystem: "-",
         partinventory: "10",
         partavailable: "6",
       },
     ]
    

    this.partsSelectedCols = [
      {
        columnName: "image",
        columnpredefind: "1",
        field: 'image',
        header: 'Picture',
        columnpclass: " shi-tb-col-1",
        headerId: "0",
        inputType: "0"
      },
      {
        columnName: "part",
        columnpredefind: "1",
        field: 'part',
        header: 'Part#',
        columnpclass: "shi-tb-col-1",
        headerId: "0",
        inputType: "0"
      },
      {
        columnName: "partdesc",
        columnpredefind: "1",
        field: 'partdesc',
        header: 'Part Description',
        columnpclass: "shi-tb-col-7",
        headerId: "0",
        inputType: "0"
      },
      {
        columnName: "parttype",
        columnpredefind: "1",
        field: 'parttype',
        header: 'Type',
        columnpclass: "shi-tb-col-4",
        headerId: "0",
        inputType: "0"
      },
      {
        columnName: "partsystem",
        columnpredefind: "1",
        field: 'partsystem',
        header: 'System',
        columnpclass: "shi-tb-col-4",
        headerId: "0",
        inputType: "0"
      },
      {
        columnName: "partinventory",
        columnpredefind: "1",
        field: 'partinventory',
        header: 'Inventory',
        columnpclass: "shi-tb-col-4",
        headerId: "0",
        inputType: "0"
      },
      {
        columnName: "partavailable",
        columnpredefind: "1",
        field: 'partavailable',
        header: 'Available',
        columnpclass: "shi-tb-col-4",
        headerId: "0",
        inputType: "0"
      },
    ];



    this.toolsSelectedList = [
       {
         id: 1,
         toolBannerImg: "assets/images/repair-order/tools-imag-1.png",
         isDefault: 0,
         toolId: "4354679",
         assetId: "34545658",
         toolname: "Installation Wrench Kits",
         tooldesc: "Tools for installation, maintenance or service on SHI systems",
         sr: "H14300328",
       },
       {
         id: 2,
         toolBannerImg: "assets/images/repair-order/tools-imag-2.png",
         isDefault: 0,
         toolId: "4354678",
         assetId: "34545657",
         toolname: "Gas Charging Valve",
         tooldesc: "Gas Charging Valve",
         sr: "M15645728",
       },
     ]
    

    this.toolsSelectedCols = [
      {
        columnName: "image",
        columnpredefind: "1",
        field: 'image',
        header: 'Picture',
        columnpclass: " shi-tb-col-1",
        headerId: "0",
        inputType: "0"
      },
      {
        columnName: "toolId",
        columnpredefind: "1",
        field: 'toolId',
        header: 'Tool ID',
        columnpclass: "shi-tb-col-1",
        headerId: "0",
        inputType: "0"
      },
      {
        columnName: "assetId",
        columnpredefind: "1",
        field: 'assetId',
        header: 'Asset ID',
        columnpclass: "shi-tb-col-1",
        headerId: "0",
        inputType: "0"
      },
      {
        columnName: "toolname",
        columnpredefind: "1",
        field: 'toolname',
        header: 'Tool Name',
        columnpclass: "shi-tb-col-6",
        headerId: "0",
        inputType: "0"
      },
      {
        columnName: "tooldesc",
        columnpredefind: "1",
        field: 'tooldesc',
        header: 'Tool Description',
        columnpclass: "shi-tb-col-7",
        headerId: "0",
        inputType: "0"
      },
      {
        columnName: "sr",
        columnpredefind: "1",
        field: 'sr',
        header: 'Sr#',
        columnpclass: "shi-tb-col-2",
        headerId: "0",
        inputType: "0"
      },
    ];

  
    
    switch (this.access) {
      case 'customerList':
      case 'customerListRO':
        this.tagFlag = true;
        this.title = this.inputData.title;
        if(this.access == 'customerListRO') {
          this.filteredTags = this.inputData.filteredItems;
          this.filteredLists = this.inputData.filteredLists;
        }
        this.loadScript();
        this.getShopList(index);
        break;
       case 'roPartNumber':
        this.tagFlag = true;
        this.title = this.inputData.title;
        this.filteredTags = this.inputData.filteredItems;
        this.filteredLists = this.inputData.filteredLists;
        this.getROPartList(index);
        break;
       case 'roQtyAvailable':
        this.tagFlag = true;
        this.title = this.inputData.title;
        this.filteredTags = this.inputData.filteredItems;
        this.filteredLists = this.inputData.filteredLists;
        this.getROQtyList(index);
        break;
      case 'jobListRO':
        this.tagFlag = true;
        this.title = this.inputData.title;
        this.filteredTags = this.inputData.filteredItems;
        this.filteredLists = this.inputData.filteredLists;
        this.checkAccessLevel();
        this.getWorkstreamLists();
        if(this.callProFlag) {
          this.getCompaniesListData(index)
        } else {
          this.getJobsData(index);
        }
        break;
      case 'GTSList':
        this.tagFlag = true;
        this.title = this.inputData.title;
        this.filteredTags = this.inputData.filteredItems;
        this.filteredLists = this.inputData.filteredLists;
        console.log(this.filteredTags)
        console.log(this.filteredLists)
        this.getGTSList(index);
        break;
      case 'Tags':
      case 'New Thread Tags':
        this.tagFlag = true;
        this.title = (this.access == 'Tags' || this.access == 'Countries') ? this.access : this.inputData.title;
        if (this.access == 'New Thread Tags') {
          this.filteredTags = this.inputData.filteredItems;
          this.filteredLists = this.inputData.filteredLists;
        } else {
          this.filteredTags = (this.filteredTags && this.filteredTags.length == 0) ? [] : this.filteredTags;
        }
        console.log(this.filteredTags);
        this.getTagInfo(index);
        break;
      case 'Error Codes':
      case 'New Thread Error Codes':
        console.log(this.inputData);
        this.title = (this.access == 'Error Codes') ? this.access : this.inputData.title;
        this.errorCodeFlag = true;
        if (this.access == 'New Thread Error Codes') {
          this.filteredErrorCodes = this.inputData.filteredItems;
          this.filteredLists = this.inputData.filteredLists;
        } else {
          this.filteredErrorCodes = (this.filteredErrorCodes.length == 0) ? [] : this.filteredErrorCodes;
          this.filteredLists = this.filteredErrorCodes;
        }
        if(!this.filterCall) {
          this.getErrorCodes(index);
        } else {
          this.manageList = this.inputData.errorCodes;
          this.itemTotal = this.manageList.length;
          this.itemLength = this.itemTotal;
          this.empty = (this.itemTotal == 0) ? true : this.empty;
          if(this.itemTotal > 0)
            this.initList('init', this.manageList);
        }
        break;
      //for Product matrix
      case 'LookupDataPM':
        case 'Countries':
        this.title = this.apiData.lookupHeaderName;
        this.lookUpdataFlag = true;
        if(this.access=='Countries')
        {
          this.lookUpdataFlag = false;
          this.tagFlag = true;
          this.title = this.access;
        }

        this.getLookUpInfo(index);
        break;
      case 'newthread':
      case 'newAdasSystem':
      case 'additionalSystems':
      case 'adasCalproReport':  
        this.title = this.inputData.title;
        this.tagFlag = (this.title == 'Recent VINs') ? false : true;
        this.vinFlag = (this.title == 'Recent VINs') ? true : false;
        this.filteredTags = (this.inputData.filteredItems == '') ? [] : this.inputData.filteredItems;
        this.filteredLists = (this.inputData.filteredLists == '') ? [] : this.inputData.filteredLists;
        console.log(this.filteredModelsCount);
        this.filteredModelsCount = (this.inputData.filteredModelsCount == '') ? [] : this.inputData.filteredModelsCount;
        this.filteredROPartDesc = (this.inputData.filteredROPartDesc == '') ? [] : this.inputData.filteredROPartDesc;        
        this.inputMaxLen = (this.inputData.field == 'complaintCategory') ? '100' : this.inputMaxLen;
        if (this.title != 'Frame Range') {
          if(this.inputData.field == 'zone'){
            this.getZoneInfo(index);
          }
          else if(this.inputData.field == 'category'){
            this.getCatgInfo(index);
          }
          else if(this.inputData.field == 'keyword'){
            this.getKeywordInfo(index);
          }
          else if(this.inputData.field == 'cba-manufacturer' || this.inputData.field == 'softwareUpdate' || this.inputData.field == 'programNewModule'){
            this.getDiagnosticInfo(index);
          }
          else if(this.inputData.field == 'folders'){
            this.getFolderInfo(index);
          }
          else{
            this.getData(index);
          }
        } else {
          this.manageList = frameRange;
          this.initList('init', this.manageList);
        }
        break;
      case 'gtsDynamicOptions':
        this.title = this.inputData.title;
        this.dynamicOptions = true;
        this.getData(index);
        break;
      case 'Error Codes':
      case 'New Parts':
        console.log(this.inputData)
        this.title = this.inputData.title;
        this.partFlag = true;
        this.filteredErrorCodes = this.inputData.filteredItems;
        this.filteredLists = this.inputData.filteredLists;
        this.getData(index);
        break;
      case 'techinfo':
        this.title = this.inputData.title;
        this.techInfoFlag = true;
        this.filteredTags = this.inputData.filteredItems;
        this.filteredLists = this.inputData.filteredLists;
        this.getData(index);
        break;
      case 'identiscan':
        this.tagFlag = true;
        this.title = this.inputData.title;
        this.placeholder = this.inputData.placeholder;
        this.manageList = this.inputData.list ;
        this.listItems   = this.inputData.list ;
        this.filteredTags = this.inputData.filteredItems;
        this.filteredLists = this.inputData.filteredLists;
        this.loading = false;
        this.bodyElem.classList.add(this.bodyClass2);
        console.log(this.filteredLists)
        for (let m in this.listItems) {
          let i: any = m;
          this.listItems[m]['action'] = "";
          this.listItems[m]['displayFlag'] = true;
          this.listItems[m]['checkFlag'] = false;
          this.listItems[m]['itemExists'] = false;
          this.listItems[m]['activeMore'] = false;
          this.listItems[m]['actionFlag'] = false;
        }
        let defaultIdentiScanValue = this.filteredLists[0].split(",");
        defaultIdentiScanValue.forEach((outer,index)=>{
          this.listItems.forEach((inner,index)=>{
            if( inner.name == outer) {
              this.listItems[index].checkFlag = true;
              this.selectionList.push({
                id:inner.id,
                name:inner.name
              })
            }
          })
        })


        // this.listItems.forEach((value,index)=>{
        //   if( value.name == defaultIdentiScanValue) {
        //     this.listItems[index].checkFlag = true;
        //     this.selectionList.push({
        //       id:value.id,
        //       name:value.name
        //     })
        //   }
        // })
        // this.getData(index);
        break;
      case 'PartType':
      case 'PartAssembly':
      case 'PartSystem':
        this.tagFlag = true;
        this.title = this.inputData.title;
        this.getData(index);
        break;
      case 'mediaUpload':
        this.tagFlag = true;
        this.title = this.inputData.title;
        this.filteredTags = this.inputData.filteredItems;
        this.filteredLists = this.inputData.filteredLists;
        this.getData(index);
        break;
      case 'InternalStatusAccess':
        this.isTechSupportInternalStatus = true;
        this.title = this.inputData.title;
        this.getData(index);
        break;
      case 'roParts':
        this.roPartsFlag = true;
        this.title = this.inputData.title;
        break;
      case 'roTools':
        this.roToolsFlag = true;
        this.title = this.inputData.title;
        break;
      case 'MSOLocationList':
        this.tagFlag = true;
        this.title = this.inputData.title;
        this.getLocationList(index);
        break;
    }

    // used remove selection(button save enable)
    let initSelectedObj = {
      length : this.filteredTags && this.filteredTags.length>0 ?  this.filteredTags.length : 0
    }
    this.initSelectedObj = initSelectedObj;

    setTimeout(() => {
      //this.initList('init', this.manageList);
    }, 500);

    
  }

  public loadScript() {
    const node = document.createElement('script');
    node.src = 'https://maps.googleapis.com/maps/api/js?key=' + environment.googleApiKey;
    node.type = 'text/javascript';
    console.log(node);
    document.getElementsByTagName('head')[0].appendChild(node);
  }

  getGTSList(index){
    this.apiData["offset"] = this.offset;
    this.apiData["limit"] = this.limit;

    const apiFormData = new FormData();
    apiFormData.append("apiKey", this.apiData["apiKey"]);
    apiFormData.append("domainId", this.apiData["domainId"]);
    apiFormData.append("countryId", this.apiData["countryId"]);
    apiFormData.append("userId", this.apiData["userId"]);
    apiFormData.append("searchKey", this.searchVal);
    apiFormData.append("limit", this.apiData["limit"]);
    apiFormData.append("offset", this.apiData["offset"]);

    this.loading = true;
    this.scrollTop = 0;
    this.lastScrollTop = this.scrollTop;
    this.gtsListingApi.getGTSLists(apiFormData).subscribe((response) => {
      console.log(response)
      let resultData = response;
        this.manageList = (index >= -1) ? [] : this.manageList;
        let list = resultData.procedure;
        for (let res in list) {
          if(list[res].status != 'Draft'){
            let name = "ID# "+list[res].procedureId+", "+list[res].name;
            this.manageList.push({
              id: list[res].procedureId,
              name: name,
            });
          }
        }
        let initText = (index == 0) ? 'init' : 'get';

        //console.log(this.selectionList);
        if (index <= 0) {
          let itemListLen = this.manageList.length;
          this.empty = (itemListLen < 1) ? true : false;
          if (this.empty) {
            this.successMsg = response.message;
          } else {
            this.scrollCallback = true;
            this.scrollInit = 1;
            this.itemTotal = resultData.total;
            this.itemLength = itemListLen;
            this.offset += this.limit;
          }
        }

        setTimeout(() => {
          this.initList(initText, this.manageList);
        }, 50);
    });
  }

   getROPartList(index) {

    this.loading = true;
    this.scrollTop = 0;
    this.lastScrollTop = this.scrollTop;

    let FiltersArr={};
    let userWorkstreams=localStorage.getItem('userWorkstreams');
    FiltersArr["domainId"] = this.apiData.domainId;
    if(this.inputData.workstreamId && this.inputData.workstreamId.length>0){
      FiltersArr["workstreamsIds"] = (this.inputData.workstreamId);       
    }
    else{
      if(userWorkstreams) {
        FiltersArr["workstreamsIds"] = JSON.parse(userWorkstreams);
      }
    }
    FiltersArr["hiddenFlagInt"] = 0;
    var objData = {};
    let queryVal =  this.searchVal && this.searchVal!='' ? this.searchVal : '';
    objData["start"] = this.offset
    objData["rows"] = this.limit;
    objData["query"] = queryVal;
    let uuIdData=localStorage.getItem('uuIdData');
    if(uuIdData)
    {
      objData["uuid"]=uuIdData;
      objData["userId"]=this.apiData.userId;
      objData["platform"]=3;

    }
    objData["type"] = SolrContentTypeValues.Parts;
    objData["listing"] = queryVal == '' ? "1" : "0";
    objData["filters"] = FiltersArr;

    this.LandingpagewidgetsAPI.getSolrDataDetail(
      objData
    ).subscribe((response) => {
      console.log(response)
      let resultData = response;
      this.manageList = (index >= -1) ? [] : this.manageList;
      let list = response.partsData;
        for (let res in list) {
          this.manageList.push({
            ...(list[res] || {}),
            id: list[res].partName,
            name: list[res].partNumber,
            desc: list[res].partDesc,
          });
        }
        let initText = (index == 0) ? 'init' : 'get';

        //console.log(this.selectionList);
        if (index <= 0) {
          let itemListLen = this.manageList.length;
          this.empty = (itemListLen < 1) ? true : false;
          if (this.empty) {
            this.successMsg = response.result;
          } else {
            this.scrollCallback = true;
            this.scrollInit = 1;
            this.itemTotal = resultData.total;
            this.itemLength = itemListLen;
            this.offset += this.limit;
          }
        }

        setTimeout(() => {
          this.initList(initText, this.manageList);
        }, 50);

        if (this.searchNew) {
          this.manageItem('new', 0);
        }
    });
  }
  getROQtyList(index) {

    this.loading = true;
    this.scrollTop = 0;
    this.lastScrollTop = this.scrollTop;

    let FiltersArr={};
    let userWorkstreams=localStorage.getItem('userWorkstreams');
    FiltersArr["domainId"] = this.apiData.domainId;
    if(this.inputData.workstreamId && this.inputData.workstreamId.length>0){
      FiltersArr["workstreamsIds"] = (this.inputData.workstreamId);       
    }
    else{
      if(userWorkstreams) {
        FiltersArr["workstreamsIds"] = JSON.parse(userWorkstreams);
      }
    }
    FiltersArr["hiddenFlagInt"] = 0;
    var apiData = new FormData();
    apiData.append("apiKey", this.apiData.apiKey);
    apiData.append("domainId", this.apiData.domainId);
    apiData.append("userId", this.apiData.userId);
    apiData.append("offset", String(this.offset));
    apiData.append("limit", String(this.limit));
    apiData.append("listing", '1');
    apiData.append("tab", '1');
    apiData.append("partNumber", this.inputData.partNumber);

    
    let queryVal =  this.searchVal && this.searchVal!='' ? this.searchVal : '';
    if(queryVal){
      apiData.append("queryVal", queryVal);
    }


    this.LandingpagewidgetsAPI.getInventoryPartsByWarehouse(apiData).subscribe((response: any) => {
      console.log("getInventoryPartsByWarehouse", response)
      let resultData = response?.items?.[0] || {};
      this.manageList = (index >= -1) ? [] : this.manageList;
      let list = resultData?.wareHouseArr || [];
      for (let res in list) {
        this.manageList.push({
          id: list[res].name,
          name: list[res].name,
          count: list[res].count,
        });
      }
      let initText = (index == 0) ? 'init' : 'get';

      //console.log(this.selectionList);
        if (index <= 0) {
          let itemListLen = this.manageList.length;
          this.empty = (itemListLen < 1) ? true : false;
          if (this.empty) {
            this.successMsg = response.result;
          } else {
            this.scrollCallback = true;
            this.scrollInit = 1;
            this.itemTotal = resultData.total;
            this.itemLength = itemListLen;
            this.offset += this.limit;
          }
        }

        setTimeout(() => {
          this.initList(initText, this.manageList);
        }, 50);

        if (this.searchNew) {
          this.manageItem('new', 0);
        }
    });
  }
  filterRoQtyList() {    
    console.log("filterRoQtyList", this.listItems);
    
    this.scrollTop = 0;
    this.lastScrollTop = this.scrollTop;

    this.listItems = this.listItems.filter((item) => {
      return item?.name?.toLowerCase()?.includes(this.searchVal?.toLowerCase()) || item?.count?.toString()?.toLowerCase().includes(this.searchVal?.toLowerCase());
    }) || []

    let itemListLen = this.manageList.length;
    this.empty = (itemListLen < 1) ? true : false;
    if (this.empty) {
      this.successMsg = "No Records Found";
    } else {
      this.scrollCallback = true;
      this.scrollInit = 1;
      this.itemTotal = itemListLen;
      this.itemLength = itemListLen;
    }
  }
  getShopList(index) {
    let apiInfo = this.inputData.apiData;
    apiInfo['offset'] = this.offset;
    apiInfo['limit'] = this.limit;
    console.log(this.searchVal);
    apiInfo['keyword'] = this.searchVal;
    if(this.access == 'customerList') {
      apiInfo['shopArr'] = JSON.stringify([]);
    }
    this.loading = true;
    this.scrollTop = 0;
    this.lastScrollTop = this.scrollTop;
    this.LandingpagewidgetsAPI.shopListAPI(apiInfo).subscribe((response) => {
      console.log(response)
      let resultData = response.data;
      this.manageList = (index >= -1) ? [] : this.manageList;
      this.customerList = (index >= -1) ? [] : this.customerList;
      let list = resultData.items;
      for (let res in list) {
        let name = list[res].name+" (ID# "+list[res].id+")";
        //let addressLine1 = list[res].addressLine1 != '' ? ", "+list[res].addressLine1 : '' ;
        let addressLine1 = list[res].addressLine1 != '' ? ", "+list[res].addressLine1 : '' ;
        let addressLine2 = list[res].addressLine2 != '' ? ", "+list[res].addressLine2 : '' ;
        let city = list[res].city != '' ? ", "+list[res].city  : '' ;
        let state = list[res].state != '' ? ", "+list[res].state  : '' ;
        let zip = list[res].zip != '' ? ", "+list[res].zip  : '' ;
        let email = list[res].email != '' ? ", "+list[res].email  : '' ;
        let dialCode = list[res].dialCode != '' ? list[res].dialCode+" "  : '' ;
        let phone = list[res].phone != '' ? ", "+dialCode+''+list[res].phone : '' ;

        let addressLine1V2 = list[res].addressLine1 != '' ? list[res].addressLine1+", " : '' ;
        let addressLine2V2 = list[res].addressLine2 != '' ? list[res].addressLine2+", " : '' ;
        let cityV2 = list[res].city != '' ? list[res].city+", "  : '' ;
        let stateV2 = list[res].state != '' ? list[res].state+" "  : '' ;
        let zipV2 = list[res].zip != '' ? list[res].zip+", "  : '' ;
        let emailV2 = list[res].email != '' ? list[res].email+", "  : '' ;
        let dialCodeV2 = list[res].dialCode != '' ? list[res].dialCode+" "  : '' ;
        let phoneV2 = list[res].phone != '' ? dialCodeV2+''+list[res].phone : '' ;
        let phoneV1 = list[res].phone != '' ? list[res].phone : '' ;
        let lat = (list[res].lat && list[res].lat != '' && list[res].lat != undefined) ? list[res].lat : ''; 
        let lng = (list[res].lng && list[res].lng != '' && list[res].lng != undefined) ? list[res].lng : '';
        let timeZone = list[res].timeZone != '' ? list[res].timeZone : '';
        console.log(list[res].isMaskCustomer, emailV2)
        emailV2 = (list[res].isMaskCustomer == 1) ? '' : emailV2; 
        email = (list[res].isMaskCustomer == 1) ? '' : email; 
        let isMaskCustomer = list[res].isMaskCustomer;

        let showval = name+addressLine1+addressLine2+city+state+zip+email+phone;
        let showvalV2 = "<label class='lb-head-text'>"+name+"</label><label class='lb-cont-text'>"+addressLine1V2+addressLine2V2+cityV2+stateV2+zipV2+emailV2+phoneV2+"</lable>"; ;
        this.manageList.push({
          id: list[res].id,
          name: showval,
          showName: showvalV2,
          lat,
          lng,
          timeZone,
          nameOnly: list[res].name,
          marketId: list[res].marketId,
          marketName: list[res].marketName,
          isMaskCustomer,
          addressOnly: addressLine1V2+addressLine2V2+cityV2+stateV2+zipV2+emailV2+phoneV2
        });
        this.customerList.push({
          id: list[res].id,
          name: list[res].name,
          marketId: list[res].marketId,
          marketName: list[res].marketName,
          addressLine1: list[res].addressLine1,
          addressLine2: list[res].addressLine2,
          city: list[res].city,
          state: list[res].state,
          zip: list[res].zip,
          email: list[res].email,
          phone: phoneV2,
          phoneNumber: phoneV1,
          businessCount: list[res].businessCount,
          discount: list[res].discount,
          isMaskCustomer,
          lat,
          lng,
          timeZone,
          showval
        });
      }
      let initText = (index == 0) ? 'init' : 'get';

      //console.log(this.selectionList);
      if (index <= 0) {
        let itemListLen = this.manageList.length;
        this.empty = (itemListLen < 1) ? true : false;
        if (this.empty) {
          this.successMsg = response.message;
        } else {
          this.scrollCallback = true;
          this.scrollInit = 1;
          this.itemTotal = resultData.total;
          this.itemLength = itemListLen;
          this.offset += this.limit;
        }
      }

      setTimeout(() => {
        this.initList(initText, this.manageList);
      }, 50);
    });
  }

  getLocationList(index) {
    let apiInfo = this.inputData.apiData;
    apiInfo['offset'] = this.offset;
    apiInfo['limit'] = this.limit;
    console.log(this.searchVal);
    apiInfo['keyword'] = this.searchVal;
    if(this.access == 'MSOLocationList') {
      apiInfo['shopArr'] = JSON.stringify([]);
    }
    this.loading = true;
    this.scrollTop = 0;
    this.lastScrollTop = this.scrollTop;
    this.LandingpagewidgetsAPI.shopMsoListAPI(apiInfo).subscribe((response) => {
      console.log("shopMsoListAPI: ", response)
      let resultData = response.data;
      this.manageList = (index >= -1) ? [] : this.manageList;
      this.customerList = (index >= -1) ? [] : this.customerList;
      let list = resultData.items;
      for (let res in list) {
        let name = list[res].name+" (ID# "+list[res].id+")";
        //let addressLine1 = list[res].addressLine1 != '' ? ", "+list[res].addressLine1 : '' ;
        let addressLine1 = list[res].addressLine1 != '' ? ", "+list[res].addressLine1 : '' ;
        let addressLine2 = list[res].addressLine2 != '' ? ", "+list[res].addressLine2 : '' ;
        let city = list[res].city != '' ? ", "+list[res].city  : '' ;
        let state = list[res].state != '' ? ", "+list[res].state  : '' ;
        let zip = list[res].zip != '' ? ", "+list[res].zip  : '' ;
        let email = list[res].email != '' ? ", "+list[res].email  : '' ;
        let dialCode = list[res].dialCode != '' ? list[res].dialCode+" "  : '' ;
        let phone = list[res].phone != '' ? ", "+dialCode+''+list[res].phone : '' ;

        let addressLine1V2 = list[res].addressLine1 != '' ? list[res].addressLine1+", " : '' ;
        let addressLine2V2 = list[res].addressLine2 != '' ? list[res].addressLine2+", " : '' ;
        let cityV2 = list[res].city != '' ? list[res].city+", "  : '' ;
        let stateV2 = list[res].state != '' ? list[res].state+" "  : '' ;
        let zipV2 = list[res].zip != '' ? list[res].zip+", "  : '' ;
        let emailV2 = list[res].email != '' ? list[res].email+", "  : '' ;
        let dialCodeV2 = list[res].dialCode != '' ? list[res].dialCode+" "  : '' ;
        let phoneV2 = list[res].phone != '' ? dialCodeV2+''+list[res].phone : '' ;
        let phoneV1 = list[res].phone != '' ? list[res].phone : '' ;
        let lat = (list[res].lat && list[res].lat != '' && list[res].lat != undefined) ? list[res].lat : ''; 
        let lng = (list[res].lng && list[res].lng != '' && list[res].lng != undefined) ? list[res].lng : '';
        let timeZone = list[res].timeZone != '' ? list[res].timeZone : '';
        console.log(list[res].isMaskCustomer, emailV2)
        emailV2 = (list[res].isMaskCustomer == 1) ? '' : emailV2; 
        email = (list[res].isMaskCustomer == 1) ? '' : email; 
        let isMaskCustomer = list[res].isMaskCustomer;

        let showval = name+addressLine1+addressLine2+city+state+zip+email+phone;
        let showvalV2 = "<label class='lb-head-text'>"+name+"</label><label class='lb-cont-text'>"+addressLine1V2+addressLine2V2+cityV2+stateV2+zipV2+emailV2+phoneV2+"</lable>"; ;
        this.manageList.push({
          id: list[res].id,
          name: showval,
          showName: showvalV2,
          lat,
          lng,
          timeZone,
          nameOnly: list[res].name,
          marketId: list[res].marketId,
          marketName: list[res].marketName,
          isMaskCustomer,
          addressOnly: addressLine1V2+addressLine2V2+cityV2+stateV2+zipV2+emailV2+phoneV2
        });
        this.customerList.push({
          id: list[res].id,
          name: list[res].name,
          marketId: list[res].marketId,
          marketName: list[res].marketName,
          addressLine1: list[res].addressLine1,
          addressLine2: list[res].addressLine2,
          city: list[res].city,
          state: list[res].state,
          zip: list[res].zip,
          email: list[res].email,
          phone: phoneV2,
          phoneNumber: phoneV1,
          businessCount: list[res].businessCount,
          discount: list[res].discount,
          isMaskCustomer,
          lat,
          lng,
          timeZone,
          showval
        });
      }
      let initText = (index == 0) ? 'init' : 'get';

      console.log("shopMsoListAPI: ", {manageList: this.manageList});
      
      //console.log(this.selectionList);
      if (index <= 0) {
        let itemListLen = this.manageList.length;
        this.empty = (itemListLen < 1) ? true : false;
        if (this.empty) {
          this.successMsg = response.message;
        } else {
          this.scrollCallback = true;
          this.scrollInit = 1;
          this.itemTotal = resultData.total;
          this.itemLength = itemListLen;
          this.offset += this.limit;
        }
      }

      setTimeout(() => {
        this.initList(initText, this.manageList);
      }, 50);
    });
  }

  getWorkstreamLists() {
    let type:any = 1;
    const apiFormData = new FormData();
    apiFormData.append('apiKey', this.apiData['apiKey']);
    apiFormData.append('domainId', this.apiData['domainId']);
    apiFormData.append('countryId', this.apiData['countryId']);
    apiFormData.append('userId', this.apiData['userId']);
    apiFormData.append('type', type);
    this.workstreamListsOptions = [];
    this.productMetrixAPI.getWorkstreamLists(apiFormData).subscribe((response) => {
      let resultData = response.workstreamList;
      this.workstreamListsOptions = resultData;   
    });
  }

  checkAccessLevel(){
    console.log("checkAccessLevel");
    
    let viewAccess = true, createAccess = false, editAccess = true,  deleteAccess = true;

    setTimeout(() => {
      let accessLevels = this.authenticationService.checkAccessItems;
      if(accessLevels && accessLevels.length > 0) {
        let reportAccess = accessLevels[0].pageAccess;
        reportAccess.forEach(item => {
          let accessId = parseInt(item.id);
          let roles = item.roles;
          let roleIndex = roles.findIndex(option => option.id == this.apiData?.roleId);
          if(roleIndex < 0) {
            return false;
          }
          let roleAccess = (roles[roleIndex].access && roles[roleIndex].access != undefined) ? roles[roleIndex].access : 0;
          console.log(accessId, roleAccess)
          switch (accessId) {
            case 1:
              // viewAccess = (roleAccess == 1) ? true : false;
              break;
            case 8:
              createAccess = (roleAccess == 1) ? true : false;
              break;
            case 3:
              // editAccess = (roleAccess == 1) ? true : false;
              break;
            case 4:
              // deleteAccess = (roleAccess == 1) ? true : false;
              break;
          }
        });

      }        
      let defaultAccessLevel : any = {view: viewAccess, create: createAccess, edit: editAccess, delete:deleteAccess};   
      this.accessLevel = defaultAccessLevel.create != undefined ?  defaultAccessLevel : this.accessLevel;      
    }, 1000)
  }
  // getLocationList(index) {
  //   // let apiInfo = this.inputData.apiData;
  //   // apiInfo['offset'] = this.offset;
  //   // apiInfo['limit'] = this.limit;
  //   // console.log(this.searchVal);
  //   // apiInfo['keyword'] = this.searchVal;

  //   const apiData = new FormData()
  //   apiData.append('apiKey', this.apiData.apiKey)
  //   apiData.append('domainId', this.apiData.domainId)
  //   apiData.append('msoNameId', this.apiData.msoNameId)
  //   apiData.append('offset', String(this.offset || 0))
  //   apiData.append('limit', String(this.limit || 0))

  //   this.loading = true;
  //   this.scrollTop = 0;
  //   this.lastScrollTop = this.scrollTop;

  //   this.productMetrixAPI.getMsoLocations(apiData).subscribe((response) => {
  //     console.log("getMsoLocations: ", response)
  //     let resultData = response;
  //     this.manageList = (index >= -1) ? [] : this.manageList;
  //     this.customerList = (index >= -1) ? [] : this.customerList;
  //     let list = resultData.items;


  //     for (let res in list) {
  //       let name = list[res].name;
  //       //let addressLine1 = list[res].addressLine1 != '' ? ", "+list[res].addressLine1 : '' ;
  //       let addressLine1 = list[res].addressLine1 != '' ? ", "+list[res].addressLine1 : '' ;
  //       let addressLine2 = list[res].addressLine2 != '' ? ", "+list[res].addressLine2 : '' ;
  //       let city = list[res].city != '' ? ", "+list[res].city  : '' ;
  //       let state = list[res].state != '' ? ", "+list[res].state  : '' ;
  //       let zip = list[res].zip != '' ? ", "+list[res].zip  : '' ;
  //       let email = list[res].email != '' ? ", "+list[res].email  : '' ;
  //       let dialCode = list[res].dialCode != '' ? list[res].dialCode+" "  : '' ;
  //       let phone = list[res].phone != '' ? ", "+dialCode+''+list[res].phone : '' ;

  //       let addressLine1V2 = list[res].addressLine1 != '' ? list[res].addressLine1+", " : '' ;
  //       let addressLine2V2 = list[res].addressLine2 != '' ? list[res].addressLine2+", " : '' ;
  //       let cityV2 = list[res].city != '' ? list[res].city+", "  : '' ;
  //       let stateV2 = list[res].state != '' ? list[res].state+" "  : '' ;
  //       let zipV2 = list[res].zip != '' ? list[res].zip+", "  : '' ;
  //       let emailV2 = list[res].email != '' ? list[res].email+", "  : '' ;
  //       let dialCodeV2 = list[res].dialCode != '' ? list[res].dialCode+" "  : '' ;
  //       let phoneV2 = list[res].phone != '' ? dialCodeV2+''+list[res].phone : '' ;
  //       let phoneV1 = list[res].phone != '' ? list[res].phone : '' ;
  //       let lat = (list[res].lat && list[res].lat != '' && list[res].lat != undefined) ? list[res].lat : ''; 
  //       let lng = (list[res].lng && list[res].lng != '' && list[res].lng != undefined) ? list[res].lng : '';
  //       let timeZone = list[res].timeZone != '' ? list[res].timeZone : '';

  //       // let showval = name+addressLine1+addressLine2+city+state+zip+email+phone;
  //       let mainText = name;
  //       let subText = addressLine1V2+addressLine2V2+zipV2+emailV2+phoneV2;
  //       // let showvalV2 = `
  //       //   <label class='lb-head-text'> ${name}</label>
  //       //   <label class='lb-cont-text'>${addressLine1V2+addressLine2V2+cityV2+stateV2+zipV2+emailV2+phoneV2}</lable>`;
        
  //       let showval = mainText+subText;
  //       let showvalV2 = "<label class='lb-head-text'>"+mainText+"</label><label class='lb-cont-text'>"+subText+"</lable>"; ;
  //       this.manageList.push({
  //         ...(list[res]),
  //         id: list[res].id,
  //         name: mainText,
  //         showName: showvalV2,
  //         lat,
  //         lng,
  //         timeZone,
  //         nameOnly: list[res].name,
  //         addressOnly: addressLine1V2+addressLine2V2+cityV2+stateV2+zipV2+emailV2+phoneV2
  //       });
  //       this.customerList.push({
  //         id: list[res].id,
  //         name: list[res].name,
  //         addressLine1: list[res].addressLine1,
  //         addressLine2: list[res].addressLine2,
  //         city: list[res].city,
  //         state: list[res].state,
  //         zip: list[res].zip,
  //         email: list[res].email,
  //         phone: phoneV2,
  //         phoneNumber: phoneV1,
  //         lat,
  //         lng, 
  //         timeZone,
  //         showval
  //       });
  //   }
  //    let initText = (index == 0) ? 'init' : 'get';

  //     //console.log(this.selectionList);
  //     if (index <= 0) {
  //       let itemListLen = this.manageList.length;
  //       this.empty = (itemListLen < 1) ? true : false;
  //       if (this.empty) {
  //         this.successMsg = response.message;
  //       } else {
  //         this.scrollCallback = true;
  //         this.scrollInit = 1;
  //         this.itemTotal = resultData.total;
  //         this.itemLength = itemListLen;
  //         this.offset += this.limit;
  //       }
  //     }

  //     setTimeout(() => {
  //       this.initList(initText, this.manageList);
  //     }, 50);

  //   });
  // }

  // Get Catg Info
  getCatgInfo(index) {
    console.log(index)
    if (index == -3) {
      this.initList('init', this.manageList);
    } else {
      this.loading = true;
      this.scrollTop = 0;
      this.lastScrollTop = this.scrollTop;
      /*let apiData = {
        apiKey: this.apiData.apiKey,
        domainId: this.apiData.domainId,
        countryId: this.apiData.countryId,
        userId: this.apiData.userId,
        searchKey: this.searchVal,
        offset: this.offset,
        limit: this.limit
      }*/

      this.apiData["offset"] = this.offset;
      this.apiData["limit"] = this.limit;

      let wsList = this.apiData["workstreamsList"]
      if(Array.isArray(wsList)){
        wsList = JSON.stringify(wsList)
      }

      const apiFormData = new FormData();
      apiFormData.append("apiKey", this.apiData["apiKey"]);
      apiFormData.append("domainId", this.apiData["domainId"]);
      apiFormData.append("countryId", this.apiData["countryId"]);
      apiFormData.append("userId", this.apiData["userId"]);
      apiFormData.append("searchKey", this.searchVal);
      apiFormData.append("limit", this.apiData["limit"]);
      apiFormData.append("offset", this.apiData["offset"]);
      apiFormData.append("workstreamsList", wsList);
      apiFormData.append("isNew", "1");

      let callAbleUrl = this.knowledgeArticleService.getAllKnowledgeArticleCategory(apiFormData);
      if (this.pageType == 'parts') {
        callAbleUrl = this.knowledgeArticleService.getAllPartCategory(apiFormData);
      }

      callAbleUrl.subscribe((response) => {
        let resultData = response;
        this.manageList = (index >= -1) ? [] : this.manageList;
        let list = response.category;
        for (let res in list) {
          this.manageList.push({
            id: list[res].id,
            name: list[res].categoryName,
          });
        }
        let initText = (index == 0) ? 'init' : 'get';

        //console.log(this.selectionList);
        if (index <= 0) {
          let itemListLen = this.manageList.length;
          this.empty = (itemListLen < 1) ? true : false;
          if (this.empty) {
            this.successMsg = response.result;
          } else {
            this.scrollCallback = true;
            this.scrollInit = 1;
            this.itemTotal = resultData.total;
            this.itemLength = itemListLen;
            this.offset += this.limit;
          }
        }

        setTimeout(() => {
          this.initList(initText, this.manageList);
        }, 50);

        if (this.searchNew) {
          this.manageItem('new', 0);
        }
      });
    }
  }

    // Get Catg Info
    getZoneInfo(index) {
      console.log(index)
      if (index == -3) {
        this.initList('init', this.manageList);
      } else {
        this.loading = true;
        this.scrollTop = 0;
        this.lastScrollTop = this.scrollTop;
        /*let apiData = {
          apiKey: this.apiData.apiKey,
          domainId: this.apiData.domainId,
          countryId: this.apiData.countryId,
          userId: this.apiData.userId,
          searchKey: this.searchVal,
          offset: this.offset,
          limit: this.limit
        }*/

        this.apiData["offset"] = this.offset;
        this.apiData["limit"] = this.limit;

        const apiFormData = new FormData();
        apiFormData.append("apiKey", this.apiData["apiKey"]);
        apiFormData.append("domainId", this.apiData["domainId"]);
        apiFormData.append("countryId", this.apiData["countryId"]);
        apiFormData.append("userId", this.apiData["userId"]);
        apiFormData.append("searchKey", this.searchVal);
        apiFormData.append("limit", this.apiData["limit"]);
        apiFormData.append("offset", this.apiData["offset"]);
        apiFormData.append("isNew", "1");

        this.dashboardService.getZoneList(apiFormData).subscribe((response) => {
          let resultData = response;
          this.manageList = (index >= -1) ? [] : this.manageList;
          let list = response.items;
          for (let res in list) {
            this.manageList.push({
              id: list[res].name,
              name: list[res].name,
            });
          }
          let initText = (index == 0) ? 'init' : 'get';

          //console.log(this.selectionList);
          if (index <= 0) {
            let itemListLen = this.manageList.length;
            this.empty = (itemListLen < 1) ? true : false;
            if (this.empty) {
              this.successMsg = response.result;
            } else {
              this.scrollCallback = true;
              this.scrollInit = 1;
              this.itemTotal = resultData.total;
              this.itemLength = itemListLen;
              this.offset += this.limit;
            }
          }

          setTimeout(() => {
            this.initList(initText, this.manageList);
          }, 50);

          if (this.searchNew) {
            this.manageItem('new', 0);
          }
        });
      }
    }

    getDiagnosticInfo(index){
      console.log(index)
      if (index == -3) {
        this.initList('init', this.manageList);
      } else {
        this.loading = true;
        this.scrollTop = 0;
        this.lastScrollTop = this.scrollTop;
        /*let apiData = {
          apiKey: this.apiData.apiKey,
          domainId: this.apiData.domainId,
          countryId: this.apiData.countryId,
          userId: this.apiData.userId,
          searchKey: this.searchVal,
          offset: this.offset,
          limit: this.limit
        }*/

        this.apiData["offset"] = this.offset;
        this.apiData["limit"] = this.limit;

        const apiFormData = new FormData();
        apiFormData.append("apiKey", this.apiData["apiKey"]);
        apiFormData.append("domainId", this.apiData["domainId"]);
        apiFormData.append("countryId", this.apiData["countryId"]);
        apiFormData.append("userId", this.apiData["userId"]);
        apiFormData.append("searchKey", this.searchVal);
        apiFormData.append("limit", this.apiData["limit"]);
        apiFormData.append("offset", this.apiData["offset"]);
        apiFormData.append("type", this.inputData.field);
        apiFormData.append("isNew", "1");

        this.commonApi.getDiagnosticFieldList(apiFormData).subscribe((response) => {
          let resultData = response;
          this.manageList = (index >= -1) ? [] : this.manageList;
          let list = response.data;
          for (let res in list) {
            this.manageList.push({
              id: list[res].id,
              name: list[res].name,
            });
          }
          let initText = (index == 0) ? 'init' : 'get';

          //console.log(this.selectionList);
          if (index <= 0) {
            let itemListLen = this.manageList.length;
            this.empty = (itemListLen < 1) ? true : false;
            if (this.empty) {
              this.successMsg = response.result;
            } else {
              this.scrollCallback = true;
              this.scrollInit = 1;
              this.itemTotal = resultData.total;
              this.itemLength = itemListLen;
              this.offset += this.limit;
            }
          }

          setTimeout(() => {
            this.initList(initText, this.manageList);
          }, 50);

          if (this.searchNew) {
            this.manageItem('new', 0);
          }
        });
      }
    }
  // Get Catg Info
  getKeywordInfo(index) {
    console.log(index)
    if (index == -3) {
      this.initList('init', this.manageList);
    } else {
      this.loading = true;
      this.scrollTop = 0;
      this.lastScrollTop = this.scrollTop;
      /*let apiData = {
        apiKey: this.apiData.apiKey,
        domainId: this.apiData.domainId,
        countryId: this.apiData.countryId,
        userId: this.apiData.userId,
        searchKey: this.searchVal,
        offset: this.offset,
        limit: this.limit
      }*/

      this.apiData["offset"] = this.offset;
      this.apiData["limit"] = this.limit;

      const apiFormData = new FormData();
      apiFormData.append("apiKey", this.apiData["apiKey"]);
      apiFormData.append("domainId", this.apiData["domainId"]);
      apiFormData.append("countryId", this.apiData["countryId"]);
      apiFormData.append("userId", this.apiData["userId"]);
      apiFormData.append("searchKey", this.searchVal);
      apiFormData.append("limit", this.apiData["limit"]);
      apiFormData.append("offset", this.apiData["offset"]);
      apiFormData.append("groupId", this.apiData["groupId"]);
      apiFormData.append("isNew", "1");

      this.commonApi.getKeyWordPriority(apiFormData).subscribe((response) => {
        let resultData = response;
        this.manageList = (index >= -1) ? [] : this.manageList;
        let list = response.items;
        for (let res in list) {
          this.manageList.push({
            id: list[res].id,
            name: list[res].name,
          });
        }
        let initText = (index == 0) ? 'init' : 'get';

        //console.log(this.selectionList);
        if (index <= 0) {
          let itemListLen = this.manageList.length;
          this.empty = (itemListLen < 1) ? true : false;
          if (this.empty) {
            this.successMsg = response.result;
          } else {
            this.scrollCallback = true;
            this.scrollInit = 1;
            this.itemTotal = resultData.total;
            this.itemLength = itemListLen;
            this.offset += this.limit;
          }
        }

        setTimeout(() => {
          this.initList(initText, this.manageList);
        }, 50);

        if (this.searchNew) {
          this.manageItem('new', 0);
        }
      });
    }
  }
   // Get Catg Info
   getFolderInfo(index) {
    console.log(index)
    if (index == -3) {
      this.initList('init', this.manageList);
    } else {
      this.loading = true;
      this.scrollTop = 0;
      this.lastScrollTop = this.scrollTop;
      /*let apiData = {
        apiKey: this.apiData.apiKey,
        domainId: this.apiData.domainId,
        countryId: this.apiData.countryId,
        userId: this.apiData.userId,
        searchKey: this.searchVal,
        offset: this.offset,
        limit: this.limit
      }*/

      this.apiData["offset"] = this.offset;
      this.apiData["limit"] = this.limit;

      const apiFormData = new FormData();
      apiFormData.append("apiKey", this.apiData["apiKey"]);
      apiFormData.append("domainId", this.apiData["domainId"]);
      apiFormData.append("countryId", this.apiData["countryId"]);
      apiFormData.append("userId", this.apiData["userId"]);
      apiFormData.append("searchKey", this.searchVal);
      apiFormData.append("limit", this.apiData["limit"]);
      apiFormData.append("offset", this.apiData["offset"]);
      apiFormData.append("workstreamsList", this.apiData["workstreamsList"]);
      apiFormData.append("isNew", "1");
      apiFormData.append("createNew", "1");

      this.authenticationService.apiGetDocumentFolder(apiFormData).subscribe((response) => {
        let resultData = response.data;
        this.manageList = (index >= -1) ? [] : this.manageList;
        let list = response.data.items;
        for (let res in list) {
          this.manageList.push({
            id: list[res].id,
            name: list[res].name,
          });
        }
        let initText = (index == 0) ? 'init' : 'get';

        //console.log(this.selectionList);
        if (index <= 0) {
          let itemListLen = this.manageList.length;
          this.empty = (itemListLen < 1) ? true : false;
          if (this.empty) {
            this.successMsg = response.result;
          } else {
            this.scrollCallback = true;
            this.scrollInit = 1;
            this.itemTotal = resultData.total;
            this.itemLength = itemListLen;
            this.offset += this.limit;
            console.log(this.itemTotal,this.itemLength,this.offset);
          }
        }

        setTimeout(() => {
          this.initList(initText, this.manageList);
        }, 50);

        if (this.searchNew) {
          this.manageItem('new', 0);
        }
      });
    }
  }
  // Get Tag Info
  getTagInfo(index) {

    if(this.filterPageAccess == '1'){
      //this.loading = true;
      this.scrollTop = 0;
      this.lastScrollTop = this.scrollTop;
      let actionTagsSIB = [];
      if(this.access == "Tags" ) {
        let mlArr3 = [];
        actionTagsSIB = localStorage.getItem("actionTagsSIB") != null ? JSON.parse(localStorage.getItem("actionTagsSIB")) : [];
        if(actionTagsSIB && actionTagsSIB.length>0){
          actionTagsSIB.forEach(item => {
            mlArr3.push({
              id: item.value,
              name: item.value,
            });
          })
        }
        this.manageList = [];
        this.manageList = mlArr3;
        let itemListLen = this.manageList.length;
        this.empty = (itemListLen < 1) ? true : false;
        if (this.empty) {
          this.successMsg = "No items found";
        } else {
          this.scrollCallback = true;
          this.scrollInit = 1;
          this.itemTotal = this.manageList.length;
          this.itemLength = itemListLen;
          this.offset += this.limit;
        }


        setTimeout(() => {
          this.loading = false;
          this.initList("init", this.manageList);
        }, 50);
      }
    }
    else{
      if (index == -3) {
        this.initList('init', this.manageList);
      } else {
        this.loading = true;
        this.scrollTop = 0;
        this.lastScrollTop = this.scrollTop;
        let apiData = {
          apiKey: this.apiData.apiKey,
          domainId: this.apiData.domainId,
          countryId: this.apiData.countryId,
          userId: this.apiData.userId,
          thread_type: this.apiData.threadType,
          groupId: this.apiData.groupId,
          searchKey: this.searchVal,
          offset: this.offset,
          limit: this.limit
        }
        let callAbleUrl = this.commonApi.getTagList(apiData);
        if (this.pageType == 'market-place') {
          callAbleUrl = this.commonApi.getKeywordsList(apiData);
        }
        if (this.pageType == 'video-library-category') {
          callAbleUrl = this.commonApi.getVideoLibraryCategoryList(apiData);
        }
        if (this.pageType == 'video-library-tags') {
          callAbleUrl = this.commonApi.getVideoLibraryTagList(apiData);
        }

        callAbleUrl.subscribe((response) => {
          console.log("response: ", response);
          let resultData = response.data;
          this.manageList = (index >= -1) ? [] : this.manageList;
          let list = resultData.tags;
          for (let res in list) {
            this.manageList.push(list[res]);
          }
          let initText = (index == 0) ? 'init' : 'get';

          //console.log(this.selectionList);
          if (index <= 0) {
            let itemListLen = this.manageList.length;
            this.empty = (itemListLen < 1) ? true : false;
            if (this.empty) {
              this.successMsg = response.result;
            } else {
              this.scrollCallback = true;
              this.scrollInit = 1;
              this.itemTotal = resultData.total;
              this.itemLength = itemListLen;
              this.offset += this.limit;
            }
          }

          setTimeout(() => {
            this.initList(initText, this.manageList);
          }, 50);

          if (this.searchNew) {
            this.manageTag('new', 0);
          }
        });
      }
    }
  }

  getLookUpInfo(index) {
let fromPPFR=0;
    if(this.access=='Countries')
    {
      this.apiData.lookUpdataId='29';
      fromPPFR=1;
    }
    this.loading = true;
    let apiData = {
      apiKey: this.apiData.apiKey,
      domainId: this.apiData.domainId,
      countryId: this.apiData.countryId,
      userId: this.apiData.userId,
      lookUpdataId: this.apiData.lookUpdataId,
      fromPPFR: fromPPFR,
      searchKey: this.searchVal,
      isInActive: this.activeListshow,
      offset: this.offset,
      limit: this.limit
    }

    this.commonApi.getLoopUpDataList(apiData).subscribe((response) => {
      // let resultData = response.data;
      this.manageList = [];
      this.manageList = response.loopUpData;

      let initText = (index == 0) ? 'init' : 'get';
      this.initList(initText, this.manageList);
      //console.log(this.selectionList);
      let itemListLen1 = this.manageList.length;
      this.empty = (itemListLen1 < 1) ? true : false;
      if (this.empty) {
        this.successMsg = response.result;
      }
      if (index < 0) {
        let itemListLen = this.manageList.length;
        this.empty = (itemListLen < 1) ? true : false;
        if (this.empty) {
          this.successMsg = response.result;
        }
      }

      if (this.searchNew) {
        this.manageTag('new', 0);
      }
    });
  }


  getEscLookUpInfo(index) {
    this.loading = true;
    let apiData = {
      apiKey: this.apiData.apiKey,
      domainId: this.apiData.domainId,
      countryId: this.apiData.countryId,
      userId: this.apiData.userId,
      commonApiValue: this.apiData.commonApiValue,
      searchKey: this.searchVal,

      offset: this.offset,
      limit: this.limit
    }

    this.commonApi.getEscalationLoopUpDataList(apiData).subscribe((response) => {
      // let resultData = response.data;
      this.manageList = [];
      this.manageList = response.items;

      let initText = (index == 0) ? 'init' : 'get';
      this.initList(initText, this.manageList);
      //console.log(this.selectionList);
      let itemListLen1 = this.manageList.length;
      this.empty = (itemListLen1 < 1) ? true : false;
      if (this.empty) {
        this.successMsg = response.result;
      }
      if (index < 0) {
        let itemListLen = this.manageList.length;
        this.empty = (itemListLen < 1) ? true : false;
        if (this.empty) {
          this.successMsg = response.result;
        }
      }

      if (this.searchNew) {
        this.manageTag('new', 0);
      }
    });
  }

  // Get Error Code
  getErrorCodes(index) {
    console.log(index)
    if (index == -3) {
      this.initList('init', this.manageList);
    } else {
      this.loading = true;
      this.scrollTop = 0;
      this.lastScrollTop = this.scrollTop;
      console.log(this.apiData)
      this.apiData.type = (this.apiData.type == undefined || this.apiData.type == 'undefined') ? '' : this.apiData.type;
      this.apiData.typeId = (this.apiData.typeId == undefined || this.apiData.typeId == 'undefined') ? [] : this.apiData.typeId;
      this.apiData.threadCategoryId = (this.apiData.threadCategoryId == undefined || this.apiData.threadCategoryId == 'undefined') ? '' : this.apiData.threadCategoryId;
      let apiData = {
        apiKey: this.apiData.apiKey,
        domainId: this.apiData.domainId,
        countryId: this.apiData.countryId,
        userId: this.apiData.userId,
        vehicleInfo: this.apiData.vehicleInfo,
        searchKey: this.searchVal,
        type: this.apiData.type,
        typeId: this.apiData.typeId,
        threadCategoryId: this.apiData.threadCategoryId,
        offset: this.offset,
        limit: this.limit
      }
      console.log(apiData, Array.isArray(this.apiData.typeId))

      this.commonApi.getErrorCodes(apiData).subscribe((response) => {
        let resultData = response;
        this.manageList = (index >= -1) ? [] : this.manageList;
        let list = resultData.errorCodes;
        for (let res in list) {
          this.manageList.push(list[res]);
        }
        let initText = (index == 0) ? 'init' : 'get';
        console.log(index, this.selectionList)
        if (index <= 0) {
          //this.searchVal = '';
          let itemListLen = this.manageList.length;
          this.empty = (itemListLen < 1) ? true : false;
          if (this.empty) {
            this.successMsg = response.result;
          } else {
            this.scrollCallback = true;
            this.scrollInit = 1;
            this.itemTotal = resultData.total;
            this.itemLength += resultData.errorCodes.length;
            this.offset += this.limit;
          }
        }

        setTimeout(() => {
          this.initList(initText, this.manageList);
        }, 50);

        if (this.searchNew) {
          //this.manageErrorCode('new', 0);
        }
      });
    }
  }

  // Initiate Manage List
  initList(action, manageList) {
    if(this.newTagOptFlag){
      action = '';
      this.newTagOptFlag = false;
    }
    console.log(this.access, manageList, this.filteredTags, this.filteredModelsCount)
    let start = 0;
    let end = 0;
    this.listItems = [];
    console.log(manageList);
    this.listItems = manageList;
    console.log("this.listItems", this.listItems);
    let newFlag = localStorage.getItem('newItem');
    this.searchForm.value.searchKey = (newFlag) ? '' : this.searchForm.value.searchKey;
    this.searchVal = this.searchForm.value.searchKey;
    let checkDisplayFlag = (action == 'get') ? true : false;
    console.log(action, newFlag)
    console.log(this.offset, this.limit)
    switch (action) {
      case 'get':
        start = this.offset - this.limit
        end = this.offset - 1;
        break;

      default:
        end = manageList.length - 1;
        break;
    }

    switch (this.access) {
      case 'GTSList':
      case 'customerList':
      case 'customerListRO':
      case 'roPartNumber':
      case 'roQtyAvailable':
      case 'Tags':
      case 'Countries':
      case 'New Thread Tags':
      case 'newthread':
      case 'newAdasSystem':
      case 'New Parts':
      case 'techinfo':
      case 'PartType':
      case 'PartAssembly':
      case 'PartSystem':
      case 'mediaUpload':
      case 'additionalSystems':
      case 'adasCalproReport':  
      case 'InternalStatusAccess':
      case 'jobListRO':  
      case 'MSOLocationList':
        console.log(this.listItems)
        console.log(start)
        console.log(end)
        for (let m in this.listItems) {
          console.log(this.listItems);
          if (start <= parseInt(m) && end >= parseInt(m)) {
            console.log(m)
            let i: any = m;
            this.listItems[m]['action'] = "";
            let field = this.inputData.field;
            console.log(field);
            switch (field) {
              case 'colour':
              case 'info-1':
              case 'info-2':
              case 'info-3':
              case 'info-4':
              case 'info-5':
              case 'info-6':
              case 'info-7':
                this.listItems[m]['editAccess'] = 1;
                break;
              case 'escalationLookup':
                this.listItems[m]['productModelsCount'] = this.listItems[m]['productModelsCount'];
                break;
            }

            this.listItems[m]['displayFlag'] = true;
            this.listItems[m]['checkFlag'] = false;
            this.listItems[m]['itemExists'] = false;
            this.listItems[m]['activeMore'] = false;
            this.listItems[m]['actionFlag'] = false;
            if (this.access == 'newthread' && (this.inputData.field == 'other-payment' || this.inputData.field == 'usetype-businessname' || this.inputData.field == 'helpdata' || this.inputData.field == 'folders' || this.inputData.field == 'keyword' || this.inputData.field == 'cba-manufacturer' || this.inputData.field == 'softwareUpdate' || this.inputData.field == 'programNewModule' || this.inputData.field == 'supplier' || this.inputData.field == 'vehicleManufector' || this.inputData.field == 'vehicleType' || this.inputData.field == 'EngineCode' || this.inputData.field == 'KBAnumber')) {
              this.listItems[m]['editAccess'] = 1;
            }
            if (this.access == 'newthread' && (this.inputData.field == 'roPartNumber' || this.inputData.field == 'roQtyAvailable' || this.inputData.field == 'escalationLookup' || this.inputData.field == 'model' || this.inputData.field == 'PartModel')) {
              switch (this.inputData.field) {
                case 'model':
                  let modelId = (this.pageAccess == 'adas-procedure') ? this.listItems[m]['id'] : this.listItems[m]['modelName'];
                  this.listItems[m]['id'] = modelId;
                  this.listItems[m]['name'] = this.listItems[m]['modelName'];
                  break;
                case 'escalationLookup':
                  this.listItems[m]['id'] = this.listItems[m]['id'];
                  this.listItems[m]['name'] = this.listItems[m]['name'];
                  this.listItems[m]['productModelsCount'] = this.listItems[m]['productModelsCount'];
                  break;
                case 'roPartNumber':
                  this.listItems[m]['id'] = this.listItems[m]['id'];
                  this.listItems[m]['name'] = this.listItems[m]['name'];
                  this.listItems[m]['desc'] = this.listItems[m]['desc'];
                  break;
                case 'roQtyAvailable':
                  this.listItems[m]['id'] = this.listItems[m]['id'];
                  this.listItems[m]['name'] = this.listItems[m]['name'];
                  this.listItems[m]['count'] = this.listItems[m]['count'];
                  break;
                default:
                  let modelData = this.listItems[m]['modelItems'][0];
                  this.listItems[m]['id'] = modelData.id;
                  this.listItems[m]['name'] = modelData.name;
                  break;
              }
            }

            if (this.access == 'techinfo') {
              this.listItems[m]['phoneNo'] = this.listItems[m]['phoneNo'];
            }
            if(this.access == 'MSOLocationList'){
              this.listItems[m] = {...(this.listItems[m] || {} )};

              if(Array.isArray(this.inputData?.defaultSelected) && this.inputData?.defaultSelected?.length){
                this.selectionList = this.inputData?.defaultSelected;
              }
            }
            let autoInc=0;
            console.log(this.filteredTags, this.filteredLists, this.selectionList)
            if(this.filteredTags){
              if(this.access == 'jobListRO') {
                for (let t of this.filteredTags) {
                  let chkItem = this.listItems[m].id;
                  console.log(t, chkItem)
                  if (t == chkItem) {
                    this.listItems[m]['checkFlag'] = true;
                    this.listItems[m]['displayFlag'] = true;
                    let sindex = this.selectionList.findIndex(option => option.id == t);
                    if(sindex < 0) {
                      this.selectionList.push(this.listItems[m]);
                    }
                  } else {
                    if(this.listItems[m]['checkFlag']) {
                      let sindex = this.selectionList.findIndex(option => option.id == t);
                      if(sindex < 0) {
                        this.selectionList.push(this.listItems[m]);
                      }
                    }
                  }
                }
              } else {
                for (let t of this.filteredTags) {
                  let chkItem = (this.pageAccess == 'adas-procedure' && this.inputData.field == 'model') ? this.listItems[m].id : this.listItems[m].id;
                  console.log(t, chkItem)
                  if (t == chkItem) {
                    this.listItems[m]['checkFlag'] = true;
                    if (this.access == 'newthread' && (this.inputData.field == 'escalationLookup')) {
                      this.selectionList.push({
                        id: t,
                        name: this.listItems[m].name,
                        productModelsCount: this.listItems[m]['productModelsCount']
                      });
                      console.log('in', t)
                      //this.setupFilteredItems(t);
                    }
                    else if (this.access == 'newthread' && (this.inputData.field == 'roPartNumber')) {
                      this.selectionList.push({
                        id: t,
                        name: this.listItems[m].name,
                        desc: this.listItems[m]['desc']
                      });
                      console.log('in', t)
                      //this.setupFilteredItems(t);
                    }
                    else if (this.access == 'newthread' && (this.inputData.field == 'roQtyAvailable')) {
                      this.selectionList.push({
                        id: t,
                        name: this.listItems[m].name,
                        count: this.listItems[m]['count']
                      });
                      console.log('in', t)
                      //this.setupFilteredItems(t);
                    }
                    else {
                      if(this.inputData.field == 'countries' && t == 0){
                        setTimeout(() => {
                          this.countryAllFlag = true;
                          this.selection = 'multiple';
                          this.itemSelection('all', '0', '0', 'checked');
                        }, 100);
                      }
                      else{


                        if((this.inputData.field == 'folders' || this.inputData.field == 'category' || this.inputData.field == 'zone') && t == 0){
                          let rmIndex = this.selectionList.findIndex(option => option.id == t);
                          if(rmIndex >= 0){ }
                          else{

                            console.log(this.selectionList);
                            this.selectionList.push({
                              id: t,
                              name: this.listItems[m].name
                            });
                          }
                          console.log(this.selectionList);
                        }
                      }

                      /* if(this.inputData.field == 'complaintCategory') {
                        console.log('in complaintCategory')
                        let sindex = this.selectionList.findIndex(option => option.id == t);
                        console.log(sindex)
                        if(sindex < 0) {
                          console.log('in push selection', this.listItems[m])
                          this.selectionList.push({
                            id: t,
                            name: this.listItems[m].name
                          });
                        }
                      } */

                      console.log('in', t)
                      //this.setupFilteredItems(t);
                    }

                  }
                  if (this.access == 'newthread' && (this.inputData.field == 'escalationLookup'))
                  {

                  }
                  else
                  {
                    if(this.inputData.field == 'countries' && t == 0)
                    {

                    }

                    else
                    {
                      if(this.inputData.field=='model')
                      {
                        this.selectionList.push({
                          id: t,
                          name: t
                        });
                      }
                      else
                      {
                        let studentObj = this.selectionList.find(s => s.id == t);
                        if (studentObj)
                        {
                          this.selectionList.find(s => s.id == t).id=t;
                          this.selectionList.find(s => s.id == t).name=this.filteredLists[autoInc];

                        }
                        else
                        {
                          console.log('push 1');
                          this.selectionList.push({
                            id: t,
                            name: this.filteredLists[autoInc]
                          });
                        }

                      }

                    }

                  }
                  autoInc++;
                }
              }
            }
            if (action == 'get' || action == 'init') {
              console.log(this.selectionList)
              for (let st of this.selectionList) {
                if (st.id == this.listItems[m].id) {
                  this.listItems[m]['checkFlag'] = true;
                }
              }
              /* if(this.access == 'jobListRO') {
                let selectedItem = [];
                this.filteredTags.forEach(fitem => {
                  let sindex = this.selectionList.findIndex(option => option.id == fitem);
                  console.log(fitem, sindex)
                  if(sindex >= 0) {
                    selectedItem.push(this.selectionList[sindex]);
                    this.selectionList = selectedItem;
                  }
                });
                
              } */
            }

            console.log("initList: ", {action, manageList, selectionList: this.selectionList});
            
          }
        }

        /* if(this.access == 'jobListRO') {
          if(this.apiData['offset'] == 0) {
            this.selectedJobList.forEach(sitem => {
              let id = sitem.id;
              let listIndex = this.listItems.findIndex(option => parseInt(option.id) == parseInt(id));
              if(listIndex >= 0) {
                this.listItems[listIndex]['displayFlag'] = false;
              }
              this.listItems.unshift(sitem);
            });
            this.itemTotal = this.itemTotal - this.selectedJobList.length;
            this.itemLength = this.itemLength - this.selectedJobList.length;
            console.log(this.listItems)
          } else {
            this.selectedJobList.forEach(sitem => {
              let id = sitem.id;
              let listIndex = this.listItems.findIndex(option => parseInt(option.id) == parseInt(id));
              if(listIndex >= 0) {
                this.listItems[listIndex]['displayFlag'] = false;
              }
            });
          }
        } */

        if (action == 'get' && this.inputData.selectionType == 'single') {
          //this.selectedItems.emit(this.selectionList);
          //this.activeModal.dismiss('Cross click');
        }

        if (newFlag != null && newFlag != 'undefined' && newFlag != undefined) {
          let action = 'new';
          this.submitActionFlag = true;
          this.searchNew = false;
          this.actionFlag = true;
          this.itemAction = action;
          let sval = localStorage.getItem('searchVal');
          console.log(sval)
          this.searchVal = "";
          this.submitActionFlag = (sval == null) ? false : true;
          this.itemVal = sval;
          let newTag = {
            id: 0,
            name: sval,
            editAccess: 0,
            displayFlag: true,
            action: action,
            activeMore: false,
            actionFlag: false,
            itemExists: false
          };
          this.listItems.unshift(newTag);
          this.empty = false;
          localStorage.removeItem('newItem');
          if (action == 'new' && sval != null) {
            this.checkTagExists(0, sval);
          }
        }

        setTimeout(() => {
          if ((!this.countryAllFlag) && (this.selection == 'multiple' || this.selection == 'single')) {
            this.headerCheck = (this.selectionList.length == 0) ? 'unchecked' : 'checked';
            this.headercheckDisplay = (this.selectionList.length == 0) ? 'checkbox-hide' : 'checkbox-show';
          }
        }, 500);
        break;

      case 'Error Codes':
      case 'New Thread Error Codes':
        //this.listItems = manageList;
        for (let m in this.listItems) {
          if (start <= parseInt(m) && end >= parseInt(m)) {
            let i: any = m;
            this.listItems[m]['action'] = "";
            this.listItems[m]['editAccess'] = 1;
            this.listItems[m]['displayFlag'] = true;
            this.listItems[m]['checkFlag'] = false;
            this.listItems[m]['itemExists'] = false;
            this.listItems[m]['activeMore'] = false;
            this.listItems[m]['actionFlag'] = false;
            console.log(this.filteredLists, this.filteredErrorCodes)
            for (let t of this.filteredErrorCodes) {
              console.log(t, this.listItems[m].id)
              let eid = this.listItems[m].id;
              let name = this.listItems[m].code + ' - ' + this.listItems[m].desc;
              name = (this.gtsAccess) ? `${this.listItems[m].type_name} - ${name}` : name;
              if(this.filterCall) {
                name = eid;
              }
              if (t == eid) {
                let ename = `${this.listItems[m].code}##${this.listItems[m].desc}`;
                this.listItems[m]['checkFlag'] = true;
                this.selectionList.push({
                  id: t,
                  name: name,
                  ename: ename
                });
                //this.setupFilteredItems(t);
              }
            }
            if (action == 'get') {
              for (let st of this.selectionList) {
                if (st.id == this.listItems[m].id) {
                  this.listItems[m]['checkFlag'] = true;
                }
              }
            }
          }
        }

        if (newFlag != null && newFlag != 'undefined' && newFlag != undefined) {
          let action = 'new';
          this.submitActionFlag = true;
          this.searchNew = false;
          this.actionFlag = true;
          this.itemAction = action;
          let sval = localStorage.getItem('searchVal');
          this.submitActionFlag = (sval == null) ? false : true;
          this.itemVal = sval;
          let newErrorCode = {
            id: 0,
            name: sval,
            editAccess: 1,
            displayFlag: true,
            action: action,
            activeMore: false,
            actionFlag: false,
            itemExists: false
          };
          this.listItems.unshift(newErrorCode);
          localStorage.removeItem('newItem');
        }

        setTimeout(() => {
          if (this.selection == 'multiple' || this.selection == 'single') {
            this.headerCheck = (this.selectionList.length == 0) ? 'unchecked' : 'checked';
            this.headercheckDisplay = (this.selectionList.length == 0) ? 'checkbox-hide' : 'checkbox-show';
          }
        }, 500);
        break;

      case 'LookupDataPM':


        this.listItems = manageList;


        for (let m in this.listItems) {
          let i: any = m;
          this.listItems[m]['action'] = "";
          this.listItems[m]['displayFlag'] = true;
          this.listItems[m]['checkFlag'] = false;
          this.listItems[m]['itemExists'] = false;
          this.listItems[m]['activeMore'] = false;
          this.listItems[m]['actionFlag'] = false;
          //console.log(this.filteredTags)
          /*for(let t of this.filteredTags) {
            if(t == this.listItems[m].id) {
              this.listItems[m]['checkFlag'] = true;
              this.selectionList.push({
                id: t,
                name: this.listItems[m].name
              });
            }
          }
          */
          if (action == 'get') {
            for (let st of this.selectionList) {
              if (st.id == this.listItems[m].id) {
                this.listItems[m]['checkFlag'] = true;
              }
            }
          }
        }

        setTimeout(() => {
          if (this.filteredTags.length > 0) {
            this.headerCheck = (this.selectionList.length == 0) ? 'unchecked' : 'checked';
            this.headercheckDisplay = (this.selectionList.length == 0) ? 'checkbox-hide' : 'checkbox-show';
          }
        }, 500);
        break;
    }
    setTimeout(() => {
      this.loading = false;
      this.lazyLoading = this.loading;
    }, 500);
  }

  // Item Selection
  itemSelection(type, index, id, flag) {
    if(this.access == 'roQtyAvailable') {
      return;
    }
    this.clearFlag = false;
    console.log(this.access, this.selectionList);
    console.log(type + ' :: ' + index + ' :: ' + id + ' :: ' + flag + ' :: ' + this.selection)
    let field = this.inputData.field;
    if(type == 'single' && id == 0 && field == "countries"){
      type = 'all';
      flag = flag ? flag : 'all';
    }
    console.log(field);
    switch (type) {
      case 'single':
        if (this.selection == 'single') {
          let emitFlag = true;
          if (flag || this.access == 'customerList' || this.access == 'MSOLocationList') {
            if(field == this.access) {
              console.log(123, id)
              this.listItems.forEach(citem => {
                console.log(citem.id, id)
                if(citem.id != id) {
                  citem.checkFlag = false;
                }
              });
            }
            this.headerCheck = 'checked';
            this.selectionList = [];
            switch (field) {
              case 'model':
              case 'PartModel':
                let item = this.listItems[index];
                let additionalInfo1 = (item.additionalInfo) ? item.additionalInfo : [];
                let additionalInfo2 = (item.additionalInfo1) ? item.additionalInfo1 : [];
                let additionalInfo3 = (item.additionalInfo2) ? item.additionalInfo2 : [];
                let additionalInfo4 = (item.additionalInfo3) ? item.additionalInfo3 : [];
                let additionalInfo5 = (item.additionalInfo4) ? item.additionalInfo4 : [];
                console.log(item, this.listItems[index]);
                let partNumber = '';
                if(field == 'model') {
                  let threadCategory = item.ThreadCategories;
                  let isPartNumber = item.hasOwnProperty("PartNumber");
                  if(isPartNumber) {
                    partNumber = (threadCategory.length > 0 && threadCategory[0].id == 10 && item.PartNumber != undefined) ? item.PartNumber : partNumber;
                  }
                }
                let modId = (this.industryType.id == 2 || this.industryType.id == 3) ? this.listItems[index].uId : this.listItems[index].id;
                this.selectionList.push({
                  id: modId,
                  name: this.listItems[index].name,
                  catg: item.CategoryId,
                  subCatg: item.SubcategoryId,
                  prodType: item.productType,
                  regions: item.regions,
                  make: item.makeName,
                  makeItems: item.makeItems,
                  partNumber,
                  additionalInfo1,
                  additionalInfo2,
                  additionalInfo3,
                  additionalInfo4,
                  additionalInfo5
                });
                break;
              case 'vinNo':
              case 'vinNoScanTool':
              case 'InternalStatusField':
                this.selectionList.push(this.listItems[index]);
                break;
              case 'serialNo':
                console.log(this.listItems[index]);
                let item1 = this.listItems[index];
                this.selectionList.push({
                  id: item1.id,
                  name: item1.name,
                  deliverableversion: item1.deliverableversion,
                  created_on: item1.created_on,
                  make: item1.make,
                  model: item1.model,
                  editAccess: item1.editAccess,
                });
                break;
              case 'roPartNumber':
                
                console.log(this.listItems[index]);
                let item12 = this.listItems[index];
                this.selectionList.push({
                  ...(item12 || {}),
                  id: item12.id,
                  name: item12.name,
                  desc: item12.desc,
                });
                break;
              case 'roQtyAvailable':
                
                console.log(this.listItems[index]);
                let item13 = this.listItems[index];
                this.selectionList.push({
                  id: item13.id,
                  name: item13.name,
                  desc: item13.desc,
                });
                break;
              default:
                console.log(this.listItems[index])
                emitFlag = (this.access == 'customerList') ? false : emitFlag;
                if(this.access == 'customerList') {
                  this.listItems[index].checkFlag = flag;
                  if(flag) {
                    this.selectionList.push({
                      id: this.listItems[index].id,
                      name: this.listItems[index].name,
                      nameOnly: this.listItems[index].nameOnly,
                      marketId: this.listItems[index].marketId,
                      marketName: this.listItems[index].marketName,
                      addressOnly: this.listItems[index].addressOnly
                    });
                  } else {
                    this.selectionList = [];
                  }
                } else if(this.access == 'MSOLocationList') {
                  this.listItems[index].checkFlag = flag;
                  if(flag) {
                    this.selectionList.push({
                      ...(this.listItems[index] || {}),
                      id: this.listItems[index].id,
                      name: this.listItems[index].name,
                      nameOnly: this.listItems[index].nameOnly,
                      addressOnly: this.listItems[index].addressOnly,
                      location: this.listItems[index].location,
                      city: this.listItems[index].city,
                      state: this.listItems[index].state,
                      locationType: this.listItems[index].locationType,
                    });
                  } else {
                    this.selectionList = [];
                  }
                } else if(this.access == 'adasCalproReport') {
                  this.selectionList.push({
                    id: this.listItems[index].id,
                    name: this.listItems[index].name,
                    make: this.listItems[index].make,
                    model: this.listItems[index].model,
                    year: this.listItems[index].year,
                    vinInfo: this.listItems[index].vinInfo
                  });
                } else {
                  this.selectionList.push({
                    id: this.listItems[index].id,
                    name: this.listItems[index].name
                  });
                }
                break;
            }
          } else {
            switch (field) {
              case 'additionalSystems':
              case 'adasCalproReport':  
              case 'customerListRO':
              case 'roPartNumber':
              case 'roQtyAvailable':
              case 'model':
              case 'PartModel':
              case 'vinNo':
              case 'vinNoScanTool':
              case 'category':
              case 'zone':
              case 'keyword':
              case 'other-payment':
              case 'usetype-businessname':
              case 'cba-manufacturer':
              case 'softwareUpdate':
              case 'programNewModule':
              case 'folders':
              case 'escalationLookup':
              case 'InternalStatusField':
                emitFlag = false;
                break;
              default:
                emitFlag = true;
                break;
            }
            this.headerCheck = 'checked';
            this.selectionList = [];
          }
          console.log(emitFlag)
          console.log(this.selectionList)
          if (emitFlag) {
            this.applySelection('trigger');
          }
        } else {
          this.listItems[index].checkFlag = flag;
          if (this.activeListshow == true) {
            this.DisableText = 'Disable';
          } else {
            this.DisableText = 'Enable';
          }
          if (!flag) {
            let rmIndex = this.selectionList.findIndex(option => option.id == id);
            this.selectionList.splice(rmIndex, 1);
            console.log(this.filteredTags);
            if(this.filteredTags) {
              let rmIndex1 = this.filteredTags.findIndex(option => option == id);
              this.filteredTags.splice(rmIndex1, 1);
              if(this.apiData['domainId'] == 98 && this.access == 'Tags' || (this.access == 'newthread' && (field == 'Category' || field == 'zone' || field == 'Emissions')) || this.access == 'jobListRO') {
                this.filteredLists.splice(rmIndex1, 1);
              }
              if(this.access == 'jobListRO' && this.filteredLists.length > 0 && this.selectionList.length == 0) {
                this.selectionList = this.filteredLists;
              }
            }
            console.log(this.selectionList)
            //this.setupFilteredItems(this.listItems[index].id);
            setTimeout(() => {
              this.headerCheck = (this.selectionList.length == 0) ? 'unchecked' : 'checked';
              if (this.activeListshow == true) {
                this.DisableText = 'Disable';
              } else {
                this.DisableText = 'Enable';
              }
              this.headercheckDisplay = (this.selectionList.length == 0) ? 'checkbox-hide' : this.headercheckDisplay;
            }, 100);
          } else {
            console.log(this.listItems[index])
            let name = (this.access != 'Error Codes' && this.access != 'New Thread Error Codes') ? this.listItems[index].name : this.listItems[index].code + ' - ' + this.listItems[index].desc;
            name = (this.gtsAccess) ? `${this.listItems[index].type_name} - ${name}` : name;
            if (this.access == 'New Thread Error Codes') {
              let ename = `${this.listItems[index].code}##${this.listItems[index].desc}`;
              name = (this.filterCall) ? this.listItems[index].id : name;
              ename = (this.filterCall) ? name : ename;
              this.selectionList.push({
                id: this.listItems[index].id,
                name: name,
                ename: ename
              });
            } else if(this.access == 'MSOLocationList') {
              this.selectionList.push({
                ...(this.listItems[index] || {}),
                id: this.listItems[index].id,
                name: this.listItems[index].name,
                nameOnly: this.listItems[index].nameOnly,
                addressOnly: this.listItems[index].addressOnly,
                location: this.listItems[index].location,
                city: this.listItems[index].city,
                state: this.listItems[index].state,
                locationType: this.listItems[index].locationType,
              });
            } else {
              console.log(this.listItems[index].id)
              switch (field) {
                case 'prodCode':
                  let item = this.listItems[index];
                  this.selectionList.push({
                    id: this.listItems[index].id,
                    name: this.listItems[index].name,
                    prodType: item.prodType,
                    model: item.model
                  });
                  break;
                case 'escalationLookup':
                  console.log(this.listItems);
                  this.selectionList.push({
                    id: this.listItems[index].id,
                    name: name,
                    productModelsCount: this.listItems[index].productModelsCount
                  });
                  break;
                case 'roPartNumber':                 
                  console.log(this.listItems);
                  this.selectionList.push({
                    id: this.listItems[index].id,
                    name: name,
                    desc: this.listItems[index].desc
                  });
                  break;
                case 'roQtyAvailable':                 
                  console.log(this.listItems);
                  this.selectionList.push({
                    id: this.listItems[index].id,
                    name: name,
                    desc: this.listItems[index].desc
                  });
                  break;
                case 'vinNo':
                case 'jobListRO':
                  this.selectionList.push(this.listItems[index]);
                  break;                  
                default:
                  this.selectionList.push({
                    id: this.listItems[index].id,
                    name: name
                  });
                  break;
              }
            }

            if (this.access == 'newthread' && this.selection == 'single') {
              let field = this.inputData.field;
              switch (field) {
                case 'model':
                case 'PartModel':
                  let item = this.listItems[index];
                  this.selectionList[0]['catg'] = item.CategoryId;
                  this.selectionList[0]['subCatg'] = item.SubcategoryId;
                  this.selectionList[0]['prodType'] = item.productType;
                  this.selectionList[0]['regions'] = item.regions;
                  this.selectionList[0]['make'] = item.makeName;
                  this.selectionList[0]['makeItems'] = item.makeItems;
                  break;
              }
            }
            this.headercheckDisplay = "checkbox-show";
            this.headerCheck = (this.selectionList.length == this.listItems.length) ? 'all' : 'checked';
            this.headercheckDisplay = (this.selectionList.length > 0) ? 'checkbox-show' : 'checkbox-hide';
          }
        }
        this.clearFlag = (this.selectionList.length == 0) ? true : false;
        if(this.access == 'identiscan' && this.selection == 'single' ) {
          this.clearFlag = true;
        }
        break;
      case 'all':
        this.selectionList = [];
        if (this.activeListshow == true) {
          this.DisableText = 'Disable';
        } else {
          this.DisableText = 'Enable';
        }
        this.headercheckDisplay = 'checkbox-show';
        if (flag == 'checked') {
          if (this.listItems.length > 0) {
            this.headerCheck = 'all';
            this.itemChangeSelection(this.headerCheck);
          }
        } else if (flag == 'all') {
          this.headerCheck = 'unchecked';
          this.headercheckDisplay = 'checkbox-hide';
          this.clearFlag = true;
          this.itemChangeSelection(this.headerCheck);
        } else {
          this.headerCheck = 'all';
          this.itemChangeSelection(this.headerCheck);
        }
        break;
    }
    console.log(this.selectionList)
  }

  // Item Selection (Empty, All)
  itemChangeSelection(action) {
    if (this.access == 'LookupDataPM') {
      for (let m of this.listItems) {
        if (action != 'empty' && action != 'unchecked') {
          if (m.editAccess == 1) {
            this.selectionList.push({
              id: m.id,
              name: m.name
            });
          }
        }
        m.checkFlag = (action == 'all') ? true : false;
      }
    } else {
      console.log(action)
      for (let m of this.listItems) {
        if (action != 'empty' && action != 'unchecked') {
          if(this.inputData.field == 'countries' && action == 'all'){
            this.selectionList.push({
              id: '0',
              name: 'All'
            });
          }
          else{
            this.selectionList.push({
              id: m.id,
              name: m.name
            });
          }
        }
        m.checkFlag = (action == 'all') ? true : false;
      }
    }
  }

  // Manage List
  manageListItem(action, index) {
    if (this.access == 'customerList') {
      this.serviceAction('new', 'shop');
    } else {
      console.log("manageListItem: ", this.access)
      switch (this.access) {
        case 'Tags':
        case 'New Thread Tags':
          this.manageTag(action, index);
          break;
        case 'Error Codes':
        case 'New Thread Error Codes':
        case 'New Parts':
        case 'techinfo':
          this.itemCode = (action == 'new') ? "" : this.itemCode;
          this.manageErrorCode(action, index);
          break;
        case 'LookupDataPM':
        case 'Countries':
          this.manageLoopUpData(action, index);
          break;
        case 'additionalSystems':
        case 'newthread':
        case 'newAdasSystem':
          this.manageItem(action, index);
          break;
        case 'jobListRO':
          if(action == 'edit'){
            const jobItem = this.listItems[index];
            this.editJob(jobItem);
          } else {
            this.manageJobsPopup();
          }
          break;
        case 'InternalStatusAccess':
          this.manageInternalStatus(action, index);
          break;
        case 'identiscan':
          this.manageIdentiScanItem(action, index);
          break;
        case 'jobListRO':
          if(this.inputData?.newJobPopup){
            if(action == 'edit'){
              const jobItem = this.listItems[index];
              this.editJob(jobItem);
            } else {
              this.manageJobsPopup();
            }
          } else {
            this.manageItem(action, index);
          }
          break;
      }
    }
  }

  manageJobsPopup() {
    const modalRef = this.modalService.open(ManageJobsComponent, {
      backdrop: "static",
      keyboard: false,
      centered: true,
      size: "xl",
      windowClass: 'jobs-popup-custom-model'
    });
    const iHeight = window.innerHeight
    modalRef.componentInstance.access = "job-rate";
    modalRef.componentInstance.workstreamListsOptions = this.workstreamListsOptions || [];
    modalRef.componentInstance.productsList = this.listItems || [];
    modalRef.componentInstance.jcId = '';
    modalRef.componentInstance.accessLevel = this.accessLevel;
    modalRef.componentInstance.showDialog = true; 
    console.log("accessLevel: ", this.accessLevel);
    modalRef.componentInstance.jobCallback.subscribe((receivedService) => {
      console.log("jobCallback: ", receivedService);
      modalRef.dismiss("Close");
      if(receivedService?.action == 'new'){
        this.offset = 0;
        this.getJobsData(0);
      }
    })   
  }


    editJob(jobItem) {
      console.log("editJob");
  
       const modalRef = this.modalService.open(ManageJobsComponent, {
            backdrop: "static",
            keyboard: false,
            centered: true,
            size: "xl",
            windowClass: 'jobs-popup-custom-model'
        });
        const iHeight = window.innerHeight
        modalRef.componentInstance.access = "job-rate";
        modalRef.componentInstance.workstreamListsOptions = this.workstreamListsOptions || [];
        modalRef.componentInstance.productsList = this.listItems || [];
        modalRef.componentInstance.currentData = jobItem;
        modalRef.componentInstance.jcId = '';
        modalRef.componentInstance.accessLevel = this.accessLevel;
        modalRef.componentInstance.showDialog = true; 
  
        console.log("accessLevel: ", this.accessLevel);
      
        modalRef.componentInstance.jobCallback.subscribe((receivedService) => {
          console.log("jobCallback: ", receivedService);
          modalRef.dismiss("Close");
          if(receivedService?.action == 'new'){
            console.log("data: ", receivedService);
            console.log("data listItems: ", this.listItems);
            console.log("data selectedItems: ", this.selectedItems);
            const updatedJob = receivedService?.response?.[0] || {}

            this.listItems = this.listItems.map(item => {
              if(item.id == updatedJob.id) {
                return {
                  ...item,
                  ...updatedJob,
                  id: updatedJob.id,
                  name: updatedJob?.jobtitle,
                  jobCode: updatedJob?.jobCode,
                  jobTitle: updatedJob?.jobtitle,
                  jobDesc: updatedJob?.description,
                  discount: updatedJob?.discount,
                  discountPrice: updatedJob?.discountPrice,
                  jobDuration: updatedJob?.jobDuration,
                  unitPrice: updatedJob?.unitPrice,
                  wdPrice: updatedJob?.wdPrice,
                  editAccess: item?.isAvailable == 1 ? 1 : 0,
                }
              }
              return item;
            });
            this.jobItemList = this.manageList;

            this.selectionList = this.selectionList.map(item => {
              if(item.id == updatedJob.id) {
                return {
                  ...item,
                  ...updatedJob,
                  id: updatedJob.id,
                  name: updatedJob?.jobtitle,
                  jobCode: updatedJob?.jobCode,
                  jobTitle: updatedJob?.jobtitle,
                  jobDesc: updatedJob?.description,
                  discount: updatedJob?.discount,
                  discountPrice: updatedJob?.discountPrice,
                  jobDuration: updatedJob?.jobDuration,
                  unitPrice: updatedJob?.unitPrice,
                  wdPrice: updatedJob?.wdPrice,
                  editAccess: item?.isAvailable == 1 ? 1 : 0,
                }
              }
              return item;
            });
            // this.getJobsData(); // api call
          }
        })
    }
  
    deleteJob(jobId) {
      console.log("deleteJob");
  
      const modalRef = this.modalService.open(ConfirmationComponent, { 
        backdrop: 'static', keyboard: false, centered: true 
      });
      modalRef.componentInstance.access = 'Delete';
      modalRef.componentInstance.confirmAction.subscribe((receivedService) => {
        modalRef.dismiss('Cross click');
        if(receivedService) {
          console.log("Delete confirmed for job: ", jobId);
          let data = new FormData();
          data.append("apiKey", this.apiData?.apiKey);
          data.append("domainId", this.apiData?.domainId);
          data.append("userId", this.apiData?.userId);
          data.append('contentTypeId', ContentTypeValues.RepairOrder);
          data.append('action', 'delete');
          data.append('id', jobId);
  
          this.repairOrderApi.updateJOBDetailsList(data).subscribe(
            (response) => {
              console.log("updateJOBDetailsList response: ", response);
              
              if(response.status=='Success') {
                const modalMsgRef = this.modalService.open(SuccessComponent, { backdrop: 'static', keyboard: false, centered: true });
                modalMsgRef.componentInstance.msg = response.message;
                setTimeout(() => {
                  this.offset = 0;
                  this.getJobsData(0);
                  modalMsgRef.dismiss('Cross click');
                }, 2000);
              }
            },
            (error) => {
              console.log("updateJOBDetailsList error: ", error);
            }
          );
        }
      });
    }

  manageIdentiScanItem(action,index) {
    switch (action) {
      case 'new':
        if (this.empty) {
          this.searchNew = true;
          let newFlag: any = true;
          localStorage.setItem('newItem', newFlag);
          //if (!this.empty)
          this.clearSearch(action);
        } else {
          if (!this.actionFlag && !this.empty) {
            this.searchNew = false;
            this.actionFlag = true;
            this.itemAction = action;
            let sval = localStorage.getItem('searchVal');
            this.submitActionFlag = (sval == null) ? false : true;
            this.itemVal = sval;
            this.inputForNewValue = true;
            let newTag = {
              id: 0,
              name: sval,
              displayFlag: true,
              action: action,
              activeMore: false,
              actionFlag: false,
              itemExists: false
            };
            this.listItems.unshift(newTag);
            let el = document.getElementById('manageTable');
            el.scrollTo(0, 0);
            if (action == 'new' && sval != null) {
              this.checkTagExists(index, sval);
            }
            this.inputFocus();
          }
        }
        break;
      case 'submit':
        let duplicateValue = this.listItems.findIndex(x => x.name == this.itemVal);
        if(duplicateValue == -1) {
          let array = [];
          this.listItems.forEach((res)=>{
            let id = parseFloat(res.id)
           array.push(id)
          })

          let largest = array[0];

         for (let i = 0; i < array.length; i++) {
           if (array[i] > largest) {
             largest = array[i];
           }
         }

          let newTag = {
            id: '',
            name: this.itemVal,
            displayFlag: true,
            action: '',
            activeMore: false,
            actionFlag: false,
            itemExists: false,
            checkFlag:true
          };
          this.actionFlag = false
          console.log(this.listItems[index])
          this.listItems.shift()
          //console.log(this.submitActionFlag)
          this.listItems.unshift(newTag);
          this.headerCheck = 'checked';

          if(this.selection == 'single') {
            this.selectionList = [];
            this.selectionList.push({
              id: '',
              name: this.itemVal,
            });
            this.applySelection('manual')
          } else {
            this.selectionList.push({
              id: '',
              name: this.itemVal,
            })
          }
        } else {
          console.log('duplicate')
          this.listItems[index].itemExists = true;
        }

        break;
        case 'cancel':
          localStorage.removeItem('searchVal');
          this.searchVal = "";
          this.itemVal = "";
          this.actionFlag = false;
          this.submitActionFlag = false;
          console.log(this.headerCheck)
          console.log(this.selectionList)
          if (this.listItems[index].action == 'new') {
            this.listItems.splice(index, 1);
          } else {
            this.listItems[index].action = "";
            this.listItems[index].activeMore = false;
          }
          break;
    }
  }

  manageInternalStatus(action,index) {
    console.log(action, this.inputData)
    switch (action) {
      case 'new':
        if (this.empty) {
          let newFlag: any = true;
          localStorage.setItem('newItem', newFlag);
          this.searchNew = true;
          if(this.listItems.length == 0 && this.inputData.field == 'InternalStatusField'){
            let newTag = {
            id: 0,
            name: '',
            editAccess: 0,
            displayFlag: true,
            action: action,
            activeMore: false,
            actionFlag: false,
            itemExists: false
            };
            this.listItems.unshift(newTag);
            this.empty = false;
          }
          else{
            this.clearSearch(action);
          }
        }
        else {
          if (!this.actionFlag && !this.empty) {
            this.searchNew = false;
            this.actionFlag = true;
            this.itemAction = action;
            let sval = localStorage.getItem('searchVal');
            this.submitActionFlag = (sval == null) ? false : true;
            this.itemVal = sval;
            let newTag = {
              id: 0,
              name: sval,
              editAccess: 0,
              displayFlag: true,
              action: action,
              activeMore: false,
              actionFlag: false,
              itemExists: false
            };
            this.listItems.unshift(newTag);
            let el = document.getElementById('manageTable');
            el.scrollTo(0, 0);
            if (action == 'new' && sval != null) {
              this.checkItemExists(index, sval);
            }
            this.inputFocus();
          }
        }
        break;
      case 'edit':
        if (!this.actionFlag) {
          this.actionFlag = true;
          this.itemAction = action;
          this.itemVal = this.manageList[index].name;
          this.submitActionFlag = true;
          this.manageList[index].action = action;
          this.manageList[index].activeMore = false;
          setTimeout(() => {
            this.inputFocus();
          }, 100);
        }
        break;
      case 'submit':
        const statusValue:string=this.focusInput.nativeElement.value;
        const currentItem = this.manageList[index];
        const isEdit = currentItem.action === 'edit';
        
        // Check for duplicates, excluding the current item if editing
        let duplicateValue = this.manageList.findIndex((x, i) => 
          x?.name?.toLowerCase() === statusValue?.toLowerCase()?.trim() && i !== index
        );
        
        if(duplicateValue == -1) {
          if (isEdit) {
            // Call separate function for update
            this.updateInternalStatus(index, currentItem.id, statusValue?.trim());
          } else {
            // Create new status
            const queryParams={
              userId:this.apiData.userId,
              name:statusValue?.trim(),
              apiKey:this.apiData.apiKey,
              domainId:this.apiData.domainId,
              id:''
            }
            this.commonApi.saveTechInternalStatus(queryParams).subscribe((response) => {
              this.searchVal = '';
              this.success = true;
              this.successMsg = response.result;
              this.manageInternalStatus('cancel', 0);
              this.clearSearch();
              setTimeout(() => {
                this.success = false;
                this.actionFlag = false;
              }, 3000);
            });
          }
        } else {
          this.manageList[index].itemExists = true;
        }

        break;
        case 'cancel':
          localStorage.removeItem('searchVal');
          this.searchVal = "";
          this.itemVal = "";
          this.actionFlag = false;
          this.submitActionFlag = false;
          console.log(this.headerCheck)
          console.log(this.selectionList, index, this.manageList[index].action)
          if (this.manageList[index].action == 'new') {
            this.manageList.splice(index, 1);
          } else {
            this.manageList[index].action = "";
            this.manageList[index].activeMore = false;
            this.manageList[index].itemExists = false;
          }
          break;
    }
  }

  // Update Internal Status
  updateInternalStatus(index, id, name) {
    let apiUrl = (this.apiData.platformId == 1) ? Constant.CollabticApiUrl : Constant.CbaApiUri;
    const queryParams = {
      userId: this.apiData.userId,
      name: name,
      apiKey: this.apiData.apiKey,
      domainId: this.apiData.domainId,
      id: id
    };
    
    this.commonApi.saveTechInternalStatus(queryParams).subscribe((response) => {
      console.log("updateInternalStatus: ", response);
      if(response.status == 'Success' || response.result){
        this.searchVal = '';
        this.success = true;
        this.successMsg = response.result || 'Internal status updated successfully';
        this.manageList[index].name = name;
        this.manageList[index].action = '';
        this.actionFlag = false;
        this.itemVal = '';
        setTimeout(() => {
          this.success = false;
        }, 3000);
      } else {
        // Handle error
        // this.success = true;
        // this.successMsg = response.message || 'Failed to update internal status';
        // setTimeout(() => {
        //   this.success = false;
        // }, 3000);
      }
    }, (error) => {
      console.error('Error updating internal status:', error);
      // this.success = true;
      // this.successMsg = 'An error occurred while updating the internal status';
      // this.manageList[index].itemExists = true;
      // setTimeout(() => {
      //   this.success = false;
      // }, 3000);
    });
  }

  // Remove Internal Status Confirmation
  removeInternalStatusConfirm(index, id, name) {
    this.bodyElem.classList.add("auth-open-remove-popup");
    const modalRef = this.modalService.open(ConfirmationComponent, this.modalConfig);
    modalRef.componentInstance.access = 'ppfrconfirmation';
    modalRef.componentInstance.title = '';
    modalRef.componentInstance.confirmAction.subscribe((receivedService) => {
      modalRef.dismiss('Cross click');
      console.log(receivedService);
      if(receivedService){
        console.log("removeInternalStatusConfirm: ", {index, id, name});
        this.deleteInternalStatus(index, id, name);
      }
    });
  }

  // Delete Internal Status
  deleteInternalStatus(index, id, name) {
    let apiUrl = (this.apiData.platformId == 1) ? Constant.CollabticApiUrl : Constant.CbaApiUri;
    const queryParams = {
      userId: this.apiData.userId,
      apiKey: this.apiData.apiKey,
      domainId: this.apiData.domainId,
      id: id
    };
    
    this.commonApi.deleteTechInternalStatus(queryParams, apiUrl).subscribe((response) => {
      console.log("deleteInternalStatus: ", response);
      if(response.status == 'Success'){
        this.success = true;
        this.successMsg = response.result || 'Internal status deleted successfully';
        
        // Remove from manageList
        this.manageList.splice(index, 1);
        
        // Remove from selectionList if it was selected
        let rmIndex = this.selectionList.findIndex(option => option.id == id);
        if (rmIndex >= 0) {
          this.selectionList.splice(rmIndex, 1);
        }
        
        // Update header check state
        setTimeout(() => {
          this.headerCheck = (this.selectionList.length == 0) ? 'unchecked' : 
                            (this.selectionList.length == this.manageList.length) ? 'all' : 'checked';
          this.headercheckDisplay = (this.selectionList.length == 0) ? 'checkbox-hide' : 'checkbox-show';
          this.success = false;
        }, 3000);
      } else {
        // Handle error
        // this.success = true;
        // this.successMsg = response.message || 'Failed to delete internal status';
        // setTimeout(() => {
        //   this.success = false;
        // }, 3000);
      }
    }, (error) => {
      console.error('Error deleting internal status:', error);
      // this.success = true;
      // this.successMsg = 'An error occurred while deleting the internal status';
      // setTimeout(() => {
      //   this.success = false;
      // }, 3000);
    });
  }

  // Add, Edit, Cancel Item
  manageItem(action, index) {
    console.log(action, index, this.empty, this.actionFlag);
    switch (action) {
      case 'new':
        if (this.empty) {
          let newFlag: any = true;
          localStorage.setItem('newItem', newFlag);
          this.searchNew = true;
          if((this.listItems.length == 0)){
            let newTag = {
            id: 0,
            name: '',
            editAccess: 0,
            displayFlag: true,
            action: action,
            activeMore: false,
            actionFlag: false,
            itemExists: false
            };
            this.listItems.unshift(newTag);
            this.empty = false;
          }
          else{
            this.clearSearch(action);
          }
        }
        else {
          if (!this.actionFlag && !this.empty) {
            this.searchNew = false;
            this.actionFlag = true;
            this.itemAction = action;
            let sval = localStorage.getItem('searchVal');
            this.submitActionFlag = (sval == null) ? false : true;
            this.itemVal = sval;
            let newTag = {
              id: 0,
              name: sval,
              editAccess: 0,
              displayFlag: true,
              action: action,
              activeMore: false,
              actionFlag: false,
              itemExists: false
            };
            this.listItems.unshift(newTag);
            let el = document.getElementById('manageTable');
            el.scrollTo(0, 0);
            if (action == 'new' && sval != null) {
              this.checkItemExists(index, sval);
            }
            this.inputFocus();
          }
        }
        break;
      case 'edit':
        this.itemAction = action;
        this.actionFlag = true;
        this.submitActionFlag = true;
        this.itemVal = this.listItems[index].name;
        this.listItems[index].action = action;
        let rmIndex = 0;
        if (this.listItems[rmIndex].action == 'new') {
          index = index - 1;
          this.listItems.splice(rmIndex, 1);
        }

        /*this.selectionList = [];
        this.headerCheck = 'unchecked';
        this.headercheckDisplay = 'checkbox-hide';*/

        for (let m in this.listItems) {
          this.listItems[m].action = (index != m) ? '' : 'edit';
          //this.listItems[m].checkFlag = false;
        }

        break;
      case 'cancel':
        localStorage.removeItem('searchVal');
        this.searchVal = "";
        this.itemVal = "";
        this.actionFlag = false;
        this.submitActionFlag = false;
        console.log(this.headerCheck)
        console.log(this.selectionList)
        if (this.listItems[index].action == 'new') {
          this.listItems.splice(index, 1);
        } else {
          this.listItems[index].action = "";
          this.listItems[index].activeMore = false;
        }
        break;
      case 'submit':
        console.log(this.listItems[index])
        console.log(this.apiData, this.itemVal)
        //console.log(this.submitActionFlag)
        if (this.submitActionFlag) {
          let id = this.listItems[index].id;
          let editAction: any = (id > 0) ? 1 : 0;
          let apiData = {
            apiKey: this.apiData['apiKey'],
            userId: this.apiData['userId'],
            domainId: this.apiData['domainId'],
            countryId: this.apiData['countryId'],
            isEdit: editAction,
            isValidate: 0
          };
          if (id > 0) {
            if(this.inputData.field == 'folders'){
              apiData['folderId'] = id;
              apiData['oldFolderName'] = this.listItems[index].name;
            }
            else{
              apiData['id'] = id;
              if(this.inputData.field == 'other-payment'){
                apiData['name'] = this.itemVal;
              }
              if(this.inputData.field == 'usetype-businessname'){
                apiData['name'] = this.itemVal;
                apiData['userType'] = this.apiData['userType'];
              }
            }
          }
          else{
            if(this.inputData.field == 'other-payment'){
               apiData['name'] = this.itemVal;
            }
            if(this.inputData.field == 'usetype-businessname'){
               apiData['name'] = this.itemVal;
               apiData['userType'] = this.apiData['userType'];
            }
          }
          if(this.inputData.field == 'keyword'){
            apiData['tagName'] = this.itemVal;
            apiData['tagId'] = id;
          }
          if(this.inputData.field == 'manufacturer' || this.inputData.field == 'softwareUpdate' ||  this.inputData.field == 'programNewModule'){
            apiData['type'] = this.inputData.field;
            apiData['name'] = this.itemVal;
            if (id > 0) {
              apiData['id'] = id;
            }
          }
          if(this.inputData.field == 'additional'){
            apiData['type'] = '';
            apiData['view'] = 3;
            apiData['id'] = '';
            apiData['isActive'] = '';
            apiData['name'] = this.itemVal;
            apiData['limit'] = 20;
            apiData['offset'] = 0;
            apiData['platform'] = 1;
            apiData['searchKey'] = '';
          }

          switch (this.inputData.field) {
            case 'adasSystem':
            case 'jobListRO':  
              apiData['action'] = 'new';
              apiData['name'] = this.itemVal;
              break;
            case 'model':
            case 'PartModel':
              apiData['MakeName'] = this.apiData.makeName;
              apiData['ModelName'] = this.itemVal;
              break;
            case 'colour':
              if (id > 0) {
                apiData['colorValueId'] = id;
              }
              apiData['colorValueName'] = this.itemVal;
              apiData['workstreamList'] = [];
              break;
            case 'info-1':
            case 'info-2':
            case 'info-3':
            case 'info-4':
            case 'info-5':
            case 'info-6':
            case 'info-7':
              if (id > 0) {
                apiData['infoId'] = id;
              }
              apiData['infoName'] = this.itemVal;
              apiData['workstreamList'] = [];
              this.listItems[index].name = this.itemVal;
              break;
            case 'folders':
              if (id > 0) {
                //apiData['folderId'] = id;
              }
            default:
              let query = this.inputData.actionQueryValues;
              if (query != '') {
                let queryVal = JSON.parse(query);

                if(this.inputData.field == 'serialNo'){
                  if (id > 0) {
                    apiData[queryVal[0]] = id;
                  }
                  console.log("apiData" + (JSON.stringify(apiData)));
                  apiData[queryVal[1]] = this.itemVal;
                  apiData['dealerCode'] = localStorage.getItem('kia-serial-dealerCode');
                  if(localStorage.getItem('kia-serial-dealerInfo') == '0'){
                    apiData['dealerName'] = localStorage.getItem('kia-serial-dealerName');
                  }
                  if(localStorage.getItem('kia-serial-userInfo') == '0'){
                    apiData['userFirstName'] = localStorage.getItem('kia-serial-userFirstName');
                    apiData['userLastName'] = localStorage.getItem('kia-serial-userLastName');
                    apiData['userPhoneNo'] = localStorage.getItem('kia-serial-userPhoneNo');
                    apiData['userEmail'] = localStorage.getItem('kia-serial-userEmail');
                    apiData['userTitle'] = localStorage.getItem('kia-serial-userTitle');
                  }
                  console.log("apiData" + (JSON.stringify(apiData)));
                }
                else{
                  if (id > 0) {
                    apiData[queryVal[0]] = id;
                  }
                  apiData[queryVal[1]] = this.itemVal;
                  apiData[queryVal[2]] = '';
                  apiData['workstreamList'] = JSON.stringify(this.ws);
                }
                queryVal.forEach(q => {
                  switch (q) {
                    case 'commonApiValue':
                      apiData[q] = this.commonApiValue;
                      break;
                  }
                });
              }
              break;
          }
          this.manageAction(index, apiData);
        }
        break;
    }
  }

  // Add, Edit, Cancel Tag
  manageTag(action, index) {
    console.log(this.actionFlag, action, this.empty)
    switch (action) {
      case 'new':
        if (this.empty) {
          this.searchNew = true;
          let newFlag: any = true;
          localStorage.setItem('newItem', newFlag);
          //if (!this.empty)
          this.clearSearch(action);
        } else {
          if (!this.actionFlag && !this.empty) {
            this.searchNew = false;
            this.actionFlag = true;
            this.itemAction = action;
            let sval = localStorage.getItem('searchVal');
            this.submitActionFlag = (sval == null) ? false : true;
            this.itemVal = sval;
            let newTag = {
              id: 0,
              name: sval,
              editAccess: 0,
              displayFlag: true,
              action: action,
              activeMore: false,
              actionFlag: false,
              itemExists: false
            };
            this.listItems.unshift(newTag);
            let el = document.getElementById('manageTable');
            el.scrollTo(0, 0);
            if (action == 'new' && sval != null) {
              this.checkTagExists(index, sval);
            }
            this.inputFocus();
          }
        }
        break;
      case 'edit':
        this.itemAction = action;
        this.actionFlag = true;
        this.submitActionFlag = true;
        this.itemVal = this.listItems[index].name;
        this.listItems[index].action = action;
        let rmIndex = 0;
        if (this.listItems[rmIndex].action == 'new') {
          this.listItems.splice(rmIndex, 1);
          index = index - 1;
        }

        /*this.selectionList = [];
        this.headerCheck = 'unchecked';
        this.headercheckDisplay = 'checkbox-hide';*/

        for (let m in this.listItems) {
          this.listItems[m].action = (index != m) ? '' : 'edit';
          //this.listItems[m].checkFlag = false;
        }

        break;
      case 'cancel':
        localStorage.removeItem('searchVal');
        this.searchVal = "";
        this.itemVal = "";
        this.actionFlag = false;
        this.submitActionFlag = false;
        console.log(this.headerCheck)
        console.log(this.selectionList)
        if (this.listItems[index].action == 'new') {
          this.listItems.splice(index, 1);
        } else {
          this.listItems[index].action = "";
          this.listItems[index].activeMore = false;
        }
        break;
      case 'submit':
        console.log(this.listItems[index])
        //console.log(this.submitActionFlag)
        if (this.submitActionFlag) {
          let id = this.listItems[index].id;
          let apiData = {
            'apiKey': this.apiData['apiKey'],
            'userId': this.apiData['userId'],
            'domainId': this.apiData['domainId'],
            'countryId': this.apiData['countryId'],
            'tagName': this.itemVal,
            'id': id
          };
          this.manageAction(index, apiData);
        }
        break;
    }
  }

  manageLoopUpData(action, index) {
    //console.log(action)
    switch (action) {
      case 'new':
        if (this.empty) {
          this.searchNew = true;
          this.clearSearch();
          //this.getTagInfo(index);
          setTimeout(() => {
            this.empty = false;
            this.submitActionFlag = true;
          }, 750);
        }

        if (!this.actionFlag && !this.empty) {
          this.searchNew = false;
          this.actionFlag = true;
          this.itemAction = action;
          let sval = localStorage.getItem('searchVal');
          this.submitActionFlag = (sval == null) ? false : true;
          this.itemVal = sval;
          let newTag = {
            id: 0,
            name: sval,
            editAccess: 0,
            displayFlag: true,
            action: action,
            activeMore: false,
            actionFlag: false,
            itemExists: false
          };
          this.listItems.unshift(newTag);
          let el = document.getElementById('manageTable');
          el.scrollTo(0, 0);
          this.inputFocus();
        }
        break;
      case 'edit':
        this.itemAction = action;
        this.actionFlag = true;
        this.submitActionFlag = true;
        this.itemVal = this.listItems[index].name;
        this.listItems[index].action = action;
        let rmIndex = 0;
        if (this.listItems[rmIndex].action == 'new') {
          index = index - 1;
          this.listItems.splice(rmIndex, 1);
        }

        /*this.selectionList = [];
        this.headerCheck = 'unchecked';
        this.headercheckDisplay = 'checkbox-hide';*/

        for (let m in this.listItems) {
          this.listItems[m].action = (index != m) ? '' : 'edit';
          //this.listItems[m].checkFlag = false;
        }

        break;
      case 'cancel':
        localStorage.removeItem('searchVal');
        this.searchVal = "";
        this.itemVal = "";
        this.actionFlag = false;
        this.submitActionFlag = false;
        console.log(this.headerCheck)
        console.log(this.selectionList)
        if (this.listItems[index].action == 'new') {
          this.listItems.splice(index, 1);
        } else {
          this.listItems[index].action = "";
          this.listItems[index].activeMore = false;
        }
        break;
      case 'submit':
        console.log(this.listItems[index])
        //console.log(this.submitActionFlag)
        if (this.submitActionFlag) {
          let id = this.listItems[index].id;
          let apiData = {
            'apiKey': this.apiData['apiKey'],
            'userId': this.apiData['userId'],
            'domainId': this.apiData['domainId'],
            'countryId': this.apiData['countryId'],
            'lookUpdataName': this.itemVal,
            'lookUpTableId': this.apiData['lookUpdataId'],
            'selectionList': '',
            'isInActive': this.activeListshow,
            'id': id,
            'title': this.title
          };

          this.manageAction(index, apiData);
        }
        break;
      case 'disable':
        //console.log(this.listItems[index])
        //console.log(this.submitActionFlag)

        // let id = this.listItems[index].id;
        let apiData = {
          'apiKey': this.apiData['apiKey'],
          'userId': this.apiData['userId'],
          'domainId': this.apiData['domainId'],
          'countryId': this.apiData['countryId'],
          'lookUpdataName': '',
          'selectionList': JSON.stringify(this.selectionList),
          'isInActive': this.activeListshow,
          'lookUpTableId': this.apiData['lookUpdataId'],
          'title': this.title
        };

        this.manageAction(index, apiData);

        break;
    }
  }

  applychangeValue(event) {
    if (event.value.name == 'In Active') {
      this.activeListshow = false;
      this.getLookUpInfo(0);
      this.selectionList = [];
    }
    if (event.value.name == 'Active') {
      this.selectionList = [];
      this.activeListshow = true;
      this.getLookUpInfo(0);
    }

  }
  applySelectionActive() {
    this.selectionList = [];
    this.activeListshow = true;
    this.getLookUpInfo(0);
  }
  applySelectionInActive() {
    this.activeListshow = false;
    this.getLookUpInfo(0);
    this.selectionList = [];
  }

  // Add, Edit, Cancel Tag
  manageErrorCode(action, index) {
    //console.log(action)
    switch (action) {
      case 'new':
        if (this.empty) {
          this.itemCode = "";
          this.itemVal = "";
          this.searchNew = true;
          let newFlag: any = true;
          localStorage.setItem('newItem', newFlag);
          this.clearSearch(action);
        } else {
          if (!this.actionFlag && !this.empty) {
            this.searchNew = false;
            this.actionFlag = true;
            this.itemAction = action;
            let sval = localStorage.getItem('searchVal');
            this.submitActionFlag = (sval == null) ? false : true;
            this.itemVal = sval;
            let newErrorCode = {
              id: 0,
              name: sval,
              editAccess: 1,
              displayFlag: true,
              action: action,
              activeMore: false,
              actionFlag: false,
              itemExists: false
            };
            this.listItems.unshift(newErrorCode);
            let el = document.getElementById('manageTable');
            el.scrollTo(0, 0);
            this.inputFocus();
          }
        }
        break;
      case 'edit':
        this.itemAction = action;
        this.actionFlag = true;
        this.submitActionFlag = true;
        console.log(this.listItems)
        this.itemCode = this.listItems[index].code;
        this.itemVal = this.listItems[index].desc;
        this.listItems[index].action = action;
        let rmIndex = 0;
        if (this.listItems[rmIndex].action == 'new') {
          index = index - 1;
          this.listItems.splice(rmIndex, 1);
        }

        /*this.selectionList = [];
        this.headerCheck = 'unchecked';
        this.headercheckDisplay = 'checkbox-hide';*/

        for (let m in this.listItems) {
          this.listItems[m].action = (index != m) ? '' : 'edit';
          //this.listItems[m].checkFlag = false;
        }

        break;
      case 'cancel':
        localStorage.removeItem('searchVal');
        this.searchVal = "";
        this.itemCode = "";
        this.itemVal = "";
        this.actionFlag = false;
        this.submitActionFlag = false;
        console.log(this.headerCheck)
        console.log(this.selectionList)
        if (this.listItems[index].action == 'new') {
          this.listItems.splice(index, 1);
        } else {
          this.listItems[index].action = "";
          this.listItems[index].activeMore = false;
        }
        break;
      case 'submit':
        if (this.submitActionFlag) {
          let id = this.listItems[index].id;
          let apiData = {
            'apiKey': this.apiData['apiKey'],
            'userId': this.apiData['userId'],
            'domainId': this.apiData['domainId'],
            'countryId': this.apiData['countryId'],
            'id': id
          };

          if (this.access == 'New Parts' || this.access == 'techinfo') {
            let queryVal = JSON.parse(this.inputData.actionQueryValues);
            apiData[queryVal[1]] = this.itemCode;
            apiData[queryVal[2]] = this.itemVal;
            apiData[queryVal[3]] = this.access == 'techinfo' ? localStorage.getItem('dealerCode') : this.vehicle;
            apiData['isValidate'] = 0;
          }

          console.log(apiData)


          this.manageAction(index, apiData);
        }
        break;
    }
  }

  // Manage Action
  manageAction(index, apiData) {
    this.offset = 0;
    this.itemLength = 0;
    this.scrollInit = 0;
    this.lastScrollTop = 0;
    this.scrollCallback = true;
    //console.log(index);
    switch (this.access) {
      case 'Tags':
      case 'New Thread Tags':
        let tagData = new FormData();
        let isValidate: any = 0;
        let name = this.itemVal;
        tagData.append('apiKey', apiData.apiKey);
        tagData.append('userId', apiData.userId);
        tagData.append('domainId', apiData.domainId);
        tagData.append('countryId', apiData.countryId);
        tagData.append('tagName', apiData.tagName);
        tagData.append('workstreamList', JSON.stringify(this.ws));
        tagData.append('vehicleInfo', this.vehicle);
        tagData.append('isValidate', isValidate);
        if (apiData.id > 0) {
          let tagIndex = apiData.id;
          tagData.append('tagId', apiData.id);
        }
        let callAbleUrl = this.commonApi.manageTag(tagData);
        if (this.pageType == 'market-place') {
          if (apiData.id > 0) {
            callAbleUrl = this.commonApi.updateTagMarketPlace(tagData);
          } else {
            callAbleUrl = this.commonApi.manageTagMarketPlace(tagData);
          }
        }
        if (this.pageType == 'video-library-category') {
          if (apiData.id > 0) {
            callAbleUrl = this.commonApi.updateCategoryVideoLibrary(tagData);
          } else {
            callAbleUrl = this.commonApi.apiVideoCategoryAdd(tagData);
          }
        }
        if (this.pageType == 'video-library-tags') {
          if (apiData.id > 0) {
            callAbleUrl = this.commonApi.updateTagVideoLibrary(tagData);
          } else {
            callAbleUrl = this.commonApi.apiVideoTagAdd(tagData);
          }
        }

        callAbleUrl.subscribe((response) => {
          this.newTagOptFlag = true;
          this.searchVal = '';
          this.success = true;
          this.successMsg = response.result;
          let successMessage = response.message;
          if (this.pageType == 'market-place' || this.pageType == 'video-library-category' || this.pageType == 'video-library-tags') {
            this.success = true;
            /*const msgModalRef = this.modalService.open(
              SuccessModalComponent,
              this.config
            );
            msgModalRef.componentInstance.successMessage = successMessage;*/
            this.successMsg = successMessage;
            setTimeout(() => {
              this.success = false;
             // msgModalRef.dismiss("Cross click");
            }, 2000);
          }
          setTimeout(() => {
            this.success = false;
            this.actionFlag = false;
          }, 3000);
          console.log(response);
          let id = response.dataId || response.data;
          let actionFlag = (response.status == 'Success') ? true : false;
          let checkIndex = this.selectionList.findIndex(option => option.id == id);
          console.log(checkIndex + ' :: ' + this.itemVal + '::' + id)
          if (checkIndex < 0) {
            this.filteredTags.push(id);
            this.actionItems.push(id);
            //if (this.pageType != 'market-place') {
              this.filteredLists.push(this.itemVal);
            //}
          }
          let i = -1;
          this.getTagInfo(i);
        });
        break;

      case 'LookupDataPM':
        case 'Countries':
        let lookupData = new FormData();
        let isValidatev: any = 0;
        this.clearSelection();
        lookupData.append('apiKey', apiData.apiKey);
        lookupData.append('userId', apiData.userId);
        lookupData.append('domainId', apiData.domainId);
        lookupData.append('countryId', apiData.countryId);
        lookupData.append('lookUpdataName', apiData.lookUpdataName);
        lookupData.append('lookUpTableId', apiData.lookUpTableId);
        lookupData.append('disabledDomain', apiData.selectionList);
        lookupData.append('isInActive', apiData.isInActive);

        lookupData.append('title', apiData.title);

        lookupData.append('workstreamList', JSON.stringify(this.ws));
        lookupData.append('vehicleInfo', this.vehicle);
        lookupData.append('isValidate', isValidatev);
        if (apiData.id > 0) {
          let tagIndex = apiData.id;
          lookupData.append('lookUpdataId', apiData.id);
        }

        this.commonApi.ManageLookUpdata(lookupData).subscribe((response) => {
          this.searchVal = '';
          this.success = true;
          this.successMsg = response.result;
          setTimeout(() => {
            this.success = false;
            this.actionFlag = false;
            this.selectionList = [];

          }, 3000);
          let id = response.dataId;
          let actionFlag = (response.status == 'Success') ? true : false;
          let checkIndex = this.selectionList.findIndex(option => option.id == id);
          console.log(checkIndex + ' :: ' + this.itemVal)
          if (checkIndex < 0) {
            this.filteredTags.push(id);
            this.actionItems.push(id);
          }
          this.getLookUpInfo(index);
        });
        break;

      case 'Error Codes':
      case 'New Thread Error Codes':
        let errData = new FormData();
        let isValidateErr: any = 0;
        let code = this.itemCode;
        let desc = this.itemVal;
        errData.append('apiKey', apiData.apiKey);
        errData.append('userId', apiData.userId);
        errData.append('domainId', apiData.domainId);
        errData.append('countryId', apiData.countryId);
        errData.append('workstreamList', JSON.stringify(this.ws));
        errData.append('vehicleInfo', this.vehicle);
        errData.append('isValidate', isValidateErr);
        errData.append('errorCode', code);
        errData.append('errorDesc', desc);
        if(this.apiData.threadCategoryId != '') {
          errData.append('threadCategoryId', this.apiData.threadCategoryId);
        }
        if (apiData.id > 0) {
          let tagIndex = apiData.id;
          errData.append('errorCodeId', apiData.id);
        }

        this.commonApi.manageErrorCode(errData).subscribe((response) => {
          this.searchVal = '';
          this.success = true;
          this.successMsg = response.result;
          setTimeout(() => {
            this.success = false;
            this.actionFlag = false;
          }, 3000);
          let id = response.dataId;
          let actionFlag = (response.status == 'Success') ? true : false;
          let checkIndex = this.selectionList.findIndex(option => option.id == id);
          console.log(checkIndex + ' :: ' + this.itemVal)
          if (checkIndex < 0) {
            this.filteredErrorCodes.push(id);
            this.actionItems.push(id);
          }
          let i = -1;
          this.getErrorCodes(i);
        });
        break;
      case 'additionalSystems':
      case 'newthread':
      case 'newAdasSystem':
      case 'New Parts':
      case 'techinfo':
      case 'jobListRO':  
        console.log(apiData)
        let apiUrl = (this.access == 'jobListRO') ? `${this.inputData.baseV3ApiUrl}` : `${this.inputData.baseApiUrl}`;
        let body: HttpParams = new HttpParams();
        switch (this.inputData.field) {
          case 'category':
            apiData['categoryName'] = this.itemVal;
            apiData['workstreams'] = this.apiData["workstreamsList"];
            if(this.pageType == 'parts'){
              apiUrl = `${apiUrl}/parts/SaveCategoryFolder`;
            }
            else{
              apiUrl = `${apiUrl}/softwaredl/SaveCategoryFolder`;
            }
          break;
          case 'zone':
            //apiData['zone'] = this.itemVal;
            //apiUrl = `${apiUrl}/softwaredl/SaveCategoryFolder`;
          break;
          case 'jobListRO':
            apiUrl = `${apiUrl}/${this.inputData.actionApiName}`;
            break;          
          case 'keyword':
            apiData['tagName'] = apiData.tagName;
            if(apiData.id>0){
              apiData['tagId'] = apiData.tagId;
            }
            apiData['groupId'] = this.apiData["groupId"];
            apiUrl = `${apiUrl}/forum/SaveKeyWordPriority`;
          break;
          case 'cba-manufacturer':
          case 'softwareUpdate':
          case 'programNewModule':
            apiData['name'] = apiData.name;
            apiData['type'] = this.inputData.field;
            if(apiData.id>0){
              apiData['id'] = apiData.id;
            }
            apiUrl = `${apiUrl}/diagnostic-programming-capabilities/manageinput`;
          break;
          case 'folders':
            apiData['workstreams'] = this.apiData["workstreamsList"];
            apiData['folderName'] = this.itemVal;
            apiUrl = `${apiUrl}/resources/SaveDocumentFolder`;
          break;
          case 'colour':
            apiUrl = `${apiUrl}/parts/SavecolorValue`;
            break;
          case 'model':
          case 'PartModel':
            apiUrl = `${apiUrl}/Productmatrix/SaveproductMatrix`;
            break;
          case 'info-1':
          case 'info-2':
          case 'info-3':
          case 'info-4':
          case 'info-5':
          case 'info-6':
          case 'info-7':
            apiUrl = `${apiUrl}/parts/SaveAdditionalInfo`;
            break;
          default:
            apiUrl = `${apiUrl}/${this.inputData.actionApiName}`;
            break;
        }
        Object.keys(apiData).forEach(key => {
          let value = apiData[key];
          console.log(key,value);
          if(key == 'workstreams' && Array.isArray(value)){
            body = body.append(key, JSON.stringify(value));
          } else {
            body = body.append(key, value);
          }
        });

        console.log(apiUrl, apiData)

        this.commonApi.apiCall(apiUrl, body).subscribe((response) => {
          console.log(response);
          this.searchVal = '';
          this.success = true;
          this.successMsg = response.result;
          if(this.inputData.field == 'folders'){
            let type = (apiData.isEdit==1) ? 'edit' : 'new';
            let id =  (apiData.isEdit==1) ? response.dataId : response.documentId;
            this.updatesolr(type,id);
          }
          if(this.inputData.field == 'category'){
            let type = (apiData.isEdit==1) ? 'edit' : 'new';
            let id =  (apiData.isEdit==1) ? response.dataId : response.documentId;
            this.updateCatgsolr(type,id);
          }
          if(this.inputData.field == 'serialNo'){
            if(response.dealerCode != undefined && response.dealerCode != '' ){
              localStorage.setItem('resDealerCode',response.dealerCode);
            }
            if(response.dealerUserId != undefined && response.dealerUserId != '' ){
              localStorage.setItem('resDealerUserId',response.dealerUserId);
            }
            else{
              localStorage.removeItem('resDealerUserId');
            }
          }
          setTimeout(() => {
            this.success = false;
            this.actionFlag = false;
            if(this.inputData.field == 'serialNo'){
              this.manageListItem('cancel', 0);
            }
          }, 3000);
          let id;
          let flag = true;
          switch (this.inputData.field) {
            case 'jobListRO':
              id = response.data.id;
              break;
            case 'adasSystem':
              id = response.data;
              break;
            case 'model':
            case 'PartModel':
              id = response.modelId;
              break;
            case 'colour':
            case 'info-1':
            case 'info-2':
            case 'info-3':
            case 'info-4':
            case 'info-5':
            case 'info-6':
            case 'info-7':
              flag = false;
              id = response.dataId;
              break;
            default:
              flag = (this.inputData.selectionType == 'single') ? false : true;
              if(this.inputData.field == 'category'){
                id = response.dataId;
                //id = ""; // selection category if create new
              }
              else{
                id = response.dataId;
              }
              break;
          }
          let checkIndex = this.selectionList.findIndex(option => option.id == id);
          console.log(this.filteredTags, checkIndex + ' :: ' + this.itemVal + '::' + id)
          if (checkIndex < 0 && flag) {
            this.filteredTags.push(id);
            this.actionItems.push(id);
            switch(this.inputData.field) {
              case 'category':
                case 'zone':
              case 'folders':
              case 'complaintCategory':
              case 'symptom':
              case 'SystemSelection':
                let filterIndex = this.filteredLists.findIndex(option => option == this.itemVal);
                if(filterIndex < 0) {
                  this.filteredLists.push(this.itemVal);
                }
                break;
              case 'adasSystem':
                this.successMsg = response.message;
                let cfilterIndex = this.filteredLists.findIndex(option => option == this.itemVal);
                if(cfilterIndex < 0) {
                  this.filteredLists.push(this.itemVal);
                }
                break;
              case 'keyword':
                if (this.pageType != 'market-place') {
                  this.filteredLists.push(this.itemVal);
                }
                break;
            }
          }

          if(this.inputData.field == 'category'){
            this.getCatgInfo(index);
          }
          else if(this.inputData.field == 'zone'){
            this.getZoneInfo(index);
          }
          else if(this.inputData.field == 'keyword'){
            this.getKeywordInfo(index);
          }
          else if(this.inputData.field == 'cba-manufacturer' || this.inputData.field == 'softwareUpdate' ||  this.inputData.field == 'programNewModule'){
            this.getDiagnosticInfo(index);
          }
          else if(this.inputData.field == 'folders'){
            localStorage.setItem('documentRefresh','1');
            let i = -1;
            this.getFolderInfo(i);
          } else if(this.inputData.field == 'jobListRO') {
            this.getJobsData(index);
          } else{
            this.getData(index);
          }
        });
        break;
    }
  }

  // Clear Selection
  clearSelection() {
    this.headerCheck = 'unchecked';
    this.headercheckDisplay = 'checkbox-hide';
    this.selectionList = [];
    switch (this.access) {
      case 'Tags':
      case 'New Thread Tags':
      case 'Error Codes':
      case 'New Thread Error Codes':
        this.clearFlag = true;
        break;
      case 'newthread':
      case 'newAdasSystem':
        if (this.inputData.field == 'escalationLookup') {
          this.clearFlag = true;
        }
    }
    this.itemChangeSelection(this.headerCheck);
  }

  // On Change
  onChange(field, index, value, vid = '') {
    let checkFlag;
    switch (this.access) {
      case 'Tags':
      case 'New Thread Tags':
        if (value.length > 0) {
          this.checkTagExists(index, value);
        } else {
          if (this.listFlag) {
            this.listFlag.unsubscribe();
          }
          this.itemVal = "";
          this.listItems[index].itemExists = false;
          this.submitActionFlag = false;
        }
        break;
      case 'LookupDataPM':
        case 'Countries':
        if (value.length > 0) {
          this.checkLookupExists(index, value, vid);
        } else {
          if (this.listFlag) {
            this.listFlag.unsubscribe();
          }
          this.itemVal = "";
          this.listItems[index].itemExists = false;
          this.submitActionFlag = false;
        }
        break;
      case 'Error Codes':
      case 'New Thread Error Codes':
      case 'New Parts':
        this.listItems[index].itemExists = false;
        this.submitActionFlag = false;
        checkFlag = false;
        if (field == 'code') {
          this.itemCode = value;
          if (value.length > 0 && this.itemVal != null) {
            checkFlag = true;
          } else {
            this.listItems[index].itemExists = false;
            //this.submitActionFlag = false;
          }
        } else {
          this.itemVal = value;
          if (value.length > 0 && this.itemCode != null) {
            checkFlag = true;
          } else {
            this.listItems[index].itemExists = false;
            //this.submitActionFlag = false;
          }
        }

        if (checkFlag) {
          this.checkErrorCodeExists(index, this.itemCode, this.itemVal);
        }
        break;

      case 'techinfo':
        checkFlag = false;
        this.submitActionFlag = false;

        if (field == 'code') {
          this.itemCode = value;
          checkFlag = true;
          if (value.length > 0) {
            checkFlag = true;
          } else {
            this.listItems[index].itemExists = false;
            //this.submitActionFlag = false;
          }
        } else {
          if (value.length >= 10 && this.itemCode != '') {
            this.submitActionFlag = (!this.listItems[index].itemExists) ? true : this.submitActionFlag;
          }
          this.itemVal = value;
        }

        if (checkFlag) {
          this.checkTechInfoExists(index, this.itemCode, this.itemVal);
        }
        break;

      case 'newthread':
      case 'additionalSystems':
      case 'newAdasSystem':
      case 'jobListRO':   
        if (value.length > 0) {
          this.checkItemExists(index, value);
        } else {
          if (this.listFlag) {
            this.listFlag.unsubscribe();
          }
          this.itemVal = "";
          this.listItems[index].itemExists = false;
          this.submitActionFlag = false;
        }
        break;
      case 'identiscan':
        if (value.length > 0) {
          this.submitActionFlag = true;
         this.itemVal = value
        } else {
          this.submitActionFlag = false;
        }
        break;
      case 'InternalStatusAccess':
        if (value.trim().length > 0) {
          this.submitActionFlag = true;
         this.itemVal = value
        } else {
          this.submitActionFlag = false;
        }
        break;
    }
  }

  // Check Tag Exists
  checkTagExists(index, value) {
    let apiData = {
      'apiKey': this.apiData['apiKey'],
      'userId': this.apiData['userId'],
      'domainId': this.apiData['domainId'],
      'countryId': this.apiData['countryId'],
      'name': value,
      'id': this.listItems[index].id
    };

    if (this.listFlag) {
      this.listFlag.unsubscribe();
      this.manageExist(index, apiData);
    } else {
      this.manageExist(index, apiData);
    }
  }

  checkLookupExists(index, value, vid) {
    let apiData = {
      'apiKey': this.apiData['apiKey'],
      'userId': this.apiData['userId'],
      'domainId': this.apiData['domainId'],
      'countryId': this.apiData['countryId'],
      'lookUptableId': this.apiData['lookUpdataId'],
      'lookUpdataId': vid,
      'name': value
    };

    if (this.listFlag) {
      this.listFlag.unsubscribe();
      this.manageExist(index, apiData);
    } else {
      this.manageExist(index, apiData);
    }
  }

  // Check Error Code Exists
  checkErrorCodeExists(index, code, desc) {
    console.log(index)
    let apiData = {
      'apiKey': this.apiData['apiKey'],
      'userId': this.apiData['userId'],
      'domainId': this.apiData['domainId'],
      'countryId': this.apiData['countryId']
    };
    if (this.access == 'New Parts') {
      let queryVal = JSON.parse(this.inputData.actionQueryValues);
      apiData[queryVal[1]] = code;
      apiData[queryVal[2]] = desc;
      apiData['isValidate'] = 1;
    } else {
      apiData['errorCode'] = code;
      apiData['errorDesc'] = desc;
    }
    apiData['errorCodeId'] = (index >= 0) ? this.listItems[index].id : 0;

    if (this.listFlag) {
      this.listFlag.unsubscribe();
      this.manageExist(index, apiData);
    } else {
      this.manageExist(index, apiData);
    }
  }

  // Check Technician Info Exists
  checkTechInfoExists(index, code, phone) {
    let apiData = {
      'apiKey': this.apiData['apiKey'],
      'userId': this.apiData['userId'],
      'domainId': this.apiData['domainId'],
      'countryId': this.apiData['countryId']
    };
    let queryVal = JSON.parse(this.inputData.actionQueryValues);
    apiData[queryVal[0]] = 0;
    apiData[queryVal[1]] = code;
    apiData[queryVal[2]] = (phone == null) ? '' : phone;
    apiData[queryVal[3]] = localStorage.getItem('dealerCode');
    apiData['isValidate'] = 1;
    if (this.listFlag) {
      this.listFlag.unsubscribe();
      this.manageExist(index, apiData);
    } else {
      this.manageExist(index, apiData);
    }
  }

  // Check Exists
  manageExist(index, apiData) {
    console.log(this.access, index)
    let isValidate: any = 1;
    switch (this.access) {
      case 'Tags':
      case 'New Thread Tags':
        let tagData = new FormData();
        tagData.append('apiKey', apiData.apiKey);
        tagData.append('userId', apiData.userId);
        tagData.append('domainId', apiData.domainId);
        tagData.append('countryId', apiData.countryId);
        tagData.append('tagName', apiData.name);
        tagData.append('workstreamList', JSON.stringify(this.ws));
        tagData.append('vehicleInfo', this.vehicle);
        tagData.append('isValidate', isValidate);
        let callAbleUrl = this.commonApi.manageTag(tagData);
        if (this.pageType == 'market-place') {
          console.log("apiData: ", apiData);
          if (apiData.id > 0) {
            tagData.append('tagId', apiData.id);
            callAbleUrl = this.commonApi.updateTagMarketPlace(tagData);
          } else {
            callAbleUrl = this.commonApi.manageTagMarketPlace(tagData);
          }
        }
        if (this.pageType == 'video-library-category') {
          if (apiData.id > 0) {
            tagData.append('tagId', apiData.id);
            callAbleUrl = this.commonApi.updateCategoryVideoLibrary(tagData);
          } else {
            callAbleUrl = this.commonApi.apiVideoCategoryAdd(tagData);
          }
        }
        if (this.pageType == 'video-library-tags') {
          if (apiData.id > 0) {
            tagData.append('tagId', apiData.id);
            callAbleUrl = this.commonApi.updateTagVideoLibrary(tagData);
          } else {
            callAbleUrl = this.commonApi.apiVideoTagAdd(tagData);
          }
        }
        this.listFlag = callAbleUrl.subscribe((response) => {
          this.listItems[index].itemExists = (response.status == 'Success') ? false : true;
          if (!this.listItems[index].itemExists) {
            this.itemVal = apiData.name;
            this.submitActionFlag = (this.itemVal != '') ? true : false;
          } else {
            this.submitActionFlag = false;
          }
        });
        break;

      case 'LookupDataPM':
        let LookupData = new FormData();
        LookupData.append('apiKey', apiData.apiKey);
        LookupData.append('userId', apiData.userId);
        LookupData.append('domainId', apiData.domainId);
        LookupData.append('countryId', apiData.countryId);
        LookupData.append('lookUpdataName', apiData.name);
        LookupData.append('lookUpdataId', apiData.lookUpdataId);

        LookupData.append('lookUpTableId', apiData.lookUptableId);
        LookupData.append('workstreamList', JSON.stringify(this.ws));
        LookupData.append('vehicleInfo', this.vehicle);
        LookupData.append('isValidate', isValidate);

        this.listFlag = this.commonApi.ManageLookUpdata(LookupData).subscribe((response) => {
          this.listItems[index].itemExists = (response.status == 'Success') ? false : true;
          if (!this.listItems[index].itemExists) {
            this.itemVal = apiData.name;
            this.submitActionFlag = (this.itemVal != '') ? true : false;
          } else {
            this.submitActionFlag = false;
          }
        });
        break;

      case 'Error Codes':
      case 'New Thread Error Codes':
        let codeData = new FormData();
        codeData.append('apiKey', apiData.apiKey);
        codeData.append('userId', apiData.userId);
        codeData.append('domainId', apiData.domainId);
        codeData.append('countryId', apiData.countryId);
        codeData.append('errorCode', apiData.errorCode);
        codeData.append('errorDesc', apiData.errorDesc);
        codeData.append('workstreamList', JSON.stringify(this.ws));
        codeData.append('vehicleInfo', this.vehicle);
        codeData.append('isValidate', isValidate);
        if(apiData.errorCodeId > 0) {
          codeData.append('errorCodeId', apiData.errorCodeId);
        }
        if(this.apiData.threadCategoryId != '') {
          codeData.append('threadCategoryId', this.apiData.threadCategoryId);
        }
        this.listFlag = this.commonApi.manageErrorCode(codeData).subscribe((response) => {
          console.log(response, index)
          this.listItems[index].itemExists = (response.status == 'Success') ? false : true;
          if (!this.listItems[index].itemExists) {
            this.itemCode = apiData.errorCode;
            this.itemVal = apiData.errorDesc;
            this.submitActionFlag = (this.itemVal != '') ? true : false;
          } else {
            this.submitActionFlag = false;
          }
        });
        break;

      case 'newthread':
      case 'newAdasSystem':
      case 'additionalSystems':
      case 'New Parts':
      case 'techinfo':
      case 'jobListRO':
        if(this.access == 'jobListRO') {
          apiData['isValidate'] = isValidate;
        }
        console.log(this.inputData, apiData)
        let apiUrl = (this.access == 'jobListRO') ? `${this.inputData.baseV3ApiUrl}` : `${this.inputData.baseApiUrl}`;
        switch (this.inputData.title) {
          case 'Colours':
            apiUrl = `${apiUrl}/parts/SavecolorValue`;
            break;
          case 'Additional Model Info 1':
          case 'Additional Model Info 2':
          case 'Additional Model Info 3':
          case 'Additional Model Info 4':
          case 'Additional Model Info 5':
          case 'Additional Model Info 6':
          case 'Additional Model Info 7':
            apiUrl = `${apiUrl}/parts/SaveAdditionalInfo`;
            break;
          case 'Model':
          case 'model':
          case 'PartModel':
            apiUrl = `${apiUrl}/Productmatrix/CheckMakeModelExist`;
            break;
          case 'Category':
            if(this.pageType == 'parts'){
              apiUrl = `${apiUrl}/parts/SaveCategoryFolder`;
            }
            else{
              apiUrl = `${apiUrl}/softwaredl/SaveCategoryFolder`;
            }
            //apiUrl = `${apiUrl}/softwaredl/SaveCategoryFolder`;
            break;
          case 'Zone':
            //apiUrl = `${apiUrl}/softwaredl/SaveCategoryFolder`;
            break;
          case 'Keyword':
            apiUrl = `${apiUrl}/forum/SaveKeyWordPriority`;
            break;
          case 'cba-manufacturer':
          case 'Software Update':
          case 'Program New Module':
            apiUrl = `${apiUrl}/diagnostic-programming-capabilities/manageinput`;
            break;
          case 'Folder':
            apiUrl = `${apiUrl}/resources/SaveDocumentFolder`;
            break;
          default:
            apiUrl = `${apiUrl}/${this.inputData.actionApiName}`;
            break;

        }

        let field = this.inputData.field;
        let body: HttpParams = new HttpParams();

        let query = this.inputData.actionQueryValues;
        if (query != '') {
          if (field == 'serialNo') {
            apiData['dealerCode'] = localStorage.getItem('kia-serial-dealerCode');
            if(localStorage.getItem('kia-serial-dealerInfo') == '0'){
              apiData['dealerName'] = localStorage.getItem('kia-serial-dealerName');
            }
            if(localStorage.getItem('kia-serial-userInfo') == '0'){
              apiData['userFirstName'] = localStorage.getItem('kia-serial-userFirstName');
              apiData['userLastName'] = localStorage.getItem('kia-serial-userLastName');
              apiData['userPhoneNo'] = localStorage.getItem('kia-serial-userPhoneNo');
              apiData['userEmail'] = localStorage.getItem('kia-serial-userEmail');
              apiData['userTitle'] = localStorage.getItem('kia-serial-userTitle');
            }
          }
        }

        Object.keys(apiData).forEach(key => {
          let value = apiData[key];
          console.log(key,value);
          if(key == 'workstreams' && Array.isArray(value)){
            body = body.append(key, JSON.stringify(value));
          } else {
            body = body.append(key, value);
          }
        });

        console.log(apiUrl, body)
        this.listFlag = this.commonApi.apiCall(apiUrl, body).subscribe((response) => {
          console.log(response, field,apiData);          
          this.listItems[index].itemExists = (response.status == 'Success') ? false : true;          
          if(this.inputData.field == 'usetype-businessname'){
            let wordToValidate = "already exist";
            let matchResult = response.message.toLowerCase().match(new RegExp(`\\b${wordToValidate}\\b`));
            this.listItems[index].itemExists = matchResult ? true : false;   
          }           
          if (!this.listItems[index].itemExists) {    
            let itemVal = '';
            switch (field) {
              case 'jobListRO':
              case 'additional':
              case 'adasSystem':
                itemVal = apiData.name;
                break;
              case 'category':
                itemVal = apiData.categoryName;
                break;
                case 'zone':
                  itemVal = apiData.categoryName;
                  break;
              case 'keyword':
                itemVal = apiData.tagName;
                if (apiData.id > 0) {
                  tagData.append('tagId', apiData.id);
                }
                break;
              case 'other-payment':
                itemVal = apiData.name;
              break;
              case 'usetype-businessname':
                itemVal = apiData.name;
              break;
              case 'cba-manufacturer':
              case 'softwareUpdate':
              case 'programNewModule':
               // tagData.append('type', field);
                itemVal = apiData.name;
                if (apiData.id > 0) {
                  tagData.append('id', apiData.id);
                }
                break;
              case 'folders':
                itemVal = apiData.folderName;
                break;
              case 'colour':
                itemVal = apiData.colorValueName;
                break;
              case 'info-1':
              case 'info-2':
              case 'info-3':
              case 'info-4':
              case 'info-5':
              case 'info-6':
              case 'info-7':
                itemVal = apiData.infoName;
                break;
              case 'Model':
              case 'model':
              case 'PartModel':
                itemVal = apiData.ModelName;
                break;
              default:
                let query = this.inputData.actionQueryValues;
                if (query != '') {
                  let queryVal = JSON.parse(query);
                  if (field == 'parts' || field == 'technicianInfo') {
                    console.log(apiData, queryVal)
                    this.itemCode = apiData[queryVal[1]];
                    itemVal = apiData[queryVal[2]];
                  } else {
                    itemVal = apiData[queryVal[1]];
                  }
                }
                break;
            }
            this.itemVal = itemVal;
            if (field == 'technicianInfo') {
              this.submitActionFlag = (this.itemCode != '' && this.itemVal.length >= 10) ? true : false;
            } else {
              this.itemVal = itemVal;
              this.submitActionFlag = (this.itemVal != '') ? true : false;
            }
          } else {
            this.submitActionFlag = false;
          }
        });
        break;
    }
  }

  // Apply Tag Selection
  applySelection(actionType) {
    if (this.access == 'LookupDataPM') {
      console.log(this.selectionList);
      this.manageListItem('disable', '');
    }
    else {
      console.log(this.filteredTags, this.filteredLists, this.selectionList, this.clearFlag)
      switch (this.inputData.field) {
        case 'additional ':
        case 'complaintCategory ':
          this.selectionList.forEach(item => {
            let id = item.id;
            let name = item.name;
            if(name == 'undefined' || name == undefined) {
              let listIndex = this.listItems.findIndex(option => option.id == id);
              if(listIndex >= 0) {
                item.name = this.listItems[listIndex].name;
              }
            }
          });
          break;
      }
      if (this.clearFlag) {
        this.selectionList = [];
        this.selectedItems.emit(this.selectionList);
        this.activeModal.dismiss('Cross click');
      } else if ((this.headerCheck == 'checked' || this.headerCheck == 'all' || this.filteredTags.length > 0)) {
        console.log(this.access, this.filteredTags, this.filteredLists, this.selectionList)
        if(this.access == 'jobListRO' && this.filteredLists.length > 0 && this.filteredLists.length != this.selectionList.length) {
          this.selectionList.forEach(sitem => {
            let id = sitem.id;
            let findex = this.filteredLists.findIndex(option => option.id == id);
            if(findex < 0) {
              this.filteredLists.push(sitem); 
              this.filteredTags.push(id);
            }
          });
          this.selectionList = this.filteredLists;
        }
        if (this.headerCheck != 'unchecked') {
          let checkArr = ['id', 'name'];
          let unique = this.commonApi.unique(this.selectionList, checkArr);
          if (this.access == 'Error Codes' || this.access == 'New Thread Error Codes') {
            console.log(this.filteredLists, this.selectionList, this.manageList);
            for (let t in this.filteredTags) {
              let eindex = this.manageList.findIndex(option => option.id == this.filteredTags[t]);
              let ename;
              console.log(eindex);
              if (eindex > 0) {
                ename = `${this.manageList[eindex].code}##${this.manageList[eindex].desc}`;
              }
              else {
                ename = '';
              }
              let sindex = this.selectionList.findIndex(option => option.id == this.filteredTags[t]);
              if (sindex < 0) {
                this.selectionList.push({
                  id: this.filteredTags[t],
                  name: this.filteredLists[t],
                  ename: ename
                });
                console.log(eindex);
              }
            }
          } else if (this.access == 'newthread' && this.inputData.field == 'prodCode') {
            for (let t in this.filteredTags) {
              if (this.filteredTags[t].length > 0) {
                this.selectionList.push({
                  id: this.filteredTags[t],
                  name: this.filteredLists[t],
                });
              }
            }
            this.selectionList = unique;
          }
          else if (this.access == 'newthread' && this.inputData.field == 'escalationLookup') {
            for (let t in this.filteredTags) {
              if (this.filteredTags[t].length > 0) {
                this.selectionList.push({
                  id: this.filteredTags[t],
                  name: this.filteredLists[t],
                  productModelsCount: this.filteredModelsCount[t],
                });
              }
            }
            this.selectionList = unique;
          } 
          else if (this.access == 'newthread' && (this.inputData.field == 'roPartNumber' || this.inputData.field == 'roQtyAvailable')) {
            for (let t in this.filteredTags) {
              if (this.filteredTags[t].length > 0) {
                this.selectionList.push({
                  ...(this.filteredLists[t] || {}),
                  id: this.filteredLists[t],
                  name: this.filteredTags[t],
                  desc: this.filteredROPartDesc[t],
                });
              }
            }
            this.selectionList = unique;
          }                   
          else {
            for (let t in this.filteredTags) {
              if (this.filteredTags[t] && this.filteredTags[t].length > 0) {
                this.selectionList.push({
                  id: this.filteredTags[t],
                  name: this.filteredLists[t],
                });
              }
            }
            this.selectionList = unique;
          }
          checkArr = ['id', 'name'];
          unique = this.commonApi.unique(this.selectionList, checkArr);
          this.selectionList = unique;
          if(this.pageAccess == 'adas-procedure' && this.inputData.field == 'model') {
            this.selectionList.forEach(item => {
              let id = item.id;
              let listIndex = this.listItems.findIndex(option => option.id == id);
              console.log(this.listItems[listIndex])
              if(listIndex >= 0) {
                item.name = this.listItems[listIndex].name;
                item.make = this.listItems[listIndex].makeItems[0].id;
              }
            });
          }
          if(this.pageAccess == 'roPartNumber' && this.inputData.field == 'roPartNumber') {
            this.selectionList.forEach(item => {
              let id = item.id;
              let listIndex = this.listItems.findIndex(option => option.id == id);
              console.log(this.listItems[listIndex])
              if(listIndex >= 0) {
                item.name = this.listItems[listIndex].name;
                item.id = this.listItems[listIndex].id;
                item.desc = this.listItems[listIndex].desc;
              }
            });
          }
          if(this.pageAccess == 'roQtyAvailable' && this.inputData.field == 'roQtyAvailable') {
            this.selectionList.forEach(item => {
              let id = item.id;
              let listIndex = this.listItems.findIndex(option => option.id == id);
              console.log(this.listItems[listIndex])
              if(listIndex >= 0) {
                item.name = this.listItems[listIndex].name;
                item.id = this.listItems[listIndex].id;
                item.desc = this.listItems[listIndex].desc;
              }
            });
          }
          this.title = "";
          console.log(this.selectionList)
          if(this.access == 'customerListRO') {
            let custIndex = this.customerList.findIndex(option => option.id == this.selectionList[0].id);
            let customerData = [this.customerList[custIndex]];
            this.selectedItems.emit(customerData);
          } else {
            this.selectedItems.emit(this.selectionList);
          }
          this.activeModal.dismiss('Cross click');
        } else {
          if (this.closeFlag) {
            this.activeModal.dismiss('Cross click');
            setTimeout(() => {
              this.closeFlag = false;
            }, 20);
          }
        }
      } else {
        if (actionType == 'trigger') {
          this.activeModal.dismiss('Cross click');
        }
      }
    }
  }

  close(action = '') {
    this.title = (action == '') ? "" : this.title;
    switch (this.access) {
      case 'customerList':
      if(action == '') {
        this.selectedItems.emit([]);
      }
      break;
      case 'LookupDataPM':
        this.selectedItems.emit(1);
        break;

      /*case 'Tags':
      case 'New Thread Tags':
      case 'newthread':
        //this.activeModal.dismiss('Cross click');
        if(this.selectionList.length == 0 && this.filteredTags.length == 0 || this.clearFlag) {
          this.activeModal.dismiss('Cross click');
        } else {
          this.closeFlag = true;
          this.applySelection('trigger');
        }
        break;

      case 'Error Codes':
      case 'New Thread Error Codes':
        console.log(this.selectionList.length, this.filteredErrorCodes.length);
        if(this.selectionList.length == 0 && this.filteredErrorCodes.length == 0 || this.clearFlag) {
          this.activeModal.dismiss('Cross click');
        } else {
          this.closeFlag = true;
          this.applySelection('trigger');
        }
        break;
      */
      case 'Error Codes':
      case 'New Thread Error Codes':
        console.log(this.selectionList, this.filteredErrorCodes)
        this.selectionList = [];
        this.filteredErrorCodes = [];
        this.activeModal.dismiss('Cross click');
        break;
      default:
        this.activeModal.dismiss('Cross click');
        if (this.access == 'identiscan' && this.inputForNewValue) {
          this.inputForNewValue = false;
          this.listItems.shift()
        }
        break;
    }
  }

  // On Submit
  onSubmit() {
    /*this.submitted = true;
    if (this.searchForm.invalid) {
      return;
    } else {
      this.searchVal = this.searchForm.value.searchKey;
      this.submitSearch();
    }*/
    if(this.filterCall && this.access == 'New Thread Error Codes'){ return false ;}
    console.log(this.searchForm.value)
    this.searchVal = this.searchForm.value.searchKey;
    if (this.searchVal != '') {
      this.searchValOld = this.searchVal;
      this.submitSearch();
    }
  }

  // Search Onchange
  onSearchChange(searchValue: string) {
    if(this.searchValOld == '' && this.searchVal == ''){
      if(this.access == 'identiscan') {
        this.listItems.forEach((res)=>{
          res.displayFlag = true;
        })
      }
      if(this.access == 'roQtyAvailable') {
        this.listItems.forEach((res)=>{
          res.displayFlag = true;
        })
      }
    }
    else{
      this.searchForm.value.searchKey = searchValue;
      this.searchTick = (searchValue.length > 0) ? true : false;
      this.searchClose = this.searchTick;
      this.searchVal = searchValue;
      if(this.filterCall && this.access == 'New Thread Error Codes') {
        console.log(this.manageList)
        let filteredList = this.manageList.filter(option => option.name.toLowerCase().indexOf(this.searchVal.toLowerCase()) !== -1);
        if(filteredList.length > 0) {
          this.empty = false;
          for(let t in this.listItems) {
            this.listItems[t].displayFlag = false;
            for(let f in filteredList) {
              if(this.listItems[t].name == filteredList[f].name) {
                this.listItems[t].displayFlag = true;
              }
            }
          }
        } else {
          this.empty = true;
          this.successMsg = "No Result Found";
        }
      } else {
        if (searchValue.length == 0) {
          this.submitted = false;
          if (this.listTotal != this.manageList.length || (this.listTotal == 0 && this.manageList.length == 0)) {
            this.clearSearch();
          }
        }
        if (this.listAction) {
          localStorage.setItem('searchVal', this.searchVal);
        }
        if(this.access == 'identiscan') {
          let search = searchValue.toLowerCase();
          this.listItems.forEach((res)=>{
            let name = res.name.toLowerCase();
            let searchChars = name.includes(search);
            if(!searchChars) {
              res.displayFlag = false;
            } else {
              res.displayFlag = true;
            }
          })
        }
        if(this.access == 'roQtyAvailable') {
          let search = searchValue?.toLowerCase() || '';
           if(searchValue == '' || searchValue == null) {
            this.getROQtyList(-1)
           } else {
             this.listItems.forEach((res)=>{
               let name = res?.name?.toLowerCase() || '';
               let searchChars = name.includes(search);
   
                 if(!searchChars) {
                   res.displayFlag = false;
                 } else {
                   res.displayFlag = true;
                 }
             })
           }

          console.log("searchValue filtered: ", searchValue, this.listItems);
          
        }
      }
    }
  }

  // Submit Search
  submitSearch() {
    let i = 0;
    this.offset = 0;
    this.itemLength = 0;
    this.scrollInit = 0;
    this.lastScrollTop = 0;
    this.scrollCallback = true;
    this.manageList = [];
    this.listItems = this.manageList;
    this.empty = false;

    switch (this.access) {
      case 'GTSList':
        this.getGTSList(i);
        break;
      case 'customerList':
      case 'customerListRO':
        this.getShopList(i);
        break;
      case 'roPartNumber':
        this.getROPartList(i);
        break;      
      case 'roQtyAvailable':
        // this.getROQtyList(i);
        // this.filterRoQtyList();
        break;      
      case 'MSOLocationList':
        this.getLocationList(i);
        break;      
      case 'Tags':
      case 'New Thread Tags':
        this.getTagInfo(i);
        break;
      case 'Error Codes':
      case 'New Thread Error Codes':
        this.getErrorCodes(i);
        break;
      case 'LookupDataPM':
        this.getLookUpInfo(i);
        break;
      case 'newthread':
      case 'newAdasSystem':
      case 'New Parts':
      case 'techinfo':
      case 'mediaUpload':
        let field = this.inputData.field;
        if(field == 'category'){
          this.getCatgInfo(i);
        }
        else if(field == 'zone'){
          this.getZoneInfo(i);
        }
        else if(field == 'keyword'){
          this.getKeywordInfo(i);
        }
        else if(field == 'cba-manufacturer' || field == 'softwareUpdate' || field == 'programNewModule'){
          this.getDiagnosticInfo(i);
        }
        else if(field == 'folders'){
          this.getFolderInfo(i);
        }
        else{
          this.getData(i);
        }
        break;
      case 'InternalStatusAccess':
      case 'adasCalproReport':  
        this.getData(i);
        break;
      case 'jobListRO':
        this.getJobsData(i);
        break;
    }
  }

  // Clear Search
  clearSearch(action = '') {
    if(this.filterCall && this.access == 'New Thread Error Codes') {
      this.empty = false;
      this.searchVal = '';
      this.listItems.forEach(item => {
        item.displayFlag = true;
      });
      return false;
    }
    let i = 0;
    this.offset = 0;
    this.itemLength = 0;
    this.scrollInit = 0;
    this.lastScrollTop = 0;
    this.scrollCallback = true;
    this.manageList = [];
    if(this.access != 'identiscan') {
      this.listItems = this.manageList;
    } else {
      this.listItems.forEach((res)=>{
        res.displayFlag = true;
      })
    }
    let newFlag = (action == 'new' && this.empty) ? true : false;
    this.empty = false;
    console.log(action, newFlag)
    this.searchVal = '';
    this.searchValOld = '';
    this.searchTick = false;
    this.searchClose = this.searchTick;
    this.actionFlag = false;
    if (action == '') {
      localStorage.removeItem('searchVal');
    }
    let accessIndex = (this.listTotal != this.manageList.length) ? -1 : 0;
    accessIndex = (action == 'new' && newFlag) ? -3 : accessIndex;
    switch (this.access) {
      case 'GTSList':
        this.getGTSList(accessIndex);
        break;
      case 'customerList':
      case 'customerListRO':
        this.searchVal = '';
        this.searchForm.value.searchKey = this.searchVal;
        this.getShopList(accessIndex);
        break;
      case 'roPartNumber':
        this.searchVal = '';
        this.searchForm.value.searchKey = this.searchVal;
        this.getROPartList(accessIndex);
        break;     
      case 'roQtyAvailable':
        this.searchVal = '';
        this.searchForm.value.searchKey = this.searchVal;
        this.getROQtyList(accessIndex);
        break;     
      case 'Tags':
      case 'New Thread Tags':
        this.getTagInfo(accessIndex);
        break;
      case 'Error Codes':
      case 'New Thread Error Codes':
        this.getErrorCodes(accessIndex);
        break;
      case 'newthread':
      case 'newAdasSystem':
      case 'New Parts':
      case 'techinfo':
      case 'mediaUpload':
        let field = this.inputData.field;
        if(field == 'category'){
          this.getCatgInfo(accessIndex);
        }
        else if(field == 'zone'){
          this.getZoneInfo(accessIndex);
        }
        else if(field == 'keyword'){
          this.getKeywordInfo(accessIndex);
        }
        else if(field == 'cba-manufacturer' || field == 'softwareUpdate' || field == 'programNewModule'){
          this.getDiagnosticInfo(accessIndex);
        }
        else if(field == 'folders'){
          this.getFolderInfo(accessIndex);
        }
        else{
          this.getData(accessIndex);
        }
        break;
      case 'InternalStatusAccess':
      case 'adasCalproReport':
        this.getData(accessIndex);
        break;
      case 'jobListRO':
        this.getJobsData(accessIndex);
        break;
      case 'MSOLocationList':
        this.getLocationList(accessIndex);
        break;
    }
  }

  // Disable Field
  disableSelection() {
    return this.actionFlag;
  }

  // Get Data
  getData(index) {
    // console.clear()
    console.log(index, this.inputData, this.apiData.data)
    if (this.access == 'gtsDynamicOptions') {
      this.listItems = JSON.parse(JSON.stringify(this.apiData.data.actionOptions));
      // this.filteredTags = this.inputData.filteredItems;
      this.filteredLists = this.inputData.filteredLists;

      for (let m in this.listItems) {
        let i: any = m;
        this.listItems[m]['checkFlag'] = false;
      }

      this.listItems.forEach((items) => {
        items.displayFlag = true;
        items.action = '';
        items.priority = '';

        let match = items.name.match(/#P\d+/);
        if (match) {
          items.priority = match[0]; // Save to new property
          items.name = items.name.replace(match[0], "").trim(); // Remove from name
          items.name = items?.statusValue == 1 ? items.name +' - '+ 'Done' : items.name;
        }
      });

      this.filteredLists.forEach((outer,index)=>{
        this.listItems.forEach((inner,index)=>{
          if( inner.id == outer.id) {
            this.listItems[index].checkFlag = true;
            this.selectionList.push({...this.listItems[index]})
          }
        })
      });

      this.headerCheck = (this.selectionList.length == 0) ? 'unchecked' : this.selectionList.length == this.listItems.length ? 'all' : 'checked';
      this.headercheckDisplay = (this.selectionList.length == 0) ? 'checkbox-hide' : 'checkbox-show';

      this.loading = false;
      return
    }
    if(this.filterPageAccess == '1'){
      //this.loading = true;
      this.scrollTop = 0;
      this.lastScrollTop = this.scrollTop;
      this.manageList = []
      let complaintCategorySIB = [];
      if(this.inputData.field == "complaintCategory" ) {
        let mlArr1 = [];
        complaintCategorySIB = localStorage.getItem("complaintCategorySIB") != null ? JSON.parse(localStorage.getItem("complaintCategorySIB")) : [];
        if(complaintCategorySIB && complaintCategorySIB.length>0){
          complaintCategorySIB.forEach(item => {
            mlArr1.push({
              id: item.value,
              name: item.value,
            });
          })
        }
        this.manageList = mlArr1;
      }
      let symptomSIB = [];
      if(this.inputData.field == "Symptoms" ) {
        let mlArr2 = [];
        symptomSIB = localStorage.getItem("symptomSIB") != null ? JSON.parse(localStorage.getItem("symptomSIB")) : [];
        if(symptomSIB && symptomSIB.length>0){
          symptomSIB.forEach(item => {
            mlArr2.push({
              id: item.value,
              name: item.value,
            });
          })
        }
        this.manageList = mlArr2;
      }

        let itemListLen = this.manageList.length;
        console.log(this.manageList);
        console.log(itemListLen)
        this.itemLength = itemListLen;
        this.empty = (itemListLen < 1) ? true : false;
        if (this.empty) {
          this.successMsg = "No items found";
        } else {
          this.scrollCallback = true;
          this.scrollInit = 1;
          this.itemTotal = this.manageList.length;

        setTimeout(() => {
          this.loading = false;
          this.initList('init', this.manageList);
        }, 100);

        }

    }
    else{
    //this.listAction = false;
    this.loading = true;
    this.scrollTop = 0;
    this.lastScrollTop = this.scrollTop;

    let apiData = this.apiData;
    let apiUrl = this.inputData.apiUrl;
    let field = this.inputData.field;
    let body: HttpParams = new HttpParams();
    if (field != "PartType") {
      apiData['offset'] = this.offset;
      apiData['limit'] = this.limit;
      apiData['searchKey'] = this.searchVal;
      if(field=="InternalStatusField"){
        delete apiData['searchKey'];
        apiData['searchText'] = this.searchVal;
      }
    }
    let newApiReq: any = false;

    if(this.inputData.field == 'serialNo'){
      apiData['dealerCode'] = localStorage.getItem('kia-serial-dealerCode');
    }
    Object.keys(apiData).forEach(key => {
      let value = apiData[key];
      console.log(key,value);
      if(key == 'workstreams' && Array.isArray(value)){
        body = body.append(key, JSON.stringify(value));
      } else {
        body = body.append(key, value);
      }
      if (key == 'commonApiValue') {
        newApiReq = true;
      }
    });


      this.commonApi.apiCall(apiUrl, body).subscribe((response) => {
        console.log(response);
        let resultData;
        let item: any = [];
        this.manageList = (index >= -1) ? [] : this.manageList;
        let initText = (index >= 0) ? 'init' : 'get';
        switch (field) {
          case 'adasSystem':
            resultData = response.data.items;
            resultData.forEach(aitem => {
              this.manageList.push(aitem);
            });
            break;
          case 'model':
          case 'PartModel':
            resultData = response.modelData;
            for (let res in resultData) {
              resultData[res]['id'] = resultData[res]['uId'];
              this.manageList.push(resultData[res]);
            }
            break;
          case 'vinNo':
          case 'vinNoScanTool':
            resultData = response.vinDetails;
            for (let res in resultData) {
              let vinRes = resultData[res][0];
              if(vinRes) {
                this.manageList.push(resultData[res][0]);
              }
            }
            break;
          case 'parts':
          case 'Media Manager':
            resultData = response.items;
            for (let res in resultData) {
              this.manageList.push(resultData[res]);
            }
            break;
          case 'prodCode':
            resultData = response.items;
            let total = response.total;
            item = [];
            if (total > 0) {
              for (let list of resultData) {
                let name = list.name.replace('###', '-')
                item.push({
                  id: list.id,
                  name: name,
                  prodType: list.productType,
                  model: list.modelName
                });
              }
              console.log(item)
              for (let res in item) {
                this.manageList.push(item[res]);
              }
            } else {
              this.manageList = item;
            }
            break;
          case 'countryList':
            resultData = response.loopUpData;
            for (let res in resultData) {
              this.manageList.push(resultData[res]);
            }
            break;
          case 'PartType':
          case 'PartAssembly':
          case 'PartSystem':
            resultData = response.attributesInfo;
            resultData = (field == 'PartType') ? resultData.PartType : (field == 'PartAssembly') ? resultData.partAssembly : resultData.partSystem;
            for (let res in resultData) {
              this.manageList.push(resultData[res]);
            }
            break;
            case 'InternalStatusField':
              resultData = response.items;
              for (let res in resultData) {
                if(resultData[res].id==this.inputData.selectedThreadStatusId){
                  resultData[res]['checkedFlag']=true;
                }else{
                  resultData[res]['checkedFlag']=false;
                }
                // Add editAccess to enable edit/delete buttons
                resultData[res]['editAccess'] = 1;
                resultData[res]['displayFlag'] = true;
                resultData[res]['action'] = '';
                resultData[res]['itemExists'] = false;
                this.manageList.push(resultData[res]);
              }
              break;
          default:
            if(field == "category"){
              resultData = response.category;
              newApiReq = true;
            } else if(field == "make"){
              resultData = response.modelData;
              newApiReq = true;
            } else if(field == "team"){
              resultData = response.teamList;
              newApiReq = true;
            } else if(field == "keyword" || field == "threadcategory" || field == 'Category' || field == 'zone' || field == 'Emissions' || field == "workstream" || field == "manufacturer"){
              resultData = response.items;
              newApiReq = true;
            } else if( field == "threadTitle") {
              resultData = response.items;
              newApiReq = true;
            }
            else if( field == "selectDealer") {
              newApiReq = true;
              let resultItems = [];
              response.items.forEach(uitem => {
                resultItems.push({
                  id: uitem.dealerCode,
                  name: uitem.dealerCode+", "+uitem.dealerName
                });
              });
              resultData = resultItems;
            }
            else if(field == "selectUserAtDealerShip") {
              this.selectUserAtDealerShip = true;
              newApiReq = true;
              let resultItems = [];
              response.items.forEach(uitem => {
                resultItems.push({
                  id: uitem.userId,
                  name: uitem.firstName+", "+uitem.lastName+", "+uitem.email+", "+uitem.phoneNo+", "+uitem.jobTitle
                });
              });
              resultData = resultItems;
            }
            else if(field == "serialNo") {
              newApiReq = true;
              let resultItems = [];
              console.log(response.items);
              response.items.forEach(uitem => {
                resultItems.push({
                  id: uitem.acxserialnumber && uitem.acxserialnumber != '' && uitem.acxserialnumber != undefined ? uitem.acxserialnumber :'' ,
                  name: uitem.acxserialnumber && uitem.acxserialnumber != '' && uitem.acxserialnumber != undefined ? uitem.acxserialnumber :'' ,
                  created_on: uitem.created_on && uitem.created_on != '' && uitem.created_on != undefined ? uitem.created_on :'' ,
                  deliverableversion: uitem.deliverableversion && uitem.deliverableversion != '' && uitem.deliverableversion != undefined ? uitem.deliverableversion :'' ,
                  make: uitem.make && uitem.make != '' && uitem.make != undefined ? uitem.make :'' ,
                  model: uitem.model && uitem.model != '' && uitem.model != undefined ? uitem.model :'' ,
                  editAccess: uitem.editAccess && uitem.editAccess != '' && uitem.editAccess != undefined ? uitem.editAccess : '0' ,
                });
              });
              resultData = resultItems;
            }
            else if(field == "forUserList") {
              newApiReq = true;
              let resultItems = [];
              response.dataInfo.forEach(uitem => {
                resultItems.push({
                  id: uitem.userId,
                  name: uitem.firstLastName
                });
              });
              resultData = resultItems;
            } else if(field == "other-payment") {
              resultData = response.items;
              newApiReq = true;
            } else if(field == "usetype-businessname") {
              resultData = response.items;
              newApiReq = true;
            } else if(field == "helpdata") {
              resultData = response.items;
              newApiReq = true;
            } else if(field == "dekra-shopList") {
              resultData = response.items;
              newApiReq = true;
            } else{
              resultData = (newApiReq) ? response.items : response.data;
            }
            if(field == 'additional'){
                resultData = response;
                resultData.total = response.items.length;
            }
            let itemTotal = (newApiReq) ? response.total : resultData.total;
            if(field == "team"){
              itemTotal = resultData.length;
            }
            console.log(resultData)
            console.log(itemTotal)
            let resItems = (newApiReq) ? resultData : resultData.items;
            item = [];
            if (itemTotal > 0) {
              for (let list of resItems) {
                if (this.access == 'techinfo') {
                  item.push({
                    id: list.id,
                    name: `${list.name} - ${list.phoneNo}`,
                    phoneNo: list.phoneNo
                  });
                }
                else if (this.access == 'newthread' && field == 'escalationLookup') {
                  item.push({
                    id: list.id,
                    name: list.name,
                    productModelsCount: list.productModelsCount
                  });
                }
                else if (this.access == 'newthread' && field == 'category') {
                  item.push({
                    id: list.id,
                    name: list.categoryName,
                  });
                }
                else if (this.access == 'newthread' && field == 'make') {
                  item.push({
                    id: list.id,
                    name: list.makeName,
                  });
                }
                else if (this.access == 'newthread' && field == 'serialNo') {
                  item.push({
                    id: list.id,
                    name: list.name,
                    created_on: list.created_on,
                    deliverableversion: list.deliverableversion,
                    make: list.make,
                    model: list.model,
                    editAccess: list.editAccess,
                  });
                }
                else if(this.access == 'adasCalproReport') {
                  let listId = (this.access == 'newthread' && field == 'Category') ? list.id.toString() : list.id;
                  let createdOn = list.createdDate;
                  createdOn = moment.utc(createdOn).toDate();
                  let createdDate = moment(createdOn).local().format('MMM DD, YYYY h:mm A');
                  item.push({
                    id: listId,
                    name: list.name,
                    date: createdDate,
                    make: list.make,
                    model: list.model,
                    year: list.year,
                    vinInfo: list.vinInfo
                  });
                }
                else {
                  let listId = (this.access == 'newthread' && field == 'Category') ? list.id.toString() : list.id;
                  item.push({
                    id: listId,
                    name: list.name
                  });
                }

              }
              for (let res in item) {
                this.manageList.push(item[res]);
              }
            } else {
              this.manageList = item;
            }
            break;
        }
        

        if (index <= 0) {
          let itemListLen = this.manageList.length;
          console.log(this.manageList);
          console.log(itemListLen)
          this.itemLength = itemListLen;
          this.empty = (itemListLen < 1) ? true : false;
          if (this.empty) {
            this.successMsg = response.result;
          } else {
            this.scrollCallback = true;
            this.scrollInit = 1;
            this.itemTotal = (field == 'adasCalproReport') ? response.data.total : response.total;
            if(field == "manufacturer"){
              this.itemLength = this.manageList.length;
            } else if(field == 'adasCalproReport') {
              this.itemLength = this.manageList.length;
            } else {
              if(field == "InternalStatusField"){
                this.itemLength = this.manageList.length;
              }else{
                this.itemLength += resultData.length;
              }
            }

            console.log(this.itemTotal)
            console.log(this.itemLength)
            this.offset += this.limit;
          }
        }

        setTimeout(() => {
          this.initList(initText, this.manageList);
        }, 100);

        if (this.searchNew) {
          this.manageTag('new', 0);
        }

      });
    }
  }

  // Check Item Exists
  checkItemExists(index, value) {
    let apiData = {
      apiKey: this.apiData['apiKey'],
      userId: this.apiData['userId'],
      domainId: this.apiData['domainId'],
      countryId: this.apiData['countryId'],
      isValidate: 1
    };
    switch (this.inputData.field) {
      case 'other-payment':
        apiData['name'] = value;
      break;
      case 'usetype-businessname':
        apiData['name'] = value;
        apiData['userType'] = this.apiData["userType"];
      break;
      case 'category':
        apiData['workstreams'] = this.apiData["workstreamsList"];
        apiData['categoryName'] = value;
        break;
      case 'zone':
        apiData['zone'] = value;
        break;
      case 'keyword':
        apiData['tagName'] = value;
        apiData['workstreams'] = this.apiData["groupId"];
        break;
      case 'cba-manufacturer':
      case 'softwareUpdate':
      case 'programNewModule':
        apiData['name'] = value;
        apiData['type'] = this.inputData.field;
        break;
      case 'other-payment':
        apiData['name'] = value;
      break;
      case 'usetype-businessname':
        apiData['name'] = value;
        apiData['userType'] = this.apiData["userType"];
      break;
      case 'make':
        apiData['makeName'] = value;
        break;
      case 'folders':
        apiData['workstreams'] = this.apiData["workstreamsList"];
        apiData['folderName'] = value;
        break;
      case 'model':
      case 'PartModel':
        apiData['ModelName'] = value;
        break;
      case 'colour':
        apiData['colorValueId'] = this.listItems[index].id;
        apiData['colorValueName'] = value;
        apiData['workstreamList'] = [];
        break;
      case 'info-1':
      case 'info-2':
      case 'info-3':
      case 'info-4':
      case 'info-5':
      case 'info-6':
      case 'info-7':
        apiData['infoId'] = this.listItems[index].id;
        apiData['infoName'] = value;
        apiData['workstreamList'] = [];
        break;
      case 'adasSystem':
        apiData['action'] = 'new';
        apiData['name'] = value;
        break;
      case 'additional':
        apiData = this.inputData.apiData;
        apiData['name'] = value;
        break;
      case 'jobListRO':
        apiData = this.inputData.apiData;
        apiData['name'] = value;
        apiData['action'] = 'new';
        break;  
      default:
        let query = this.inputData.actionQueryValues;
        console.log(query)
        if (query != '') {
          let queryVal = JSON.parse(query);
          if(this.listItems[index].id>0){
            apiData[queryVal[0]] = this.listItems[index].id;
          }
          apiData[queryVal[1]] = value;
          queryVal.forEach(q => {
            switch (q) {
              case 'commonApiValue':
                console.log(this.commonApiValue)
                apiData[q] = this.commonApiValue;
                break;
            }
          });
        }
        break;
    }

    if (this.listFlag) {
      this.listFlag.unsubscribe();
      this.manageExist(index, apiData);
    } else {
      this.manageExist(index, apiData);
    }
  }

  updatesolr(type,id){
    const apiData = new FormData();
    apiData.append('apiKey', this.apiData['apiKey']);
    apiData.append('domainId', this.apiData['domainId']);
    apiData.append('userId', this.apiData['userId']);
    if(type == 'edit'){
      apiData.append('dataId', id);
      apiData.append('action', 'folderUpdate');
    }
    else{
      apiData.append('action', 'create');
      apiData.append('threadId', id);
    }
    apiData.append('actionType', '2');
    apiData.append('platform', '3');
    this.baseSerivce.postFormData("forum", "UpdateDatetoSolr", apiData).subscribe((response: any) => { })
  }
  updateCatgsolr(type,id){
    const apiData = new FormData();
    apiData.append('apiKey', this.apiData['apiKey']);
    apiData.append('domainId', this.apiData['domainId']);
    apiData.append('userId', this.apiData['userId']);
    if(type == 'edit'){
      apiData.append('dataId', id);
      apiData.append('action', 'categoryUpdate');
    }
    else{
      apiData.append('action', 'create');
      apiData.append('threadId', id);
    }
    if(this.pageType == 'parts'){
      apiData.append('actionType', '4');
    }
    else{
      apiData.append('actionType', '6');
    }
    apiData.append('platform', '3');
    this.baseSerivce.postFormData("forum", "UpdateDatetoSolr", apiData).subscribe((response: any) => { })
  }

  setupFilteredItems(id) {
    if (this.selection == 'multiple') {
      switch (this.access) {
        case 'Tags':
        case 'New Thread Tags':
        case 'newthread':
        case 'newAdasSystem':
          if (this.filteredTags.length > 0) {
            let rmIndex = this.filteredTags.findIndex(option => option == id);
            if (rmIndex >= 0) {
              this.filteredTags.splice(rmIndex, 1);
              this.filteredLists.splice(rmIndex, 1);
            }
          }
          console.log(this.filteredModelsCount.length);
          if (this.filteredModelsCount.length > 0) {
            let rmIndex1 = this.filteredTags.findIndex(option => option == id);
            if (rmIndex1 >= 0) {
              this.filteredModelsCount.splice(rmIndex1, 1);
            }
          }
          if (this.filteredROPartDesc.length > 0) {
            let rmIndex1 = this.filteredTags.findIndex(option => option == id);
            if (rmIndex1 >= 0) {
              this.filteredROPartDesc.splice(rmIndex1, 1);
            }
          }
          break;
        case 'Error Codes':
        case 'New Thread Error Codes':
          if (this.filteredErrorCodes.length > 0) {
            let rmIndex = this.filteredErrorCodes.findIndex(option => option == id);
            if (rmIndex >= 0) {
              this.filteredErrorCodes.splice(rmIndex, 1);
              this.filteredLists.splice(rmIndex, 1);
            }
          }
          break;
      }
    }
  }

  // remove option
  removeConfirm(index,id,name){
    if(this.access == 'jobListRO'){
      this.deleteJob(id);
    } else {
      this.bodyElem.classList.add("auth-open-remove-popup");
      const modalRef = this.modalService.open(ConfirmationComponent, this.modalConfig);
      modalRef.componentInstance.access = 'ppfrconfirmation';
      modalRef.componentInstance.title = '';
      modalRef.componentInstance.confirmAction.subscribe((receivedService) => {
        modalRef.dismiss('Cross click');
        console.log(receivedService);
        if(receivedService){
          this.deleteOption(index,id,name);
        }
      });
    }
  }

  deleteOption(index,id,name){
    if(this.inputData.field == 'folders'){
      let formData = new FormData();
      formData.append("apiKey", this.apiData["apiKey"]);
      formData.append("domainId", this.apiData["domainId"]);
      formData.append("countryId", this.apiData["countryId"]);
      formData.append("userId", this.apiData["userId"]);
      formData.append("folderId", id);
      formData.append("folderName", name);
      formData.append("deleteStatus", "2");

      this.authenticationService.apiSaveDocumentFolder(formData).subscribe((response) => {
        if(response.status=='Success'){
          localStorage.setItem('documentRefresh','1');
          this.listItems.splice(index, 1);
          let rmIndex = this.selectionList.findIndex(option => option.id == id);
          this.selectionList.splice(rmIndex, 1);
          setTimeout(() => {
            this.headerCheck = (this.selectionList.length == 0) ? 'unchecked' : 'checked';
            if (this.activeListshow == true) {
              this.DisableText = 'Disable';
            } else {
              this.DisableText = 'Enable';
            }
            this.headercheckDisplay = (this.selectionList.length == 0) ? 'checkbox-hide' : this.headercheckDisplay;
          }, 100);
        }
        else{
          // error
        }
      });
    }
    else if(this.inputData.field == 'keyword'){
      return false;
    }
    else{
      let formData = new FormData();
      formData.append("apiKey", this.apiData["apiKey"]);
      formData.append("domainId", this.apiData["domainId"]);
      formData.append("countryId", this.apiData["countryId"]);
      formData.append("userId", this.apiData["userId"]);
      if(this.inputData.field == 'serialNo'){
        formData.append("id", id);
        formData.append("dealerCode", localStorage.getItem('kia-serial-dealerCode'));
      }
      else{
        formData.append("tagId", id);
      }
      let callableURL = this.commonApi.apiDeleteTag(formData);
      if (this.pageType == 'market-place') {
        callableURL = this.commonApi.deleteTagMarketPlace(id, this.domainId);
      }
      if(this.inputData.field == 'serialNo'){
        callableURL = this.commonApi.apiDeleteSNo(formData);
      }
      if(this.pageType == 'video-library-category'){
        callableURL = this.commonApi.deleteVideoCategoryDelete(id, this.domainId);
      }
      if(this.pageType == 'video-library-tags'){
        callableURL = this.commonApi.apiDeleteVideoTagDelete(id, this.domainId);
      }
      callableURL.subscribe((response) => {
        if(response.status=='Success'){
          this.listItems.splice(index, 1);
        }
        else{
          // error
        }
      });
    }


  }

  inputFocus() {
    setTimeout(() => {
      this.setFocusToInput();
    }, 400);
  }

  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    this.close();
  }

  @HostListener('focusout', ['$event']) public onListenerTriggered(event: any): void {
    //this.setFocusToInput();
  }

  setFocusToInput() {
    this.focusInput.nativeElement.focus();
  }

    // Create New Options
    serviceAction(action, field, item:any = '') {
      console.log(action, field);
      this.submitClicked = false;
      this.formProcessing = false;
      this.shopExist = false;
      let formTimeout = (action == 'new') ? 0 : 500;
      this.bodyElem.classList.add(this.bodyClass3);
      switch (field) {
        case 'shop':
          console.log(item);
          let shopText = 'Customer';
          this.actionTitle = (action == 'new') ? `${ManageTitle.actionNew} ${shopText}` : `${ManageTitle.actionEdit} ${shopText}`;
          let sitem = (action == 'new') ? '' : item;
          //this.emailDisable = (sitem != '' && sitem.isUser == 1) ? true : false;
          this.emailDisable = (sitem != '') ? true : false;
          this.createForm('serviceShop', sitem);
          setTimeout(() => {
            this.custActionFlag = true;
            this.emptyPhoneData();
            this.actionForm = field;
          }, formTimeout);
          break;

      }
    }

  createForm(action, item:any = '', date:any = '') {
    switch (action) {

      case 'serviceShop':
        let cfirstName = (item != '') ? 'fname' : '';
        let clastName = (item != '') ? 'lname' : '';
        let shopId = (item == '') ? 0 : item.id;
        let shopName = (item == '') ? '' :item.name;
        let addressLine1 = (item == '') ? '' : item.addressLine1;
        let addressLine2 = (item == '') ? '' : item.addressLine2;
        let city = (item == '') ? '' : item.city;
        let state = (item == '') ? '' : item.state;
        let zip = (item == '') ? '' : item.zip;
        let customerId = (item == '') ? '' : item.customerId;
        let scountryName = (item == '') ? '' : item.countryName;
        let scountryCode = (item == '') ? '' : item.countryCode;
        let sdialCode = (item == '') ? '' : item.dialCode;
        let phone = (item == '') ? '' : item.phone;
        let cemail = (item == '') ? '' : item.email;
        this.icountryName = (item == '' || scountryName) ? this.icountryName : scountryName;
        this.icountryCode = (item == '' || scountryCode == null) ? this.icountryCode : scountryCode;
        this.idialCode = (item == '' || sdialCode == '') ? this.idialCode : sdialCode;
        this.iphoneNumber = (item == '' || phone == null) ? this.iphoneNumber : phone;
        this.phoneNumberData = {
          countryCode: this.icountryCode,
          phoneNumber: this.iphoneNumber,
          country: this.icountryName,
          dialCode: this.idialCode,
          access: 'phone'
        }
        this.serviceShopForm = this.formBuilder.group({
          shopId: [shopId],
          shopName: [shopName, [Validators.required]],
          addressLine1: [addressLine1],
          addressLine2: [addressLine2],
          city: [city],
          state: [state],
          zip: [zip],
          customerId: [customerId],
          countryName: [scountryName],
          countryCode: [scountryCode],
          dialCode: [sdialCode],
          phone: [phone],
          email: [cemail, [Validators.required, Validators.email,Validators.pattern(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]],
          firstName: [cfirstName, [Validators.required]],
          lastName: [clastName, [Validators.required]]
        });
        break;


    }
  }

  // Form Action
  formAction(action) {
    console.log(action, this.actionForm);
    switch (action) {
      case 'submit':
        this.submitClicked = true;
        this.formSubmit();
        break;

      default:
        this.formProcessing = false;
        this.formCancel();
        break;
    }
  }

      // check email validation
      checkEmailValition(){
        console.log(456)
        let emailVal = '';
        var emailError;

       switch(this.actionForm){
        case 'shop':
          emailVal = this.serviceShopForm.value.email.trim();
          emailError = this.serviceShopForm.controls.email.errors;
          break

       }

        console.log(emailVal)
        if(emailVal.length>0){
          this.emailValidationError = false;
          this.emailValidationErrorMsg = "";
          if(emailError){
            this.emailValidationError = true;
            this.emailValidationErrorMsg = "Invalid Email";
          }
        }
      }

    // Form Submit
    formSubmit() {
      const apiInfo = {
        apikey: Constant.ApiKey,
        countryId: this.apiData["countryId"],
        domainId: this.apiData["domainId"],
        userId: this.apiData["userId"],
        action: 'new',
      };
      switch (this.actionForm) {
        case 'shop':
          this.shopExist = false;
          this.serviceShopSubmit = true;
          for (const i in this.serviceShopForm.controls) {
            this.serviceShopForm.controls[i].markAsDirty();
            this.serviceShopForm.controls[i].updateValueAndValidity();
          }
          this.invalidNumber = (this.iphoneNumber.length > 0 && !this.phoneNumberValid) ? false : true;
          console.log(this.serviceShopForm.valid, this.iphoneNumber, this.phoneNumberValid, this.invalidNumber)
          let shopObj = this.serviceShopForm.value;
          if (this.serviceShopForm.valid && (!this.shopExist || !this.invalidNumber)) {
            this.formProcessing = true;
            let phoneNumber = (shopObj.countryCode == 'IN' && shopObj.phone.length > 10) ? shopObj.phone.substring(1) : shopObj.phone;
            let shopAction = (shopObj.shopId == 0) ? apiInfo.action : 'edit';
            apiInfo.action = shopAction;
            apiInfo['contentTypeId'] = ContentTypeValues.RepairOrder;
            apiInfo['shopId'] = shopObj.shopId;
            apiInfo['name'] = shopObj.shopName;
            apiInfo['customerId'] = shopObj.customerId;
            apiInfo['addressLine1'] = shopObj.addressLine1;
            apiInfo['addressLine2'] = shopObj.addressLine2;
            apiInfo['city'] = shopObj.city;
            apiInfo['state'] = shopObj.state;
            apiInfo['zip'] = shopObj.zip;
            apiInfo['countryName'] = shopObj.countryName;
            apiInfo['countryCode'] = shopObj.countryCode;
            apiInfo['dialCode'] = shopObj.dialCode;
            apiInfo['phone'] = phoneNumber;
            apiInfo['email'] = shopObj.email;
            if(shopAction == 'new') {
              apiInfo['firstName'] = shopObj.firstName;
              apiInfo['lastName'] = shopObj.lastName;
            }
            console.log(shopObj);
            //apiInfo['lat'] = "0";
            //apiInfo['lng'] = "0";

            const address = shopObj.addressLine1 + shopObj.addressLine2 + ',' + shopObj.city + ',' + shopObj.state + ',' + shopObj.zip;
            if(shopObj.addressLine1 != '' && shopObj.city != '' && shopObj.state != '' && shopObj.zip != '') {
              this.geocode(address).then(response => {
                this.formProcessing = false;
                console.log(response.geometry.location.lat());
                console.log(response.geometry.location.lng());
                let lat = response.geometry.location.lat();
                let lng = response.geometry.location.lng();
                apiInfo['lat'] = lat.toString();
                apiInfo['lng'] = lng.toString();
                this.manageShop(apiInfo);
              })
              .catch(err => {
                console.log(err);
              });
            } else {
              apiInfo['lat'] = "0";
              apiInfo['lng'] = "0";
              this.manageShop(apiInfo);
            }

            //this.manageShop(apiInfo);
          } else {
            this.formProcessing = false;
          }
        break;
      }
    }
    // Form Cancel
    formCancel() {
      this.bodyElem.classList.remove(this.bodyClass3);
      this.actionFlag = false;
      this.submitClicked = false;
      switch (this.actionForm) {
        case 'shop':
          this.shopExist = false;
          this.existError = '';
          this.serviceShopSubmit = false;
          this.serviceShopForm.reset();
          this.custActionFlag = false;
          break;
      }
    }

         // Manage Shop
  manageShop(apiData) {
    console.log(apiData);
    //return false;
    this.LandingpagewidgetsAPI.manageServiceShopAPI(apiData).subscribe((response) => {
      this.formProcessing = false;
      let error = response.error;
      if(!error) {
        this.bodyElem.classList.remove(this.bodyClass3);
        this.actionTitle = '';
        this.serviceShopSubmit = false;
        this.actionFlag = false;
        const serviceShop = response.data[0];
        console.log(serviceShop);
        let name = serviceShop.name+" (ID# "+serviceShop.id+")";
        let addressLine1 = serviceShop.addressLine1 != '' ? ", "+serviceShop.addressLine1 : '' ;
        let addressLine2 = serviceShop.addressLine2 != '' ? ", "+serviceShop.addressLine2  : '' ;
        let city = serviceShop.city != '' ? ", "+serviceShop.city : '' ;
        let state = serviceShop.state != '' ? ", "+serviceShop.state : '' ;
        let zip = serviceShop.zip != '' ? " "+serviceShop.zip : '' ;
        let email = serviceShop.email != '' ? ", "+serviceShop.email : '' ;
        let phone = serviceShop.phone != '' ? ", "+serviceShop.dialCode+" "+serviceShop.phone : '' ;
        serviceShop['showval'] = name+addressLine1+addressLine2+city+state+zip+email+phone;

        let addressLine1V2 = serviceShop.addressLine1 != '' ? serviceShop.addressLine1+", " : '' ;
        let addressLine2V2 = serviceShop.addressLine2 != '' ? serviceShop.addressLine2+", "  : '' ;
        let cityV2 = serviceShop.city != '' ? serviceShop.city+", " : '' ;
        let stateV2 = serviceShop.state != '' ? serviceShop.state+" " : '' ;
        let zipV2 = serviceShop.zip != '' ? serviceShop.zip+", " : '' ;
        let emailV2 = serviceShop.email != '' ? serviceShop.email+", " : '' ;
        let phoneV2 = serviceShop.phone != '' ? serviceShop.dialCode+" "+serviceShop.phone : '' ;
        serviceShop['showvalV2'] = "<label class='lb-head-text'>"+name+"</label><label class='lb-cont-text'>"+addressLine1V2+addressLine2V2+cityV2+stateV2+zipV2+emailV2+phoneV2+"</lable>"; ;
        console.log(serviceShop);
        if(apiData.action == 'new') {
          this.manageList.unshift({
            action : "",
            actionFlag : false,
            activeMore : false,
            checkFlag : false,
            displayFlag : true,
            itemExists : false,
            id: serviceShop.id,
            name: serviceShop['showval'],
            showName: serviceShop['showvalV2'],
            marketId: serviceShop['marketId'],
            marketName: serviceShop['marketName'],
            nameOnly: serviceShop.name,
            addressOnly: addressLine1V2+addressLine2V2+cityV2+stateV2+zipV2+emailV2+phoneV2
          });
          this.listItems = this.manageList;
          this.custActionFlag = false;
        } else {


        }
        this.shopExist = false;
        this.existError = '';
        this.actionForm = '';
        this.serviceShopForm.reset();
      } else {
        this.shopExist = true;
        this.existError = response.message;
      }
    });
  }

    // Get Geo Code
    geocode(address): Promise<any> {
      const geocoder = new google.maps.Geocoder();
      return new Promise((resolve, reject) => {
        geocoder.geocode({address: address},
          (results, status) => {
            if (status === google.maps.GeocoderStatus.OK) {
              resolve(results[0]);
            } else {
              reject(new Error(status));
            }
          }
        );
      });
    }

      // country & phone number update
  getPhoneNumberData(newValue){
    console.log(newValue)
    if(newValue != null){
      if(newValue.phoneVal != null){
        if(newValue.access == 'phone'){
          let placeHolderValueTrim = '';
          let placeHolderValueLen = 0 ;
          let placeHolderValue = newValue.placeholderVal;
          placeHolderValueTrim = placeHolderValue.replace(/[^\w]/g, "");
          placeHolderValueTrim = placeHolderValueTrim.replace(/^0+/, '');
          placeHolderValueLen = placeHolderValueTrim.length;

          let currPhValueTrim = '';
          let currPhValueLen = 0 ;
          if(newValue.phoneVal['number'] != ''){
            currPhValueTrim = newValue.phoneVal['number'].replace(/[^\w]/g, "");
            currPhValueTrim = currPhValueTrim.replace(/^0+/, '');
            currPhValueLen = currPhValueTrim.length;
          }

          if(newValue.phoneVal['number'].length>0){
            this.phonenoInputFlag = (newValue.phoneVal['number'].length>0) ? true : false;
            this.invalidNumber = (newValue.errorVal) ? true : false;

            this.phoneNumberValid = true;
            this.emptyPhoneData();
            this.iphoneNumber = newValue.phoneVal.number;

            if(currPhValueLen == placeHolderValueLen){
              this.phoneNumberValid = false;

              let getCode = newValue.phoneVal.countryCode;
              this.icountryName = countries[getCode].name;
              this.icountryCode = newValue.phoneVal.countryCode;
              this.idialCode = newValue.phoneVal.dialCode;
              this.iphoneNumber = newValue.phoneVal.number;
            }
          }
          else{
            this.phonenoInputFlag = false;
            this.iphoneNumber = '';
          }
        }
      }
      else{
        this.phonenoInputFlag = false;
        this.invalidNumber = (newValue.errorVal) ? true : false;
        this.phoneNumberValid = true;
        this.emptyPhoneData();
      }
    }
    else{
      this.phonenoInputFlag = false;
      this.invalidNumber = (newValue.errorVal) ? true : false;
      this.phoneNumberValid = true;
      this.emptyPhoneData();
    }
    setTimeout(() => {
      switch (this.actionForm) {
        case 'shop':
          this.serviceShopForm.patchValue({
            countryName: this.icountryName,
            countryCode: this.icountryCode,
            dialCode: this.idialCode,
            phone: this.iphoneNumber
          });
          break;
      }

    }, 150);
  }

  emptyPhoneData(){
    this.icountryName = '';
    this.icountryCode = '';
    this.idialCode = '';
    this.iphoneNumber = '';
    this.serviceShopForm.patchValue({
      countryName: this.icountryName,
      countryCode: this.icountryCode,
      dialCode: this.idialCode,
      phoneNumber: this.iphoneNumber
    });
    this.phoneNumberData = {
      countryCode: this.icountryCode,
      phoneNumber: this.iphoneNumber,
      country: this.icountryName,
      dialCode: this.idialCode,
      access: 'phone'
    }
  }

  getCompaniesListData(i: any) {
    const payload = new FormData();
    payload.append('domainId', this.apiData['domainId']);
    payload.append('userId', this.apiData['userId']);
    
    this.repairOrderApi.getCompaniesList(payload).subscribe(
      (res)=> {
        console.log("getCompaniesList: ", res);
        if (res?.status == 'Success') {
          this.companiesList = res?.data || [];
          if(this.companiesList && this.companiesList.length) {
            let company = this.companiesList.find((res)=> {
              return res.name === 'General';
            });
            if (company) {
              this.selectedCompanyValue = company;
            }
          };
          const generalIndex = this.companiesList.findIndex(item => item.name === "General");
          if (generalIndex > 0) {
            const [generalItem] = this.companiesList.splice(generalIndex, 1);
            this.companiesList.unshift(generalItem);
          }
          this.companiesList.splice(0, 0, { id: 0, name: 'New', logo: null });
          // setTimeout(() => {
          //   this.checkAccessLevel();
          // }, 10);
        }

        this.getJobsData(i);
      },
      (error) => {
        console.log("getCompaniesList Error: ", error);
        this.getJobsData(i);
      }
    )
  }

  getJobsData(index){
    this.apiData['offset'] = this.offset;
    this.apiData['limit'] = this.limit;
    const apiFormData = new FormData();
    apiFormData.append('apiKey', this.apiData['apiKey']);
    apiFormData.append('domainId', this.apiData['domainId']);
    apiFormData.append('countryId', this.apiData['countryId']);
    apiFormData.append('userId', this.apiData['userId']);
    apiFormData.append('teamId', this.apiData['teamId']);
    apiFormData.append('limit', this.apiData['limit']);
    apiFormData.append('offset', this.apiData['offset']);
    apiFormData.append('search', this.searchVal);
    if(this.selectedCompanyValue?.id){
      apiFormData.append('jcId', this.selectedCompanyValue?.id);
    }
    if(this.apiData['offset'] == 0) {
      //apiFormData.append('selectedItems', JSON.stringify(this.inputData.filteredItems));
    }
    this.repairOrderApi.getJOBDetailsList(apiFormData).subscribe((response) => {     
      console.log("getJOBDetailsList:", response);
      let resultData = response.data;
      
      /* if(this.apiData['offset'] == 0) {
        let selectedJobListItems = this.selectedJobSort(resultData.selectedItems, name);
        selectedJobListItems.forEach(sitem => {
          let id = sitem.id;
          let name = sitem.jobtitle;
          let jobCode = sitem.jobCode;
          let jobTitle = name;
          let jobDesc = sitem.jobdescription;
          let discount = sitem.discount;
          let discountPrice = sitem.discountPrice;
          let jobDuration = sitem.jobDuration;
          let unitPrice = sitem.unitPrice;
          let wdPrice = sitem.wdPrice;
          let action = '', actionFlag = false, activeMore = false, checkFlag = true, displayFlag = true, itemExists = false;
          this.selectedJobListItems.push({
            id,
            name,
            jobCode,
            jobTitle,
            jobDesc,
            discount,
            discountPrice,
            jobDuration,
            unitPrice,
            wdPrice,
            action, actionFlag, activeMore, checkFlag, displayFlag, itemExists
          });
          this.selectedJobList = this.selectedJobListItems;
        });
      } */
      this.manageList = (index >= -1) ? [] : this.manageList;
      this.jobItemList = (index >= -1) ? [] : this.jobItemList;
      let list = resultData.items;
      console.log(resultData, index, this.jobItemList)
      for (let res in list) {
        let id = list[res].id;
        let name = list[res].jobtitle;
        let jobCode = list[res].jobCode;
        let jobTitle = name;
        let jobDesc = list[res].jobdescription;
        let discount = list[res].discount;
        let discountPrice = list[res].discountPrice;
        let jobDuration = list[res].jobDuration;
        let unitPrice = list[res].unitPrice;
        let wdPrice = list[res].wdPrice;
        this.manageList.push({
          ...(list[res] || {}),
          id,
          name,
          jobCode,
          jobTitle,
          jobDesc,
          discount,
          discountPrice,
          jobDuration,
          unitPrice,
          wdPrice,
          editAccess: list[res].isAvailable == 1 ? 1 : 0,
        });
        this.jobItemList = this.manageList;
      }
      let initText = (index == 0) ? 'init' : 'get';

      //console.log(this.selectionList);
      if (index <= 0) {
        let itemListLen = this.manageList.length;
        this.empty = (itemListLen < 1) ? true : false;
        if (this.empty) {
          this.successMsg = response.message;
        } else {
          this.scrollCallback = true;
          this.scrollInit = 1;
          this.itemTotal = resultData.total;
          this.itemLength = itemListLen;
          this.offset += this.limit;
        }
      }

      setTimeout(() => {
        this.initList(initText, this.manageList);
      }, 50);  
    });
  }

  filterCompany(event: any) {
    console.log("filter company", event);

    this.offset = 0;
    this.getJobsData(0);
  }

  selectedJobSort(data, prop) {
    return data.sort((a, b) => (a[prop] < b[prop] ? -1 : 1) * (-1));
  }

  /* setupSelectedJobList(item) {
    console.log(item)
  } */

  ngOnDestroy() {
    document.body.classList.remove("manage-popup-new");
    document.body.classList.remove("fixvin");
    let url = this.router.url.split('/');
    if(url[1] == 'documents') {
      if(!document.body.classList.contains(this.bodyClass1)) {
        document.body.classList.add(this.bodyClass1);
      }
    }
    if(url[1] == 'identiscan') {
      if(document.body.classList.contains(this.bodyClass2)) {
        document.body.classList.remove(this.bodyClass2);
      }
    }
  }

  selectAdasReportType(type: number) {
    this.adasReportType = type;
    console.log(this.fileAttachment)
    if(this.fileAttachment && this.fileAttachment.hasOwnProperty('action')) {
      this.fileAttachment.action = '';
    }
    this.apiDataCalproAttachments['uploadedItems'] = [];
    this.apiDataCalproAttachments['attachments'] = [];
  }

  myUploader(event) {
    this.attachmentinit = true;
    this.adasAttachmentLoader = true;
    setTimeout(() => {
      this.adasAttachmentLoader = false;
    }, 2000);
    // setTimeout(() => {
    this.uploadedItems = [];
    this.attachmentsData = [];
    this.apiDataCalproAttachments['uploadedItems'] = this.uploadedItems;
    this.apiDataCalproAttachments['attachments'] = this.attachmentsData;
    const item = event.files[0];
    const fileType = event.files[0].type.split('/');
    this.fileAttachment.onUpload(event);
    this.fileName = item?.name;
    // }, 10);

  }
  
  removeFile() {
    this.fileName = '';
    this.uploadedItems = [];
    this.attachmentsData = [];
    this.apiDataCalproAttachments['uploadedItems'] = this.uploadedItems;
    this.apiDataCalproAttachments['attachments'] = this.attachmentsData;
    this.attachmentinit = false;
  }

  saveFile() {
    if(this.isSaving) return;
    this.isSaving = true;
    if (this.UseExistingFile) {
      let resOld = this.UseExistingFileData; 
      let data = {
        res: {
          mediaId: resOld?.fileId,
          fileAttachments: { fileCaption: resOld?.binaryfile?.name, filePath: '' },
        }
      }
      this.uploadComplete(data);
    } else {
      this.fileAttachment.action = 'uploading';
      // this.apiDataCalproAttachments['uploadedItems'] = this.uploadedItems;
      // this.apiDataCalproAttachments['attachments'] = this.attachmentsData;
      this.fileAttachment.ngOnInit();
    }
  }

  attachments(items) {
    console.log(items);
    
    if (items?.items && items?.items.length) {
      if (items?.items[0]?.name) {
        this.uploadedItems = items?.items;
        this.attachmentsData = items?.attachments;
        this.apiDataCalproAttachments['uploadedItems'] = this.uploadedItems;
        this.apiDataCalproAttachments['attachments'] = this.attachmentsData;

        if (items?.action == 'upload' && this.uploadedItems[0]?.fileName) {
          if (this.fileName && (this.uploadedItems && this.uploadedItems.length > 0)) {
            this.fileName = this.uploadedItems[0]?.fileName + '.' + this.uploadedItems[0]?.fileExtension;
          }
        }
        if((this.uploadedItems[0] || {}).hasOwnProperty('existIndex')) {
          // this.saveFile();
        }
      } else {
        /* use existing name */
          this.UseExistingFile = true;
          this.UseExistingFileData = items?.attachments[0];
          // this.saveFile();

          // items?.attachments[0]?.fileId
          // items?.attachments[0]?.binaryfile?.fileCaption
      }
    }

  }

  uploadComplete(event: any) {
    this.adasAttachmentLoader = true;
    console.log(event);
    console.log(this.apiData);
    let attachmentRes = event?.res;

    const apiFormData = new FormData();
    apiFormData.append("apiKey", this.apiData?.apiKey);
    apiFormData.append("domainId", this.apiData?.domainId);
    apiFormData.append("userId", this.apiData?.userId);
    apiFormData.append("roId", this.apiDataCalproAttachments?.dataId);
    apiFormData.append("mediaId", attachmentRes?.mediaId);
    apiFormData.append("reportLink", attachmentRes?.fileAttachments?.filePath || '');
    apiFormData.append("reportData", '');
    apiFormData.append("fileName", attachmentRes?.fileAttachments?.fileCaption || '');
    apiFormData.append("action", 'new');

    this.repairOrderApi.manageAdasThirdParty(apiFormData).subscribe(async (res)=> {
      if (res?.status == 'Success') {
        let fileUrl = res?.data?.reportLinkEncoded;
        const response = await fetch(fileUrl);
        const blob = await response.blob();

        const fileName = res?.data?.fileName;
        const file = new File([blob], fileName, { type: blob.type });

        const apiFormData2 = new FormData();
        apiFormData2.append('file', file);
        
        this.repairOrderApi.chatbotSubmitAdasReport(apiFormData2).subscribe((res2)=> {
          const apiFormData3 = new FormData();
          apiFormData3.append("apiKey", this.apiData?.apiKey);
          apiFormData3.append("domainId", this.apiData?.domainId);
          apiFormData3.append("userId", this.apiData?.userId);
          apiFormData3.append("roId", this.apiDataCalproAttachments?.dataId);
          apiFormData3.append("id", res?.data?.id);
          apiFormData3.append("jobId", res2.job_id);
          apiFormData3.append("action", 'jobId');

          this.repairOrderApi.manageAdasThirdParty(apiFormData3).subscribe(async (res3)=> {
            let returnData = {...res.data, jobId: res2.job_id};
            this.thirdPartyReport.emit(returnData);
            this.close();
            this.adasAttachmentLoader = false;
          });
        });
      }
    });
  }
}
